angular.module("ainapp")
    .service('LanguageService', ['$q', '$window', '$http', "app.config", "localStorageService",
        function ($q, $window, $http, config, localStorageService) {
            //            var tokenInfo;
            //
            //            this.init = function () {
            //                tokenInfo = this.getTokenInfo();
            //            };


            this.getLanguageData = function (data) {

                if (data == "AR") {

                    var languageData = {
                        Dashboard: "اللوحة الرئيسية",
                        Shortcuts: "اختصارات",
                        Masters: "الاساسيات",
                        Purchase: "المشتريات",
                        Sales: "المبيعات",
                        Cost: "يكلف",
                        BasicVouchers: "السندات الاساسية",
                        PaymentVouchers: "سندات الدفع",
                        ReceiptVouchers: "سندات القبض",
                        PDCManagement: "ادارة الشيكات تحت التحصيل",
                        Stocks: "المخزون",
                        Reports: "التقارير",
                        EASYBOOKACCOUNTING: "ايزيبوك للمحاسبة",
                        Notifications: "الإشعارات",
                        Support: "الدعم الفني",
                        Admin: "مدير النظام",
                        Suppliers: "الموردين",
                        Customers: "الزبائن",
                        Purchase: "المشتريات",
                        Income: "الدخل",
                        Expense: "المصروف",
                        NetProfit: "صافي الربح",
                        January: "يناير",
                        MonthlySales: "المبيعات الشهرية",
                        CostCenterExpense: "مصاريف مركز التكلفة",
                        CostCenter: "مركز التكلفة",
                        ExpenseCurrentMonth: "مصاريف الشهر الحالي",
                        CostCenterExpenseSummary: "ملخص مصاريف مركز التكلفة",
                        Country: "الدولة",
                        City: "المدينة",
                        Unit: "الوحدة",
                        VAT: "ضريبة القيمة المضافة",
                        Employees: "الموظفين",
                        Nature: "طبيعة",
                        AccountTypes: "انواع الحسابات",
                        AddAccountTypes: "إضافة أنواع الحسابات",
                        ChartofAccounts: "شجرة الحسابات",
                        CostCenters: "مراكز التكلفة ",
                        Products: "المنتجات",
                        Services: "الخدمات",
                        Assets: "الأصول ",
                        Countries: "الدول",
                        Name: "الإسم",
                        Refresh: "تحديث",
                        Submit: "تقديم",
                        CountryName: "اسم البلد",
                        Options: "الخيارات",
                        Delete: "حذف",
                        Edit: "تعديل",
                        Items: "المواد",
                        Cities: "المدن",
                        Country: "الدولة",
                        Refresh: "تحديث",
                        Submit: "تقديم",
                        CityName: "اسم المدينة",
                        CountryName: "اسم الدولة",
                        Options: "الخيارات",
                        Delete: "حذف",
                        Edit: "تعديل",
                        ConfirmtoProceed: "تأكيد للمتابعة",
                        Units: "الوحدات",
                        Name: "الاسم",
                        UnitName: "اسم الوحدة",
                        ConfirmDelete: "تأكيد الحذف",
                        VATS: "ضريبة القيمة المضافة",
                        Value: "القيمة",
                        Designation: "المسمى الوظيفي",
                        MobileNo: "رقم الموبايل",
                        TelNo: "رقم الهاتف",
                        Email: "البريد الالكتروني",
                        Address: "العنوان",
                        TRNo: "تي آر لا",
                        Country: "الدولة",
                        Remarks: "الملاحظات",
                        Photo: "صورة فوتوغرافية",
                        ChooseFile: "اختيار الملف",
                        NoFileChosen: "لم يتم اختيار الملف",
                        Password: "كلمة المرور ",
                        Image: "الصورة",
                        Telephone: "رقم الهاتف",
                        AccountTypes: "أنواع الحسابات",
                        SavedCostCentre: "حفظ مركز التكلفة",
                        CHARTOFACCOUNTS: "دليل الحسابات",
                        NameinArabic: "الاسم باللغة العربية ",
                        AccountType: "نوع الحساب",
                        GiveAccountName: "إعطاء اسم الحساب",
                        AddAccount: "إضافة حساب",
                        ShowTable: "عرض الجدول",
                        Group: "مجموعة",
                        UpdateAccount: "تحديث الحساب",
                        ConfirmDelete: "التأكيد للحذف",
                        Proceed: "معالجة",
                        Confirm: "تأكيد",
                        Cancel: "إلغاء",
                        code: "الرمز",
                        Saved: "حفظ",
                        EnglishName: "الاسم باللغة الانكليزية",
                        ArabicName: "الاسم باللغة العربية ",
                        ExporttoExcel: "التصدير الى اكسل",
                        ShowTree: "عرض الدليل",
                        ShowTable: "عرض الجدول",
                        CostCenters: "مراكز التكلفة",
                        Products: "المنتجات",
                        Code: "الرمز",
                        EnglishName: "الاسم باللغة الانكليزية",
                        ArabicName: "الاسم باللغة العربية ",
                        AddProductGroup: "إضافة مجموعة منتجات",
                        Services: "الخدمات",
                        AddServiceGroup: "إضافة مجموعة خدمات",
                        GiveName: "إعطاء الاسم",
                        Assets: "الاصول",
                        AddAssetGroup: "اضافة مجموعة اصول",
                        PurchaseinvoiceReturnSummary: "فاتورة المشتريات / ملخص المرتجعات",
                        Purchaseinvoice: "فاتورة المشتريات",
                        PurchaseReturn: "مرتجع المشتريات",
                        AuditPendingVouchers: "سندات المراجعة المعلقة",
                        PurchaseInvoice: "فاتورة المشتريات",
                        PurchaseOrder: "طلب الشراء",
                        GoodsReceived: "سند استلام البضاعة",
                        PurchaseQuotations: "عرض سعر المشتريات",
                        PurchaseEnquiries: "استعلامات الشراء",
                        Pending: "قيد الإجراء",
                        Purchaseflow: "مخطط المشتريات",
                        Purchaserequest: "طلب الشراء",
                        PurchaseRequest: "طلب الشراء",
                        PurchaseQuotation: "عرض سعر المشتريات",
                        PurchaseOrder: "طلب الشراء",
                        GoodsReceived: "سند استلام البضاعة",
                        Purchasereturn: "مرتجع المشتريات",
                        purchase: "المشتريات",
                        Date: "التاريخ",
                        Supplier: "المورد",
                        Remarks: "الملاحظات",
                        Enabletosendmailtosupplier: "السماح بإرسال رسالة الكترونية الى المورد",
                        EnabletosendSMStoSupplier: "السماح بإرسال رسالة نصية الى المورد",
                        Code: "الرمز",
                        ProductName: "اسم المنتج",
                        Description: "الشرح",
                        Unit: "الوحدة",
                        VAT: "ضريبة القيمة المضافة ",
                        VATType: "نوع ضريبة القيمة المضافة",
                        Quantity: "العدد",
                        Bonus: "علاوة",
                        UnitPrice: "سعر الوحدة",
                        Gross: "إجمالي",
                        Discount: "الخصم",
                        Taxable: "الخاضع للضريبة",
                        Vat: "ضريبة القيمة المضافة ",
                        RoundVat: "تقريب VAT",
                        Total: "الإجمالي",
                        Refresh: "تحديث",
                        view: "معاينة",
                        View: "معاينة",
                        Print: "طباعة",
                        save: "حفظ",
                        NetTotal: "صافي المجموع",
                        TotalTax: "اجمالي مبلغ ضريبة القيمة المضافة",
                        GrandTotal: "المبلغ الإجمالي",
                        Supplier: "المورد",
                        PleaseselectSupplier: "يرجى اختيار المورد",
                        selectSupplier: " اختر المورد",
                        PurchaseQuotation: " عرض سعر المشتريات",
                        IntroLetterDescription: " مقدمة رسالة الشرح",
                        Enabletosendmailtosupplier: " السماح بإرسال رسالة الكترونية الى المورد",
                        EnabletosendSMStoSupplier: " السماح بإرسال رسالة نصية الى المورد",
                        EndLetterDescription: " نهاية رسالة الشرح",
                        Productcode: " رمز المنتج",
                        ProductName: " اسم المنتج",
                        Description: " الشرح",
                        PurchaseOrder: " طلب الشراء",
                        date: " التاريخ",
                        EmailId: " عنوان الايميل",
                        Enabletosendmailtosupplier: " السماح بإرسال رسالة الكترونية الى المورد",
                        IntroLetterDescription: " مقدمة رسالة الشرح",
                        EnabletosendSMStoSupplier: " السماح بإرسال رسالة نصية الى المورد",
                        EndLetterDescription: " نهاية رسالة الشرح",
                        Productcode: " رمز المنتج",
                        ProductName: " اسم المنتج",
                        PleaseselectSupplier: " يرجى اختيار المورد",

                        SelectSupplier: " اختر المورد",
                        GoodsReceived: " سند  استلام بضاعة",
                        OrderNo: " رقم الطلب",
                        Enabletosendmailtosupplier: " السماح بإرسال رسالة الكترونية الى المورد",
                        EnabletosendSMStoSupplier: " السماح بإرسال رسالة نصية الى المورد",
                        Taxable: " خاضع للضريبة",
                        ViewPrint: " معاينة قبل الطباعة",
                        DebitAccount: " الحساب المدين",
                        DeliveryDate: " تاريخ التوصيل",
                        ReturnDate: " تاريخ المرتجع",
                        Dragacolumnheaderanddropitheretogroupbythatcolumn: " اسحب رأس العمود واسقطه هنا للتجميع حسب هذا العمود",
                        CreditAccount: " الحساب الدائن",
                        SalesInvoiceReturnSummary: " فاتورة المبيعات / ملخص المرتجع",
                        SalesInvoice: "فاتورة المبيعات",
                        SalesReturn: "مرتجع المبيعات",
                        SalesOrder: "سندات المراجعة المعلقة",
                        AuditPendingVouchers: "سندات المراجعة المعلقة",
                        SalesQuotations: "عروض أسعار المبيعات",
                        SalesEnquiries: "استفسارات المبيعات",
                        SalesFlow: "تدفق المبيعات",
                        SalesEnquiry: "تحقيق مبيعات",
                        salesorder: "طلب المبيعات",
                        DeliveryNote: "مذكرة تسليم",
                        Sales: "المبيعات",
                        Customer: "الزبون",
                        Enabletosendmailtocustomer: "السماح بإرسال رسالة الكترونية الى العميل",
                        Enabletosentsmstocustomer: "السماح بإرسال رسالة نصية الى العميل",
                        code: "الرمز",
                        Description: "الشرح",
                        Salesquotation: "عرض سعر المبيعات",
                        Enabletosendmailtocustomer: "السماح بإرسال رسالة الكترونية الى العميل",
                        Enabletosendsmstocustomer: "السماح بإرسال رسالة نصية الى العميل",
                        PleaseselectCustomer: "يرجى اختيار الزبون",
                        Selectcustomer: "اختيار العميل",
                        SalesOrder: "طلب المبيعات",
                        remarks: "الملاحظات",
                        FinYear: "زعنفة السنة",

                        OpeningBalance: "الرصيد الإفتتاحي",
                        account_code: "رمز الحساب",
                        account_name: "اسم الحساب",
                        debit_amount: "الحساب المدين",
                        Credit_amount: "الحساب الدائن",
                        remarks: "الملاحظات",
                        project: "المشروع",
                        CostCenter2: "مركز التكلفة 2",
                        costcenter2: "مركز التكلفة 2",
                        costcenter3: "مركز التكلفة 3",
                        refresh: "تحديث",
                        viewGL: "معاينة دفتر الاستاذ",
                        savedelete: "حفظ الحذف",
                        confirmsavevoucher: "تأكيد حفظ السند",
                        confirmtoproceed: "التأكيد للمتابعة",
                        confirm: "التأكيد",
                        cancel: "إلغاء",
                        GeneralLedger: "دفتر الاستاذ",
                        type: "النوع",
                        account: "الحساب",
                        Account: "الحساب",
                        debit: "المدين",
                        Debit: "المدين",
                        Credit: "الدائن",
                        credit: "الدائن",
                        CostCenter1: "مركز التكلفة 1",
                        costcenter1: "مركز التكلفة 1",
                        costcenter2: "مركز التكلفة 2",
                        costcenter3: "مركز التكلفة 3",
                        totaldebit: "اجمالي المدين",
                        TotalDebit: "اجمالي المدين",
                        totalcredit: "اجمالي الدائن",
                        TotalCredit: "اجمالي الدائن",
                        balance: "الرصيد",
                        Balance: "الرصيد",
                        close: "اغلاق",
                        Close: "اغلاق",
                        JournalVoucher: "قيود اليومية",
                        narration: "الشرح",
                        Narration: "الشرح",
                        invaliddetails: "تفاصيل غير متوفرة",
                        Companyexpense: "مصاريف الشركة",
                        CompanyExpense: "مصاريف الشركة",
                        amount: "المبلغ",
                        sub_total: "المجموع",
                        total_vat: "اجمالي مبلغ ضريبة القيمة المضافة",

                        total_tax: "اجمالي مبلغ ضريبة القيمة المضافة",
                        selectaccount: "اختر الحساب",
                        cashpaymentvoucher: "سند دفع نقدي",
                        total: "الإجمالي",
                        invaliddetails: "تفاصيل غير متوفرة",
                        FundPaymentVoucher: "سند دفع بنكي",
                        PDCPayableAccount: "حساب الشيكات المدفوعة المؤجلة",
                        Bankaccount: "حساب البنك",
                        BankAccount: "حساب البنك",
                        ChequeNo: "رقم الشيك",
                        Maturitydate: "تاريخ الإستحقاق",

                        ChequeReceiptvoucher: "سند استلام نقدي",
                        PDCReceivableAccount: "حساب الشيكات المؤجلة المستلمة",
                        PDCReceivable: "مستحقات PDC",
                        PDCPayable: "PDC المستحقة",
                        Bankaccount: "حساب البنك",
                        PendingPDCs: "الشيكات المؤجلة المعلقة",
                        DateFrom: "من تاريخ",
                        DateTo: "الى تاريخ",
                        Refresh: "تحديث",
                        Filter: "التصنيف",
                        Noitemstodisplay: "لا توجد عناصر لعرضها",
                        PDCNo: "رقم حافظة الشيكات",
                        Voucher: "سند",
                        Cheque: "الشيك",
                        PDCAccount: "حساب حافظة الشيكات",

                        Bankaccount: "حساب البنك",
                        Status: "الحالة",
                        Options: "الخيارات",
                        ProcessedPDCs: "معالجة الشيكات",
                        Noitemstodisplay: "لا توجد عناصر لعرضها",
                        PDCNo: "رقم حافظة الشيكات",
                        VoucherNo: "رقم السند",
                        PDCAccount: "حساب حافظ الشيكات",
                        SupplierCustomeraccount: "حساب العميل / المورد",
                        Options: "الخيارات",
                        ReconcileDate: "تاريخ تحصيل الشيك",
                        ReconcileBankAccount: "حساب بنك تحصيل الشيك",
                        Reconcilechequepayment: "تحصيل الشيكات المدفوعة",
                        chequepayNo: "رقم شيك الدفع",
                        Noitemstodisplay: "لا توجد عناصر لعرضها",
                        Reconcilechequereceipt: "تحصيل الشيكات المقبوضة",
                        Openingstocks: "الرصيد الافتتاحي للمخزون",
                        confirmsavevoucher: "تاكيد حفظ السند",

                        confirmsavevoucher: "تاكيد حفظ السند",
                        confirmdelete: "المتابعة للحذف",
                        confirmtoproceed: "التاكيد للمتابعة",
                        totalquantity: "إجمالي الكمية",
                        TotalQuantity: "إجمالي الكمية",
                        stockissue: "سند إخراج بضاعة",
                        StockIssue: "سند إخراج بضاعة",
                        stockrecive: "سند استلام بضاعة",
                        FilterLedger: "التصنيف في دفتر الاستاذ العام",
                        SelectAll: "اختيار الكل",
                        selectall: "اختيار الكل",
                        from: "من",
                        to: "الى",
                        DocNumber: "رقم المستند",
                        Applyfilter: "تطبيق التصنيف",
                        resetfilter: "اعادة التصنيف",
                        close: "اغلاق",
                        exporttoexcel: "التصدير الى اكسيل",
                        exporttoPDF: "التصدير الى PDF",

                        itemsperpage: "صفحة المواد",
                        Noitemstodisplay: "لا يوجد عناصر لعرضها",
                        trailbalance: "ميزان المراجعة",
                        level: "مستوى",
                        accountcode: "رمز الحساب",
                        AccountCode: "رمز الحساب",
                        accountname: "اسم الحساب",
                        AccountName: "اسم الحساب",
                        balancedebit: "الرصيد المدين",
                        balancecredit: "الرصيد الدائن",
                        itemsperpage: "صفحة المواد",
                        profitloss: "قائمة الارباح والخسائر",
                        all: "جميع",
                        itemsperpage: "صفحة المواد",
                        balancesheet: "الميزانية العمومية",
                        BalanceSheet: "الميزانية العمومية",

                        itemsperpage: "صفحة المواد",
                        shortcuts: "اختصارات",
                        addaccounts: "اضافة حسابات",
                        addproducts: "اضافة المنتجات",
                        addservices: "اضافة الخدمات",
                        addassets: "اضافة الاصول",
                        addaccount: "اضافة حساب",
                        chartofaccounts: "شجرة الحسابات",
                        assets: "الاصول",
                        support: "الدعم",
                        livechat: "الدعم الفني المباشر",
                        emailsupport: "الدعم الفني بالايميل",
                        whatsappsupport: "الدعم الفني بالواتس اب ",
                        enquiry: "استعلام",
                        admin: "المشرف",
                        documentnumber: "رقم المستند",
                        smstemplates: "قوالب الرسائل النصية",
                        changepassword: "تغيير كلمة المرور",

                        Logout: "تسجيل الخروج",
                        logout: "تسجيل الخروج",
                        TRN: "رقم التسجيل الضريبي",
                        profile: "الملف الشخصي",
                        Profile: "الملف الشخصي",
                        general: "عام",
                        phoneno: "رقم الهاتف",
                        mobileno: "رقم الجوال",
                        emailsupport: "البريد الالكتروني للدعم",
                        address: "العنوان",
                        website: "الموقع الالكتروني",
                        TRNNo: "رقم التسجيل الضريبي",
                        defaultvat: "ضريبة القيمة المضافة الافتراضية",
                        defaultfinancialyear: "السنة المالية الافتراضية",
                        defaultsalesaccount: "حساب المبيعات الافتراضي",
                        defaultpurchaseaccount: "حساب المشتريات الافتراضي",
                        defaultinpoutvaraccount: "حساب مدخلات الضريبة الافتراضي",
                        defaultoutputvataccount: "حساب مخرجات الضريبة الافتراضي",
                        deafultcashaccount: "حساب النقدية الافتراضي",
                        defaultbankaccount: "حساب البنك الافتراضي",
                        deafultPDCPayableaccount: "حساب الشيكات المدفوعة الافتراضي",
                        defaultPDCReceivableAccount: "حساب الشيكات المستلمة الافتراضي",
                        refresh: "تحديث",
                        Vouchercostcentermapping: "مخطط مركز التكلفة",
                        updatemappings: "تحديث بيانات المخطط",
                        documentnumber: "رقم المستند",
                        YourEmailAddress: "عنوان بريدك الإلكتروني",
                        YourMobileNo: "هاتفك النقال لا",
                        save: "حفظ",
                        cancel: "الغاء",
                        prefix: "اختصار",
                        number: "الرقم",
                        DONo: "هل الرقم",
                        smstemplates: "قوالب الرسائل النصية",
                        keywords: "لوجة الكلمات",
                        vouchername: "اسم السند",
                        VoucherName: "اسم السند",
                        vouchernumber: "رقم السند",
                        clientcustomername: "اسم العميل",
                        invoicedate: "تاريخ الفاتورة",
                        subtotal: "المجموع",
                        SubTotal: "المجموع",
                        totaltax: "اجمالي مبلغ ضريبة القيمة المضافة",
                        template: "القالب",
                        smsText: "نص الرسالة النصية",
                        updatetemplates: "نص الرسالة النصية",
                        newpassword: "كلمة المرور الجديدة",
                        confirmpassword: "كلمة المرور الجديدة",
                        EditAccountType: "تحرير نوع الحساب",
                        voucher: "فاتورة #",
                        selectlevel: "اختار مستوى",
                        DeselectAll: "الغاء تحديد الكل",
                        TotalVAT: "إجمالي ضريبة القيمة المضافة",
                        CostMandatory: "التكلفة إلزامية",
                        Details: "تفاصيل",
                        CreditAmount: "مبلغ الائتمان",
                        DebitAmount: "مقدار الخصم",
                        ChequeDate: "تحقق التاريخ",
                        Profit: "ربح",
                        Loss: "ربح",
                        SalesInvoiceReport: "تقرير فاتورة المبيعات",
                        OpeningStock: "الرصيد الافتتاحي للمخزون",
                        Openingstock: "الرصيد الافتتاحي للمخزون",
                        Poduct_Code: "كود المنتج",
                        Poduct_Name: "اسم المنتج",
                        InsertRow: "الصف إدراج",
                        DeleteRow: "احذف صف",
                        StockReceive: "تلقي الأوراق المالية",
                        Supplier: "المورد",
                        ConfirmProcessPDC: "تأكيد عملية PDC",
                        SupplierCustomerAccount: "حساب عميل المورد",
                        ChequeDate: "تحقق التاريخ",
                        ConfirmReversePDC: "تأكيد عكس PDC",
                        ReconcileChequePaymentDetails: "تسوية الشيك تفاصيل الدفع",
                        Payment_No: "رقم الدفعة",
                        PDCNumber: "رقم PDC",
                        BankAccountName: "اسم الحساب المصرفي",
                        CostCenters1Name: "مراكز التكلفة 1 الاسم",
                        CostCenter2Name: "مركز التكلفة 2 الاسم",
                        CostCenter3Name: "مركز التكلفة 3 الاسم ",
                        ReconcileChequeReceiptDetails: "التوفيق بين التحقق من تفاصيل الاستلام ",
                        CashReceiptVoucher: "إيصال استلام النقدية ",
                        Audited: "مدققة",
                        FundReceiptVoucher: "قسيمة استلام الصندوق",
                        ChequePaymentVoucher: "التحقق من قسيمة الدفع",
                        Grand_Total: "المبلغ الإجمالي",
                        Exclusive: "حصرية",
                        Inclusive: "شامل",
                        VoucherLinking: "ربط القسيمة",
                        SalesEnquiry: "تحقيق مبيعات",
                        SalesQuotation: "تسعير المبيعات",
                        SalesOrder: "طلب المبيعات",
                        DeliveryNote: "مذكرة تسليم",
                        Link: "حلقة الوصل",
                        PlaceofSupply: "مكان التوريد",
                        PlaceOfSupply: "مكان التوريد",
                        SalesEmployee: "موظف مبيعات",
                        AddAccount: "إضافة حساب",
                        ContactPerson: "الشخص الذي يمكن الاتصال به",
                        ContactPersonNo: "شخص الاتصال لا",
                        CreditLimit: "الحد الائتماني",
                        CreditDays: "أيام الائتمان",
                        Registered: "مسجل",
                        EnterOTP: "أدخل OTP",
                        OTP: "OTP",
                        NotRegistered: "غير مسجل",
                        FaxNo: "فاكس رقم",
                        LicenseNo: "رقم الرخصة",
                        Username: "اسم المستخدم",
                        LicenseExpiryDate: "تاريخ انتهاء الترخيص",
                        AddCostCenter: "إضافة مركز التكلفة",
                        CostCenterName: "اسم مركز التكلفة",
                        EditCostCenter: "تحرير مركز التكلفة",
                        AddProduct: "أضف منتج",
                        Barcode: "الرمز الشريطي",
                        SellingPrice: "سعر البيع",
                        PurchasePrice: "سعر الشراء",
                        SalesAccount: "حساب مبيعات",
                        PurchaseAccount: "شراء حساب",
                        Specification: "تخصيص",
                        Continue: "استمر",
                        Model: "نموذج",
                        DoDate: "هل التاريخ",
                        SendMail: "ارسل بريد",
                        CashReceipt: "فاتورة نقدية",
                        CashPayment: "دفع نقدا",
                        SupplierName: "اسم المورد",
                        UpdateProductGroup: "تحديث مجموعة المنتجات",
                        UpdateProduct: "تحديث المنتج",
                        SelctedGroup: "سيلكتيد جروب",
                        UpdateServiceGroup: "تحديث مجموعة الخدمات",
                        UpdateService: "تحديث الخدمة",
                        AddService: "إضافة الخدمة",
                        AddAsset: "إضافة الأصول",
                        AMCCompany: "شركة AMC",
                        DepreciationYear: "سنة الاستهلاك",
                        WarrantyDate: "تاريخ الضمان",
                        UpdateAssetGroup: "تحديث مجموعة الأصول",
                        UpdateAsset: "تحديث الأصول",
                        InsertRow: "الصف إدراج",
                        DeleteRow: "احذف صف",
                        VoucherLinking: "ربط القسيمة",
                        PurchaseEnquiry: "استفسار عن الشراء",
                        Link: "حلقة الوصل",
                        SalesEnquiry: "تحقيق مبيعات",
                        SelctedGroup: "سيلكتيد جروب",
                        Audited: "مدققة",
                        Subject: "موضوع",

                        FundReceipt: "استلام الصندوق",
                        FundPayment: "دفع الصندوق",
                        ChequePayment: "الدفع بشيك",
                        AnyDesk: "أي مكتب",
                        Youhave0Mails: "لديك 0 رسائل",
                        Voucher_CostCenterMapping: "قسيمة - مركز التكلفة رسم الخرائط",
                        CompanyExpenseVoucher: "قسيمة مصاريف الشركة",
                        NoPurchaseDatasFound: "لم يتم العثور على دتس الشراء",
                        NoAuditDatasFound: "لم يتم العثور على دتس التدقيق",
                        SalesInvocie: "فاتورة المبيعات",
                        PurchaseInvocie: "شراء Invocie",
                        Accounts: "حسابات",
                        Passwordsdonotmatch: "كلمة المرور غير مطابقة",
                        Reset: "إعادة تعيين",
                        Passwordisrequired: "كلمة المرور مطلوبة ",
                        EnterYourMessageHere: "أدخل رسالتك هنا",
                        ChequeReceipt: "تحقق الإيصال",
                        TeamViewer: "فريق المشاهد",
                        ChangeToEnglish: "التغيير إلى اللغة الإنجليزية",
                        ChangeToArabic: "التغيير إلى العربية",
                        SuperUser: "سوبر المستخدم",
                        NeedOTP: "تحتاج مكتب المدعي العام",
                        DefaultVAT: "Default VAT ",
                        DefaultFinancialYear: " السنة المالية الافتراضية ",
                        DefaultSalesAccount: "حساب المبيعات الافتراضي",
                        DefaultPurchaseAccount: "حساب الشراء الافتراضي ",
                        DefaultInputVatAccount: "حساب ضريبة القيمة المضافة الافتراضية",
                        DefaultOutputVatAccount: "حساب ضريبة القيمة المضافة الافتراضية ",
                        DefaultCashAccount: " حساب ضريبة القيمة المضافة الافتراضية ",
                        DefaultBankAccount: "  الحساب البنكي الافتراضي ",
                        DefaultPDCPayableAccount: "  حساب الدفع PDC الافتراضي ",
                        DefaultPDCReceivableAccount: " حساب مستحقات PDC الافتراضي ",
                        SMSId: "معرف SMS",
                        DubaiunitedArabEmirates: "دبى، الامارات العربية المتحدة",
                        UsernamePasswordFinancialYearError: "اسم المستخدم / كلمة المرور / خطأ في السنة المالية",
                        SMSUsername: "اسم المستخدم SMS",
                        SMSPassword: "كلمة مرور الرسائل القصيرة",
                        EasybookCloud: "Easybook الغيمة",
                        EasybookSoftwareTrading: "Easybook تجارة البرمجيات",
                        LoginNow: "تسجيل الدخول الآن",
                        Login: "تسجيل الدخول",
                        Dateofsupply: "تاريخ العرض",
                        TaxInvoice: "فاتورة ضريبية",
                        LoremIpsumissimplydummytextoftheprintingandtypesettingindustryLoremIpsumhasbeentheindustrysstandarddummytexteversincethe1500s: "أبجد هوز هو مجرد دمية النص لصناعة الطباعة والتنضيد. لقد كان Lorem Ipsum هو النص الوهمي القياسي في هذه الصناعة منذ القرن السادس عشر",
                        EnglishName: "الاسم الانجليزي",
                        SellingPrice: "سعر البيع",
                        Cashledger: "Cashledger",
                        BankLedger: "BankLedger",
                        PettyCashLedger: "PettyCashLedger",
                        DebtorsLedger: "DebtorsLedger",
                        FixedAssetsLedger: "FixedAssetsLedger",
                        InventoryLedger: "InventoryLedger",
                        CashBalance: "CashBalance",
                        PettyCashBalance: "PettyCashBalance",
                        BankBalance: "BankBalance",
                        DebtorsBalance: "DebtorsBalance",
                        FixedAssetsBalance: "FixedAssetsBalance",
                        InventoryBalance: "InventoryBalance",
                        EquityCapitalBalance: "EquityCapitalBalance",
                        PartnerAccountBalance: "PartnerAccountBalance",
                        CreditorsBalance: "CreditorsBalance",
                        LoanBalance: "LoanBalance",
                        OtherLiabilitiesBalance: "OtherLiabilitiesBalance",
                        PurchaseLedger: "PurchaseLedger",
                        DirectCostLedger: "DirectCostLedger",
                        PurchaseBalance: "PurchaseBalance",
                        DirectCostBalance: "DirectCostBalance",
                        SalaryandAllowancesBalance: "SalaryandAllowancesBalance",
                        ExpensesBalance: "ExpensesBalance",
                        SalaryandAllowancesLedger: "SalaryandAllowancesLedger",
                        ExpensesLedger: "ExpensesLedger",
                        SalesBalance: "SalesBalance",
                        SalesLedger: "SalesLedger",
                        OtherRevenueAccount: "OtherRevenueAccount",
                        OtherRevenueLedger: "OtherRevenueLedger",
                        EquityCapitalLedger: "EquityCapitalLedger",
                        PartnerAccountLedger: "PartnerAccountLedger",
                        CreditorsLedger: "CreditorsLedger",
                        LoanLedger: "LoanLedger",
                        Currency: "عملة",
                        Symbol: "رمز",
                        Rate: "معدل",
                        CurrencyName: "اسم العملة",
                        ConvertedCurrencyName: "اسم العملة المحولة",
                        CurrencyConvertion: "تحويل العملات",
                        ConvertedCurrency: "تحويل العملة",
                        BaseCurrency: "العملة الأساسية",
                        EntertheCurrencyConvertionty: "أدخل تحويل العملة",
                        OtherLiabilitiesLedger: "OtherLiabilitiesLedger",
                        Currency: "عملة",
                        Usesearchforfindingtheaccountpleaseresetandaddupdateaccountsinactualway: "استخدم البحث للعثور على الحساب. يرجى إعادة ضبط وإضافة / تحديث الحسابات بالطريقة الفعلية",
                        Cash: "نقد",
                        Bank: "مصرف",
                        InterviewDay: "يوم المقابلة",
                        DesignationDate: "تاريخ التعيين",
                        StartingDate: "تاريخ البدء",
                        ResignationDate: "تاريخ الاستقالة",
                        EndingDate: "تاريخ الانتهاء",
                        FirstName: "الاسم الاول",
                        SurName: "لقب",
                        FatherName: "اسم الأب",
                        MotherName: "اسم الأم",
                        BirthDate: "تاريخ الولادة",
                        Gender: "جنس",
                        BirthPlace: "مكان الولادة",
                        PassportNo: "رقم جواز السفر",
                        PassportIssueDate: "تاريخ اصدار جواز السفر",
                        PassportIExpireDate: "تاريخ انتهاء صلاحية جواز السفر",
                        Religion: "دين",
                        VisaType: "نوع الفيزا",
                        VisaNo: "فيزا",
                        VisaIssueDate: "تاريخ إصدار التأشيرة",
                        VisaExpireDate: "تاريخ انتهاء صلاحية التأشيرة",
                        JobLocation: "مكان العمل",
                        Qualification: "المؤهل",
                        ContractNo: "رقم العقد",
                        ContractEndDate: "تاريخ انتهاء العقد",
                        BloodGroup: "فصيلة الدم",
                        MaritalStatus: "الحالة الاجتماعية",
                        WhatsappNo: "رقم الواتس اب",
                        HomeCountryAddress: "عنوان البلد الأم",
                        Insurance: "تأمين",
                        EmiratesIDNo: "رقم الهوية الإماراتية",
                        EmiratesIDExpireDate: "تاريخ انتهاء الهوية الإماراتية",
                        ReferenceFriendName: "مرجع اسم الصديق",
                        ReferenceFriendNo: "رقم الصديق المرجعي",
                        Designation: "تعيين",
                        Department: "قسم",
                        ReportingManager: "مدير التقارير",
                        FullName: "الاسم الكامل",
                        Employee: "موظف",
                        AttachmentType: "نوع المرفق",
                        EmployeeAttachment: "إرفاق الموظف",
                        DocNo: "رقم المستند",
                        FilePath: "مسار الملف",
                        WpsDetail: "Wps Detail",
                        WpsDetail: "Wps Detail",
                        PaymentType: "نوع الدفع",
                        BankName: "اسم البنك",
                        BankAccNo: "رقم الحساب المصرفي",
                        BankBranch: "فرع بنك",
                        AgentCode: "رمز العميل",
                        IbanNo: "IbanNo",
                        SalaryDetail: "تفاصيل الراتب",
                        BasicSalary: "راتب اساسي",
                        TransportAllowance: "بدل النقل",
                        AccommodationAllowance: "بدل إقامة",
                        OtherAllowance: "بدلات أخرى",
                        Total: "مجموع",
                        LeaveType: "نوع الإجازة",
                        VacationRequest: "طلب إجازة",
                        StartDate: "تاريخ البدء",
                        EndDate: "تاريخ الانتهاء",
                        ResignationForm: "استمارة الاستقالة",
                        ResignationDate: "تاريخ الاستقالة",
                        Reason: "السبب",
                        WarningLetter: "رسالة تحذير",
                        RespondDate: "تاريخ الرد",
                        ApplyVacation: "تطبيق الإجازة",
                        HR: "HR",
                        SalarySheet: "SalarySheet",
                        BasicSalary: "BasicSalary",
                        TransportationAllowance: "TransportationAllowance",
                        AccommodationAllowance: "AccommodationAllowance",
                        OverTime: "OverTime",
                        OtherAllowance: "OtherAllowance",
                        Bonus: "Bonus",
                        Advance: "Advance",
                        Deduction: "Deduction",
                        NetSalary: "NetSalary",
                        OtherAllowance: "OtherAllowance",
                        TotalAccommodationAllowance: "TotalAccommodationAllowance",
                        TotalTransportationAllowance: "TotalTransportationAllowance",
                        TotalOverTime: "TotalOverTime",
                        TotalNetSalary: "TotalNetSalary",
                        TotalSalary: "TotalSalary",
                        TotalOtherAllowance: "TotalOtherAllowance",
                        TotalBonus: "TotalBonus",
                        TotalAdvance: "TotalAdvance",
                        TotalDeduction: "TotalDeduction",
                        EmployeeAdvance: "EmployeeAdvance",
                        Amount: "Amount",
                        EmployeeFine: "EmployeeFine",
                        FineType: "FineType",
                        TimeSheet: "TimeSheet",
                        Shift1Start: "Shift1Start",
                        Shift2Start: "Shift2Start",
                        Shift1End: "Shift1End",
                        Shift2End: "Shift2End",
                        DailyHours: "DailyHours",
                        OverTime: "OverTime",
                        TotalHours: "TotalHours",
                        VacationHistory: "VacationHistory",
                        StartDate: "StartDate",
                        JoingDate: "JoingDate",
                        TotalDays: "TotalDays",
                        AppraisalHistory: "AppraisalHistory",
                        Salary: "Salary",
                        PreviousSalary: "PreviousSalary",
                        CourtCategory: "CourtCategory",
                        Court: "Court",
                        CaseCategory: "CaseCategory",
                        CaseStage: "CaseStage",
                        AppointmentType: "AppointmentType",
                        CaseTransaction: "CaseTransaction",
                        AuthorizedPerson: "AuthorizedPerson",
                        Case: "Case",
                        OppositeLawyerName: "OppositeLawyerName",
                        OppositeLawyerPhone: "OppositeLawyerPhone",
                        TotalFees: "TotalFees",
                        Advocate: "Advocate",
                        CaseNo: "CaseNo",
                        IsClosed: "IsClosed",
                        Act: "Act",
                        Appointment: "Appointment",
                        AppointmentDate: "AppointmentDate",
                        IsVisited: "IsVisited",
                        CaseVisit: "CaseVisit",
                        CaseVisitType: "CaseVisitType",
                        CreatedBy: "CreatedBy",
                        CreatedDate: "CreatedDate",
                        CaseHearing: "CaseHearing",
                        HearingDate: "HearingDate",
                        IsDone: "IsDone",
                        Recipe: "Recipe",
                        Product: "Product",
                        RProduct: "RecipeProduct",
                        Cusian: "Cushion",
                        counterSalesTable: "CounterSalesTable",
                        CounterSalesTable: "CounterSalesTable",
                        SalesInvoiceA: "SalesInvoiceA",
                        SalesInvoiceB: "SalesInvoiceB",
                        SalesInvoiceC: "SalesInvoiceC",
                        SalesInvoiceD: "SalesInvoiceD",
                        SalesInvoiceE: "SalesInvoiceE",
                        EmployeeSalesReport: "EmployeeSalesReport",
                        FromDate: "FromDate",
                        ToDate: "ToDate",

                        Building: "Building",
                        BuildingNo: "BuildingNo",
                        PlotNo: "PlotNo",
                        Floors: "Floors",
                        Area: "Area",
                        RentPropertyType: "RentPropertyType",
                        Location: "Location",
                        AddressArabic: "AddressArabic",
                        BuildDate: "BuildDate",
                        BondDate: "BondDate",
                        BondNo: "BondNo",
                        BondType: "BondType",
                        Lessor: "Lessor",
                        ContractorName: "ContractorName",
                        ContractorNameArabic: "ContractorNameArabic",
                        WatchMen: "WatchMen",
                        GovtNo: "GovtNo",
                        RemarksArabic: "RemarksArabic",
                        NoOfParking: "NoOfParking",
                        Contracts: "Contracts",
                        NameArabic: "NameArabic",
                        Flat: "Flat",
                        FlatNo: "FlatNo",
                        FloorNo: "FloorNo",
                        BedRooms: "BedRooms",
                        BathRooms: "Bathrooms",
                        AvgRate: "Average Rate",
                        ContractType: "ContractType",
                        RemarksAr: "RemarksArabic",
                        ContractPlace: "ContractPlace",
                        Tenant: "Tenant",
                        RentalType: "RentalType",
                        PurposeOfRent: "PurposeOfRent",
                        RentDuration: "RentDuration",
                        ExpiryDate: "ExpiryDate",
                        TotalAmountInWords: "TotalAmountInWords",
                        NoOfPayments: "NoOfPayments",
                        SecurityDeposit: "SecurityDeposit",
                        Commission: "Commission",
                        PaymentMethod: "PaymentMethod",
                        TotalAmount: "TotalAmount",
                        ContractInvoice: "ContractInvoice",

                        VehicleInsuranceExpiryDate: "VehicleInsuranceExpiryDate",
                        Branch: "Branch",
                        VehicleMake: "VehicleMake",
                        VehicleInsuranceProviderName: "VehicleInsuranceProviderName",
                        VehicleModel: "VehicleModel",
                        VehicleChassisNo: "VehicleChassisNo",
                        VehicleEngine: "VehicleEngine",
                        VehicleCurrentOdometer: "VehicleCurrentOdometer",
                        VehicleYear: "VehicleYear",
                        VehicleDailyOdometerLimit: "VehicleDailyOdometerLimit",
                        VehicleColor: "VehicleColor",
                        VehicleOdometerExtraFeesPerUnit: "VehicleOdometerExtraFeesPerUnit",
                        VehicleTrafficNo: "VehicleTrafficNo",
                        VehicleCurrentFuel: "VehicleCurrentFuel",
                        VehiclePlateSource: "VehiclePlateSource",
                        VehicleDailyRate: "VehicleDailyRate",
                        VehicleWeeklyRate: "VehicleWeeklyRate",
                        VehiclePlateCategory: "VehiclePlateCategory",
                        VehicleMonthlyRate: "VehicleMonthlyRate",
                        VehicleLicenceIssuedDate: "VehicleLicenceIssuedDate",
                        VehicleLicenceExpiryDate: "VehicleLicenceExpiryDate",
                        VehicleYearlyRate: "VehicleYearlyRate",
                        VehicleCurrentLocation: "VehicleCurrentLocation",
                        VehicleSalikAccount: "VehicleSalikAccount",
                        VehicleCurrentStatus: "VehicleCurrentStatus",
                        VehicleCategory: "VehicleCategory",
                        VehiclePlateNo: "VehiclePlateNo",
                        IntroLetterDescription: "IntroLetterDescription",
                        EndLetterDescription: "EndLetterDescription",
                        SupplierPONO: "SupplierPONO",
                        SupplierBillNo: "SupplierBillNo",
                        SupplierBillDate: "SupplierBillDate",
                        PaymentTerms: "PaymentTerms",
                        DeliveryBasis: "DeliveryBasis",
                        DeliveryPeriod: "DeliveryPeriod",
                        EnquiryNo: "EnquiryNo",
                        WarrantyPeriod: "WarrantyPeriod",
                        YRRefNo: "YRRefNo",
                        Manufacturing: "Manufacturing",
                        Stock: "Stock",
                        UnitConvertion: "UnitConvertion",
                        ConvertedUnit: "ConvertedUnit",
                        ConvertedUnitName: "ConvertedUnitName",
                        ShippingAddress: "ShippingAddress",

                        Grades: "Grades",
                        Shifts: "Shifts",
                        Banks: "Banks",
                        PayrollComponents: "PayrollComponents",
                        Type: "Type",


                        Order: "Order",
                        Lead: "Lead",
                        Task: "Task",
                        Followup: "Followup",
                        Change: "Change",
                        Cushion: "Cushion",
                        TelphoneNo: "Telphone No",
                        Branches: "Branches",
                        Warehouses: "Warehouses",
                        Brands: "Brands",
                        DeleteAll: "Delete All",
                        DeleteOne: "Delete One",
                        AddCostCenter: "Add Cost Center",
                        SelectedGroup: "Selected Group",
                        AddParentCostCenter: "Add Parent Cost Center",
                        Add: "Add",
                        AccountWiseCostCenters: "Account Wise Cost Centers",
                        Save: "Save",
                        ChooseParentAccountToMove: "Choose Parent Account To Move",
                        MoveAccount: "Move Account",
                        WorkPhoneNo: "Work Phone No",
                        WorkAddress: "Work Address",
                        Profession: "Profession",
                        HomePhoneNo: "Home Phone No",
                        DrivingLicenseIssuedBy: "Driving License Issued By",
                        HomeAddress: "Home Address",
                        PlaceOfBirth: "Place Of Birth",
                        VisitVisaNo: "Visit Visa No",
                        DrivingLicenseExpiryDate: "Driving License Expiry Date",
                        DrivingLicenseIssueDate: "Driving License Issue Date",
                        DateOfBirth: "Date Of Birth",
                        IdentityExpiryDate: "Identity Expiry Date",
                        IdentityIssueDate: "Identity Issue Date",
                        Nationlity: "Nationlity",
                        UnifiedNo: "Unified No",
                        IdentityCardNo: "Identity Card No",
                        PreferedLanguage: "Prefered Language",
                        PhoneNo: "Phone No",
                        IsGroup: "Is Group",
                        More: "More",
                        Basic: "Basic",
                        SaveAccount: "Save Account",
                        Economy: "Economy",
                        Business: "Business",
                        First: "First",
                        TicketAirClass: "Ticket Air Class",
                        TicketDestination: "Ticket Destination",
                        TicketInfants: "Ticket Infants",
                        TicketChildren: "Ticket Children",
                        TicketAdults: "Ticket Adults",
                        VacationDays: "Vacation Days",
                        TwoYears: "Two Years",
                        HalfYearly: "Half Yearly",
                        Yearly: "Yearly",
                        VacationPeriod: "Vacation Period",
                        RemainingTickets: "Remaining Tickets",
                        RemainingVacationSalary: "Remaining Vacation Salary",
                        RemainingVacationDays: "Remaining Vacation Days",
                        LOPDays: "LOP Days",
                        DateAsOn: "Date As On",
                        Notes: "Notes",
                        AnnualCTC: "Annual CTC",
                        SwiftNo: "Swift No",
                        IBANNo: "IBAN No",
                        BankBranchName: "Bank Branch Name",
                        BankAccountNo: "Bank Account No",
                        Bank: "Bank",
                        ModeOfPayment: "Mode Of Payment",
                        MolNo: "Mol No",
                        OHCExpiryDate: "OHC Expiry Date",
                        OHCIssueDate: "OHC Issue Date",
                        OHCNo: "OHC No",
                        MedicalExpiryDate: "Medical Expiry Date",
                        MedicalIssueDate: "Medical Issue Date",
                        MedicalNo: "Medical No",
                        DrivingLicenseNo: "Driving License No",
                        IdExpiryDate: "ID Expiry Date",
                        IdIssueDate: "ID Issue Date",
                        IdNo: "ID No",
                        ContractExpendableDate: "Contract Expendable Date",
                        ContractExpiryDate: "Contract Expiry Date",
                        ContractIssueDate: "Contract Issue Date",
                        LabourCardIssueDate: "Labour Card Issue Date",
                        LabourCardIssueDate: "Labour Card Issue Date",
                        LabourCardNo: "Labour Card No",
                        VisaExpiryDate: "Visa Expiry Date",
                        PassportExpiryDate: "Passport Expiry Date",
                        Contact: "Contact",
                        Permanant: "Permanant",
                        Present: "Present",
                        Address2: "Address 2",
                        Address1: "Address 1",
                        MobileNo2: "MobileNo 2",
                        MobileNo1: "MobileNo 1",
                        AddNew: "Add New",
                        Relative: "Relative",
                        Friend: "Friend",
                        Wife: "Wife",
                        Husband: "Husband",
                        Sister: "Sister",
                        Brother: "Brother",
                        Mother: "Mother",
                        Father: "Father",
                        Relation: "Relation",
                        Saturday: "Saturday",
                        Friday: "Friday",
                        Thursday: "Thursday",
                        Wednesday: "Wednesday",
                        Tuesday: "Tuesday",
                        Monday: "Monday",
                        Sunday: "Sunday",
                        WeeklyOff2: "Weekly Off 2",
                        WeeklyOff1: "Weekly Off 1",
                        AllowOverTime: "Allow Over Time",
                        Section: "Section",
                        Sponsership: "Sponsership",
                        ConfirmationDate: "Confirmation Date",
                        DateOfJoining: "Date Of Joining",
                        InterviewDate: "Interview Date",
                        GuardianRelation: "Guardian Relation",
                        GuardianName: "Guardian Name",
                        EmergencyContactNo: "Emergency Contact No",
                        EmergencyContactName: "Emergency Contact Name",
                        RoomNo: "Room No",
                        Accomodation: "Accomodation",
                        RegisteredPartnership: "Registered Partnership",
                        Separated: "Separated",
                        Divorced: "Divorced",
                        Widowed: "Widowed",
                        Married: "Married",
                        Single: "Single",
                        MaritalStatus: "Marital Status",
                        Others: "Others",
                        Nonreligious: "Nonreligious",
                        Sikh: "Sikh",
                        Buddha: "Buddha",
                        Hindu: "Hindu",
                        Christian: "Christian",
                        Muslim: "Muslim",
                        NotSpecified: "Not Specified",
                        Female: "Female",
                        Male: "Male",
                        Shift: "Shift",
                        Grade: "Grade",
                        Contract: "Contract",
                        PartTime: "Part Time",
                        Permanent: "Permanent",
                        EmployeeType: "Employee Type",
                        EmployeeCode: "Employee Code",
                        Attachments: "Attachments",
                        Appraisals: "Appraisals",
                        Vacation: "Vacation",
                        Openings: "Openings",
                        Payroll: "Payroll",
                        Payment: "Payment",
                        Identities: "Identities",
                        ViewList: "View List",
                        AssetCategory: "Asset Category",
                        AddAsset: "Add Asset",
                        AssetList: "Asset List",
                        SubCategory: "Subcategory",
                        Category: "Category",
                        ShowOnPOS: "Show On POS",
                        AssetSubCategory: "Asset Subcategory",
                        Parent: "Parent",
                        ApplyParent: "Apply Parent",
                        ChooseExcel: "Choose Excel",
                        DownloadExcel: "Download Excel",
                        Upload: "Upload",
                        CostCenterUpload: "Cost Center Upload",
                        VatAccountType: "VAT Account Type",
                        TaxCategory: "Tax Category",
                        VatStateEmirate: "VAT State / Emirate",
                        VatCountry: "VAT Country",
                        Expenses: "Expenses",
                        CostCenter: "Cost Center",
                        Combinations: "Combinations",
                        CostCenterGroup: "Cost Center Group",
                        SellPrice: "Sell Price",
                        PurchasePrice: "Purchase Price",
                        PriceChart: "Price Chart",
                        ProductCategory: "Product Category",
                        ProductColors: "Product Colors",
                        ProductList: "ProductList",
                        Color: "Color",
                        Size: "Size",
                        IsBatch: "Is Batch",
                        Brand: "Brand",
                        HSCode: "HS Code",
                        GrossWeight: "Gross Weight",
                        NetWeight: "Net Weight",
                        Volume: "Volume",
                        Height: "Height",
                        Width: "Width",
                        Length: "Length",
                        Packing: "Packing",
                        ProductSizes: "Product Sizes",
                        ProductSubCategory: "Product Sub Category",
                        ProductTypes: "Product Types",
                        Apply: "Apply",
                        ProductUpdate: "Product Update",
                        AfterEachUploadPleaseReloadThePage: "After Each Upload Please Reload The Page",
                        ConvertingValue: "Converting Value",
                        ConvertingUnit: "Converting Unit",
                        Manufacture: "Manufacture",
                        RecipeProduct: "Recipe Product",
                        MainProduct: "Main Product",
                        ServiceCategory: "Service Category",
                        ServiceList: "Service List",
                        ServiceSubCategory: "Service Subcategory",
                        UserRoles: "User Roles",
                        ConfirmBlockUnblockUser: "Confirm Block / Unblock User",
                        ConfirmPassword: "Confirm Password",
                        Role: "Role",
                        UserName: "User Name",
                        Users: "Users",
                        VATAccountType: "VAT Account Type",
                        VatStateEmirate: "VAT State / Emirate",
                        VatCountry: "VAT Country",
                        Vendors: "Vendors",

                        RemarksAr: "RemarksArabic",
                        Next: "التالي",
                        Back: "للخلف",
                        Save: "حفظ",
                        ViewLedger: "عرض الحساب",
                        TotalBalance: "الرصيد الإجمالي",
                        Adjustment: "تعديل",
                        TotalPaid: "إجمالى المبالغ المدفوعة",
                        INVNo: "رقم الفاتورة",
                        INVType: "نوع الفاتورة",
                        AutoAdjust: "ضبط تلقائي",
                        BillAnalysis: "تحليل الفاتورة",
                        BillwiseDetails: "تفاصيل الفاتورة",
                        LPONo: "رقم أمر الشراء المحلي",
                        DueDate: "تاريخ الاستحقاق",
                        InvNo: "رقم الفاتورة",
                        InvDate: "تاريخ الفاتورة",
                        CostCenterDetails: "تفاصيل مركز التكلفة",
                        Date: "التاريخ",
                        CompanyExpensePreview: "عرض مصروفات الشركة",
                        CreditNotePreview: "عرض مذكرة الائتمان",
                        DebitNotePreview: "عرض مذكرة المديونية",
                        JournalVoucherPreview: "عرض قيد اليومية",
                        OpeningBalancePreview: "عرض الرصيد الافتتاحي",
                        ConfirmtoSave: "تأكيد للحفظ",
                        Probability: "احتمالا",
                        CustomerAddress: "عنوان العميل",
                        CustomerEmirate: "إمارة العميل",
                        CustomerEmail: "البريد الإلكتروني للعميل",
                        CustomerMobileNo1: "جوال العميل رقم 1",
                        CustomerMobileNo2: "جوال العميل رقم 2",
                        CustomerName: "اسم العميل",
                        LeadSource: "مصدر الدليل",
                        LeadType: "نوع الدليل",
                        Tasks: "المهام",
                        Folloup: "المتابعة",
                        FollowUp: "المتابعة",
                        OtherInfo: "معلومات اخرى",
                        LeadInfo: "معلومات الدليل",
                        AddLead: "أضف دليل",
                        UpdateStatus: "تحديث الحالة",
                        ConfirmConvert: "تأكيد التحويل",
                        Leads: "دلائل",
                        LeadSources: "مصادر الدلائل",
                        LeadTypes: "أنواع الدلائل",
                        Opportunities: "الفرص",
                        TotalExpense: "إجمالى المصروفات",
                        InventoryValue: "قيمة المخزون",
                        TotalPayable: "إجمالي المدفوعات",
                        TotalReceivable: "إجمالي المستلم",
                        BankBalance: "رصيد البنك",
                        CashBalance: "الرصيد النقدي",
                        LastYearPurchase: "مشتريات العام الماضي",
                        LastMonthPurchase: "مشتريات الشهر الماضي",
                        LastDayPurchase: "مشتريات اليوم الأخير",
                        ThisYearPurchase: "مشتريات هذا العام",
                        ThisMonthPurchase: "مشتريات هذا الشهر",
                        TodayPurchase: "مشتريات اليوم",
                        ToDoList: "عمل قائمة",
                        VacantFlats: "شقق شاغرة",
                        CreatedOn: "تم إنشاؤها على",
                        RecentlyAddedContracts: "العقود المضافة مؤخرا",
                        ExpiringOn: "إنتهاء الصلاحية",
                        ContractsEndingSoon: "العقود التى تنتهي قريبا",
                        VacantUnits: "الوحدات الشاغرة",
                        ActiveUnits: "الوحدات المشغولة",
                        TotalUnits: "إجمالي الوحدات",
                        TotalBuildings: "إجمالي المباني",
                        TodaySales: "مبيعات اليوم",
                        ThisMonthSales: "مبيعات الشهر",
                        ThisYearSales: "مبيعات العام",
                        LastDaySales: "مبيعات اليوم الأخير",
                        LastMonthSales: "مبيعات الشهر الماضي",
                        LastYearSales: "مبيعات العام الماضي",
                        Expiry: "الصلاحية",
                        FileName: "اسم الملف",
                        DocumentsByJobNo: "المستندات حسب رقم الوظيفة",
                        UploadDoc: "تحميل المستند",
                        VoucherDocuments: "وثائق الفاتورة",
                        BillDate: "تاريخ الفاتورة",
                        BillNo: "رقم الفاتورة",
                        DueDate: "تاريخ الإستحقاق",
                        ChequePaymentVoucherPreview: "عرض إيصال الدفع بشيك",
                        CashPaymentVoucherPreview: "عرض إيصال الدفع نقدا",
                        FundPaymentVoucherPreview: "عرض إيصال الدفع بالتحويل",
                        ReceiptNo: "رقم الإيصال",
                        BounceChequePayment: "دفع الشيكات المرتجعة",
                        BounceChequeReceipt: "إيصال شيك مرتجع",
                        BouncePDC: "ترتد PDC",
                        BounceDate: "تاريخ الإرتجاع",
                        ItemTotal: "مجموع الصنف",
                        VATPerc: "ضريبة القيمة المضافة",
                        ItemPrice: "سعر الصنف",
                        ItemDescription: "مواصفات الصنف",
                        BalanceAmount: "رصيد الكمية",
                        ReceivedAmount: "الكمية المستلمة",
                        CardAmount: "مبلغ الكارد",
                        CashAmount: "المبلغ النقدى",
                        CustomerMob: "رقم جوال العميل",
                        Search: "بحث",
                        BillReview: "عرض الفاتورة",
                        TotalDiscount: "إجمالى الخصم",
                        TotalCardAmount: "إجمالى مبلغ البطاقة",
                        TotalSales: "إجمالي المبيعات",
                        TotalCashAmount: "إجمالي المبلغ النقدي",
                        ConfirmCloseCounter: "تأكيد إغلاق العداد",
                        MyCounters: "عداداتي",
                        CloseCounterNow: "غلق العداد ",
                        PrintBill: "طباعة الفاتورة",
                        CurrentCounterStartedAt: "بدأ العداد الحالي في",
                        YourCounterDidnotOpenedYet: "العداد الخاص بك لم يفتح بعد",
                        CurrentCounter: "العداد الحالي",
                        CounterList: "قائمة العداد",
                        Current: "الحالى",
                        Counters: "العدادات",
                        ConfirmSaveSale: "تأكيد حفظ البيع",
                        OpenCounterNow: "فتح العداد الآن",
                        BalanceCash: "الرصيد النقدي",
                        RecievedCash: "النقدية المستلمة",
                        Staff: "طاقم العمل",
                        CardAmt: "مبلغ البطاقة",
                        CashAmt: "مبلغ النقدية",
                        PayType: "طريقة الدفع",
                        Checkout: "خروج",
                        SelectProductCode: "حدد رمز المنتج",
                        SelectProduct: "حدد المنتج",
                        Scanbarcode: "مسح الرمز الشريطى",
                        PurchasedProducts: "المنتجات المشتراة",
                        Finished: "انتهى ؟",
                        Sub: "الفرعية",
                        Item: "الصنف",
                        SelectedTable: "الجدول المحدد",
                        ChooseProducts: "اختر المنتجات",
                        Using: "استخدام",
                        Open: "فتح",
                        SlotName: "اسم الفتحة",
                        Zone: "منطقة",
                        ZoneName: "اسم المنطقة",
                        Conditions: "شروط",
                        TitleInArabic: "العنوان باللغة العربية",
                        Publish: "نشر ؟",
                        Particulars: "تفاصيل",
                        LandloardCommissionAccount: "حساب عمولة مالك الأرض",
                        ParkingAdvanceAccount: "حساب مقدم لمواقف السيارات",
                        ParkingIncomeAccount: "حساب إيراد مواقف السيارات",
                        RentalAdvanceReceivableCloseAccount: " إغلاق حساب الإيجار المستلم مقدمًا",
                        RentalAdvanceReceivableAccount: " حساب الإيجار المستلم مقدمًا",
                        ProvisionAccount: "حساب الأحتياطى",
                        BankLoanAccount: "حساب قرض البنك",
                        AdvanceRentAccount: "حساب الإيجار المقدم",
                        PenaltyAccount: "حساب الغرامات",
                        RentReceivableAccount: "حساب الإيجار المستلم",
                        RentIncomeAccount: "حساب إيراد الإيجار",
                        RemarksInArabic: "ملاحظات باللغة العربية",
                        AddressinArabic: "العنوان باللغة العربية",
                        GovernmentNo: "الرقم الحكومى",
                        BondNumber: "رقم السند",
                        UnderConstruction: "تحت الإنشاء",
                        InActive: "غير نشط",
                        Active: "نشط",
                        Parking: "موقف سيارات",
                        ContractorInArabic: "المقاول باللغة العربية",
                        Contractor: "مقاول",
                        Watchmen: "الحارس",
                        Lessor: "المؤجر",
                        BuildingType: "نوع البناية",
                        History: "تاريخى",
                        ParkingSlots: "أماكن وقوف السيارات",
                        ParkingZones: "مناطق وقوف السيارات",
                        PublishDetails: "نشر التفاصيل",
                        AccountDetails: "تفاصيل الحساب",
                        BasicDetails: "التفاصيل الأساسية",
                        AddBuilding: "إضافة مبنى",
                        Title: "عنوان",
                        IsOnCase: "هل في حالة ؟",
                        FlatType: "نوع الشقة",
                        Residential: "سكني",
                        Commercial: "تجاري",
                        FloorNumber: "رقم الدور",
                        FlatNumber: "رقم الشقة",
                        AddFlatUnit: "إضافة شقة / وحدة",
                        ReceivableBank: "البنك المستلم",
                        PayeeBank: "بنك المستفيد",
                        PaymentStartDate: "تاريخ بدء الدفع",
                        ChequeStartingNo: "رقم بداية الشيك",
                        NoofChequesPayments: "عدد الشيكات / الدفعات",
                        GeneratePayments: "عمل الدفعات",
                        ConfirmSave: "تأكيد الحفظ",
                        POBox: "صندوق البريد",
                        Fax: "فاكس",
                        TelephoneNo: "رقم الهاتف ",
                        Nationality: "الجنسية",
                        LessorCardNo: "رقم بطاقة المؤجر",
                        DetailsOfLessor: "تفاصيل المؤجر",
                        Beneficiary: "المستفيد",
                        CardNo: "رقم البطاقة",
                        PropertyTypesNo: "أنواع العقارات",
                        TenantNameArabic: "اسم المستأجر عربي",
                        TenantName: "اسم المستأجر",
                        DetailsOfTenant: "تفاصيل المستأجر",
                        AmountInWords: "المبلغ بالحروف",
                        LedgerDateBy: "تاريخ الحساب بواسطة",
                        ContractDate: "تاريخ العقد",
                        LastOfMonth: "نهاية الشهر",
                        FirstOfMonth: "بداية الشهر",
                        MonthlyPaymentOn: "الدفع الشهري على",
                        Monthly: "شهريا",
                        Annual: "سنوي",
                        Fulltime: "وقت كامل",
                        SelectFlat: "إختيار الشقة",
                        SelectBuilding: "إختيار المبنى",
                        LesseeNameArabic: "اسم المستأجر عربي",
                        LesseeName: "اسم المستأجر",
                        Terms: "شروط",
                        LesseeLessor: "المستأجر/ المؤجر",
                        PremisesPayment: "دفعة مقدمة",
                        PremisesConditions: "شروط المباني",
                        AddTenancyContract: "إضافة عقد الإيجار",
                        Buildings: "البنايات",
                        AverageRate: "السعرالمتوسط",
                        Floor: "أرضي",
                        Vacant: "شاغر",
                        BuildingSummary: "ملخص المبنى",
                        BuildingTypes: "أنواع المبانى",
                        Flats: "الشقق",
                        Occupied: "مشغول",
                        FlatTypes: "أنواع الشقق",
                        Terminate: "إنهاء",
                        Refund: "استرداد",
                        Termination: "طرد",
                        Both: "كلاهما",
                        Renew: "تجديد",
                        New: "جديد",
                        LoadType: "نوع التحميل",
                        TenancyContracts: "عقود الإيجار",
                        FOCQty: "كمية FOC",
                        TNetWeight: "إجمالي الوزن الصافي",
                        TGrossWeight: "إجمالي الوزن الكلى",
                        DiscValue: "قيمة الخصم",
                        DiscType: "نوع الخصم",
                        OtherCharges: "رسوم أخرى",
                        ExtraCharges: "رسوم إضافية",
                        WareHouse: "مستودع",
                        BalanceQty: " رصيد الكمية",
                        QtyToLink: "الكمية المرتبطة",
                        AvailableQty: "الكمية المتوفرة",
                        LinkedQty: "الكمية المرتبطة",
                        ActualQuantity: "الكمية الفعلية",
                        VoucherLinkingPreview: "عرض الفواتير",
                        LinkVouchers: "ربط الفواتير",
                        NoPendingVouchersFound: "لم يتم العثور على فواتير معلقة!",


                        ApplyUnitPrice: "تطبيق سعر الوحدة",
                        RoundOfVat: " ضريبة القيمة المضافة",
                        TaxValue: "قيمة الضريبة",
                        TaxableAmount: "المبلغ الخاضع للضريبة",
                        ProductAnalysis: "تحليل المنتج",
                        ShowBatchInfo: "عرض معلومات الدفعة",
                        LoadFromPriceChart: "تحميل الرسم البياني للسعر",
                        AnalyseAllPrice: "تحليل جميع الأسعار",
                        AnalyseCustomerPrice: "تحليل سعر العميل",
                        AddedQuantity: "الكمية المضافة",
                        ManufacturingDate: "تاريخ التصنيع",
                        BatchNo: "رقم المجموعة",
                        SaveToList: "حفظ القائمة",
                        ProductBatch: "دفعة المنتج",
                        TotalBalanceAmount: "إجمالي مبلغ الرصيد",
                        UnassignedBillsFound: "تم العثور على فواتير غير مخصصة!",
                        Extra: "إضافي",
                        Percentage: "نسبة مئوية",
                        DeliveryTime: "موعد التسليم",
                        SupplyPlace: "مكان التوريد",
                        TotalNetWeight: "إجمالي الوزن الصافي",
                        TotalGrossWeight: "إجمالي الوزن الكلى",
                        NoOfPackages: "عدد الحزم",
                        Weight: "الوزن",
                        Dimension: "الأبعاد",
                        CustomerPONo: "رقم طلب الشراء الخاص بالعميل",
                        SupplierQTNNo: "رقم المورد QTN",
                        ConcernPerson: "الشخص المعني",
                        Validity: "صلاحية",
                        ReturnTime: "وقت العودة",
                        DueDays: "أيام الاستحقاق",
                        LinkedRefs: "المراجع المرتبطة",
                        Recalculate: "إعادة الحساب",
                        BulkPE: "السائبة بي",
                        VatAmount: "مبلغ ضريبة القيمة المضافة",
                        VATAmount: "مبلغ ضريبة القيمة المضافة",
                        VendorName: "اسم البائع",
                        VendorCode: "رمز البائع",
                        BulkPurchaseEnquiry: "الاستفسار عن الشراء بالجملة",
                        ShowPendingLinking: "عرض في انتظار (ربط)؟",
                        CustomerDetails: "تفاصيل العميل",
                        VoucherDetails: "تفاصيل الفاتورة",
                        Preview: "عرض",
                        IndividualPurchaseInvociePreview: "عرض فاتورة الشراء الفردية",
                        PDCAccountDebit: "حساب الشيكات المؤرخة (مدين)",
                        CreditDebitAccount: "الحساب دائن / مدين",
                        CostLedger: "حساب التكلفة",
                        FilterData: "اختيار البيانات",
                        CounterSales: "مبيعات الكاشير",
                        date: "التاريخ",
                        SelectJobs: "حدد المهام",
                        JobWiseProfit: "ربح المهمة",
                        LossDetails: "تفاصيل الخسائر",
                        CashPaymentReport: "تقرير النقدية المدفوعة",
                        CashReceiptReport: "تقرير النقدية المستلمة",
                        ChequePaymentReport: "تقرير الشيكات المدفوعة",
                        ChequeReceiptReport: "تقرير الشيكات المستلمة",
                        CompanyExpenseReport: "تقرير مصروفات الشركة",
                        CreditNoteReport: "تقرير مذكرة دائنة",
                        DebitNoteReport: "تقرير مذكرة مدينة",
                        FundPaymentReport: "تقرير التحويلات المدفوعة",
                        FundReceiptReport: "تقرير التحويلات المستلمة",
                        JournalVoucherReport: "تقرير القيود اليومية",
                        OpeningBalanceReport: "تقرير الرصيد الافتتاحي",
                        PaymentsReceiptReport: "تقرير المدفوعات والاستلامات",
                        Report: "تقرير",
                        VendorWisePurchaseReport: "تقرير المشتريات لكل مورد",
                        ProductWisePurchaseReport: "تقرير المشتريات لكل منتج",
                        PurchaseReport: "تقرير المشتريات",
                        Pending: "قيد الانتظار",
                        PendingPurchaseReport: " تقرير المشتريات المعلقة",
                        AgingAnalysisReport: "تقرير تحليل فترة الفواتير",
                        BillWiseAging: "فترات الفواتير ",
                        BillWiseAnalysis: "تحليل الفواتير",
                        ListOfOutstanding: "قائمة المعلقات",
                        Keyword: "الكلمة الرئيسية",
                        BillWiseReport: "تقرير بيل وايز",
                        ListOfOutstandingCredit: "قائمة المعلقات (دائن)",
                        ListOfOutstandingDebit: "قائمة المعلقات (مدين)",
                        AgingAnalysis: "تحليل الفترات",
                        ListOfOutstandingBills: "قائمة الفواتير المعلقة",
                        Payables: "الذمم الدائنة",
                        Receivables: "الذمم المدينة",
                        CustomerWiseSalesReport: "تقرير المبيعات للعملاء",
                        OverdueDirectSalesInvoices: "فواتير المبيعات المباشرة المستحقة",
                        OverdueExportSalesInvoices: "تصديرفواتيرالمبيعات المستحقة",
                        OverdueIndividualSalesInvoices: "فواتير المبيعات الفردية المستحقة",
                        OverdueSalesInvoices: "فواتير المبيعات المستحقة",
                        PendingSalesReport: "تقرير المبيعات المعلقة",
                        ProductWiseSalesReport: "تقرير مبيعات المنتج",
                        CustomerWiseSales: "مبيعات العملاء ",
                        ProductWiseSales: "مبيعات المنتج ",
                        SalesReport: "تقرير المبيعات",
                        SalesReports: "تقارير المبيعات",
                        BatchLedger: "دفتر الأستاذ دفعة",
                        InventoryReport: "تقرير المخزون",
                        StockLedger: "حساب المخزون",
                        StockLedgerMultiUnit: "مخزون المنتج",
                        StockList: "قائمة المخزون",
                        StockValuation: "تقييم المخزون",
                        StockMovement: "حركة المخزون",
                        StockLedgerMultiUnit: "حساب المخزون لأكثر من منتج",
                        Print2: "طباعة 1",
                        Print2: "طباعة 2",
                        Print3: "طباعة 3",
                        CarNo: "رقم السيارة",
                        CarName: "اسم السيارة",
                        CustomerHistory: "تاريخ العملاء",
                        CPVs: "فاتورة دفع نقدى",
                        CRVs: "فاتورة إستلام نقدى",
                        ChequePVs: "الشيكات المدفوعة",
                        ChequeRVs: "الشيكات المستلمة",
                        FPVs: "التحويلات المدفوعة",
                        FRVs: "التحويلات المستلمة",
                        JVs: "قيود اليومية",
                        BalanceQuantity: "رصيد الكمية",
                        IndividualSalesInvociePreview: "عرض فاتورة المبيعات الفردية",
                        TCost: "التكلفة الإجمالية",
                        StockFOC: "مخزون FOC",
                        StockJV: "قيد يومية المخزون",
                        Warehouse: "مستودع",
                        Price: "سعر",
                        Issue: "إصدار",
                        Receive: "إستلام",
                        StockReceivePreview: "عرض المخزون المستلم",
                        StockJVPreview: "عرض قيد يومية المخزون",
                        StockIssuePreview: "عرض صرف المخزون",
                        StockFOCPreview: "عرض المخزون",
                        OpeningStockPreview: "عرض المخزون الأفتتاحى",
                        Projects: "المشاريع",
                        Document: "وثيقة",
                        Project: "مشروع",
                        DurationType: "نوع المدة",
                        Minutes: "دقائق)",
                        Hours: "ساعات)",
                        Days: "أيام)",
                        Duration: "مدة",
                        AssignedTo: "مخصص ل",
                        TaskType: "نوع المهمة",
                        TaskTypes: "أنواع المهام",
                        Cancelled: "ألغيت",
                        Completed: "مكتمل",
                        Terminated: "إنتهى",
                        ReasonOfClosing: "سبب الإغلاق",
                        CloseContract: "إغلاق العقد",
                        Closed: "مغلق",
                        Vehicle: "مركبة",
                        NRef: "رقم المرجع ",
                        DailyKMLimit: "الحد اليومي للكيلو مترات",
                        ReturnLocation: "موقع العودة",
                        IsTaxInclusive: "هل شامل الضريبة",
                        Rate: "السعر",
                        Period: "فترة",
                        Weekly: "أسبوعي",
                        Daily: "يوميًا",
                        OrderType: "نوع الطلب",
                        CustomerMobileNo: "رقم جوال العميل",
                        CarContract: "عقد السيارة",
                        CarContractLedger: "حساب عقود السيارات",
                        Acts: "أعمال",
                        Payments: "المدفوعات",
                        FilingDate: "تاريخ التوثيق",
                        FileNo: "رقم الملف",
                        No: "لا",
                        Yes: "نعم",
                        CustomerSupplier: "العميل / المورد",
                        SaveAll: "احفظ الكل",
                        CustomerSupplier: "العميل / المورد؟",
                        Head: "رأس",
                        Body: "جسم",
                        IndividualSalesInvoice: "فاتورة المبيعات الفردية",
                        ExportSalesInvoice: "تصديرفاتورة المبيعات ",
                        ProformaInvoice: "الفاتورة الأولية",
                        PackingList: "قائمة التعبئة",
                        DirectSalesInvoice: "فاتورة المبيعات المباشرة",
                        ExportPurchaseInvoice: "تصديرفاتورة مشتريات",
                        ImportPurchaseInvoice: "إستيراد فاتورة مشتريات",
                        IndividualPurchaseInvoice: "فاتورة الشراء الفردية",
                        DirectPurchaseInvoice: "فاتورة الشراء المباشر",
                        VoucherAccountsLoading: "تحميل حسابات الفاتورة",
                        IsDescriptionMandatory: "هل الوصف إلزامي؟",
                        IsAddressMandatory: "هل العنوان إلزامي؟",
                        IsField20Mandatory: "هل الحقل 20 إلزامي؟",
                        IsField19Mandatory: "هل الحقل 19 إلزامي؟",
                        IsField18Mandatory: "هل الحقل 18 إلزامي؟",
                        IsField17Mandatory: "هل الحقل 17 إلزامي؟",
                        IsField16Mandatory: "هل الحقل 16 إلزامي؟",
                        IsField15Mandatory: "هل الحقل 15 إلزامي؟",
                        IsField14Mandatory: "هل الحقل 14 إلزامي؟",
                        IsField13Mandatory: "هل الحقل 13 إلزامي؟",
                        IsField12Mandatory: "هل الحقل 12 إلزامي؟",
                        IsField11Mandatory: "هل الحقل 11 إلزامي؟",
                        IsField10Mandatory: "هل الحقل 10 إلزامي؟",
                        IsField9Mandatory: "هل الحقل 9 إلزامي؟",
                        IsField8Mandatory: "هل الحقل 8 إلزامي؟",
                        IsField7Mandatory: "هل الحقل 7 إلزامي؟",
                        IsField6Mandatory: "هل الحقل 6 إلزامي؟",
                        IsField5Mandatory: "هل الحقل 5 إلزامي؟",
                        IsField4Mandatory: "هل الحقل 4 إلزامي؟",
                        IsField3Mandatory: "هل الحقل 3 إلزامي؟",
                        IsField2Mandatory: "هل الحقل 2 إلزامي؟",
                        IsField1Mandatory: "هل الحقل 1 إلزامي؟",
                        IsDescription: "هل الوصف؟",
                        IsAddress: "هل العنوان؟",
                        IsField20: "هل الحقل 20؟",
                        IsField19: "هل الحقل 19؟",
                        IsField18: "هل الحقل 18؟",
                        IsField17: "هل الحقل 17؟",
                        IsField16: "هل الحقل 16؟",
                        IsField15: "هل الحقل 15؟",
                        IsField14: "هل الحقل 14؟",
                        IsField13: "هل الحقل 13؟",
                        IsField12: "هل الحقل 12؟",
                        IsField11: "هل الحقل 11؟",
                        IsField10: "هل الحقل 10؟",
                        IsField9: "هل الحقل 9؟",
                        IsField8: "هل الحقل 8؟",
                        IsField7: "هل الحقل 7؟",
                        IsField6: "هل الحقل 6؟",
                        IsField5: "هل الحقل 5؟",
                        IsField4: "هل الحقل 4؟",
                        IsField3: "هل الحقل 3؟",
                        IsField2: "هل الحقل 2؟",
                        IsField1: "هل الحقل 1؟",
                        Field16Date: "الحقل 16 (التاريخ)",
                        Field17Date: "الحقل 17 (التاريخ)",
                        Field18Date: "الحقل 18 (التاريخ)",
                        Field19Date: "الحقل 19 (التاريخ)",
                        Field20Date: "الحقل 20 (التاريخ)",
                        Field11select: "الحقل 11 (اختر)",
                        Field12select: "الحقل 12 (اختر)",
                        Field13select: "الحقل 13 (اختر)",
                        Field14select: "الحقل 14 (اختر)",
                        Field15select: "الحقل 15 (اختر)",
                        Field1: "الحقل 1",
                        Field2: "الحقل 2",
                        Field3: "الحقل 3",
                        Field4: "الحقل 4",
                        Field5: "الحقل 5",
                        Field6: "الحقل 6",
                        Field7: "الحقل 7",
                        Field8: "الحقل 8",
                        Field9: "الحقل 9",
                        Field10: "الحقل 10",
                        CostCenterDesign: "تصميم مراكز التكلفة",
                        IsMaster8: "هل هو رئيسى 8؟",
                        IsMaster7: "هل رئيسى 7؟",
                        IsMaster6: "هل هو رئيسى 6؟",
                        IsMaster5: "هل هو رئيسى 5؟",
                        IsMaster4: "هل هو رئيسى 4؟",
                        IsMaster3: "هل هو رئيسى 3؟",
                        IsMaster2: "هل هو رئيسى 2؟",
                        IsMaster1: "هل رئيسى 1؟",

                        Master8Name: "الاسم الرئيسي 8",
                        Master7Name: "الاسم الرئيسي 7",
                        Master6Name: "الاسم الرئيسي 6",
                        Master5Name: "الاسم الرئيسي 5",
                        Master4Name: "الاسم الرئيسي 4",
                        Master3Name: "الاسم الرئيسي 3",
                        Master2Name: "الاسم الرئيسي 2",
                        Master1Name: "الاسم الرئيسي 1",
                        Master8Field1Name: " الرئيسي 8 اسم الحقل 1",
                        Master7Field1Name: " الرئيسي 7 اسم الحقل 1",
                        Master6Field1Name: " الرئيسي 6 اسم الحقل 1",
                        Master5Field1Name: " الرئيسي 5 اسم الحقل 1",
                        Master4Field1Name: " الرئيسي 4 اسم الحقل 1",
                        Master3Field1Name: " الرئيسي 3 اسم الحقل 1",
                        Master2Field1Name: " الرئيسي 2 اسم الحقل 1",
                        Master1Field1Name: " الرئيسي 1 اسم الحقل 1",
                        Master7Field2Name: " الرئيسي 7 اسم الحقل 2",
                        Master6Field2Name: " الرئيسي 6 اسم الحقل 2",
                        Master5Field2Name: " الرئيسي 5 اسم الحقل 2",
                        Master4Field2Name: " الرئيسي 4 اسم الحقل 2",
                        Master3Field2Name: " الرئيسي 3 اسم الحقل 2",
                        Master2Field2Name: " الرئيسي 2 اسم الحقل 2",
                        Master1Field2Name: " الرئيسي 1 اسم الحقل 2",
                        Master8Field2Name: " الرئيسي 8 اسم الحقل 2",
                        Master8Field3Name: " الرئيسي 8 اسم الحقل 3",
                        Master7Field3Name: " الرئيسي 7 اسم الحقل 3",
                        Master6Field3Name: " الرئيسي 6 اسم الحقل 3",
                        Master5Field3Name: " الرئيسي 5 اسم الحقل 3",
                        Master4Field3Name: " الرئيسي 4 اسم الحقل 3",
                        Master3Field3Name: " الرئيسي 3 اسم الحقل 3",
                        Master2Field3Name: " الرئيسي 2 اسم الحقل 3",
                        Master1Field3Name: " الرئيسي 1 اسم الحقل 3",
                        ExtraMasters: "حقول رئيسية إضافية",
                        Page: "صفحة",
                        SelectPage: "حدد الصفحة",
                        SelectPageGroup: "حدد مجموعة الصفحات",
                        FavouriteLinks: "الروابط المفضلة",
                        YouDonotHaveAccessOnThisPage: "ليس لديك حق الوصول إلى هذه الصفحة",
                        ContactAdminRegardingYourAccess: "اتصل بالمسؤول بخصوص دخولك",
                        GoToDashboard: "الذهاب إلى لوحة العرض",
                        InvoiceCompeleted: "اكتملت الفاتورة",
                        InvoiceSent: "تم إرسال الفاتورة",
                        fromlastmonth: "من الشهر الماضي",
                        Complete: "مكتمل",
                        InvoiceRemaining: "الفاتورة المتبقية",
                        TotalTransactions: "إجمالي القيود",
                        ClickHereToConnect: "انقر هنا للاتصال",
                        Ifyoufaceanytrouble: "إذا واجهت أي مشكلة، فيرجى الاتصال بنا الآن للحصول على الدعم والإصلاحات. وقت الدعم العادي من 9:00 صباحًا إلى 10:00 مساءً.",
                        LookingForSupportConnectUsNow: "تبحث عن الدعم، تواصل معنا الآن",
                        UploadDate: "تاريخ التحميل",
                        ExpiringExpiredDocuments: "منتهية الصلاحية / المستندات منتهية الصلاحية",
                        LatestSaleOrders: "أحدث أوامر البيع",
                        UpdateProfile: "تحديث الملف",
                        TotalQuotations: "مجموع العروض",
                        UnpaidBills: "الفواتير غير المدفوعة",
                        PaidBills: "الفواتير المدفوعة",
                        TotalInvoices: "إجمالي الفواتير",
                        ERPCLOUD: "سحابة تخطيط موارد المؤسسات",
                        Seeallnotifications: "اطلع على جميع الإشعارات",
                        VoucherSettings: "إعدادات الفاتورة",
                        VoucherCostCenters: "مراكز تكلفة الفاتورة",
                        VoucherLinks: "روابط الفاتورة",
                        VoucherDesign: "تصميم الفاتورة",
                        VoucherLoading: "تحميل الفاتورة",
                        TabDesign: "تصميم علامة التبويب",
                        ProductDesign: "تصميم المنتج",
                        CostCenterDesign: "تصميم مراكز التكلفة",
                        VoucherNames: "أسماء الفاتورة",
                        VoucherPrints: "مطبوعات الفاتورة",
                        TableDesign: "تصميم الجدول",
                        ResaveVouchers: "إعادة حفظ الفاتورة",
                        UserRoleMapping: "تعيين دور المستخدم",
                        UserPageRole: "دور صفحة المستخدم",
                        Reminders: "تذكيرات",
                        Hi: "أهلاً،,",
                        Inbox: "صندوق الوارد",
                        SalesDashboard: "لوحة تحكم المبيعات",
                        PurcahseDashboard: "لوحة معلومات المشتريات",
                        FinancialDashboard: "لوحة المعلومات المالية",
                        RealestateDashboard: "لوحة معلومات العقارات",
                        Inventory: "مخزون",
                        ProductType: "نوع المنتج",
                        ProductColor: "لون المنتج",
                        ProductSize: "حجم المنتج",
                        Uploads: "التحميلات",
                        CostCenterUpload: "تحميل مركز التكلفة",
                        CustomerUpload: "تحميل العملاء",
                        ExpenseUpload: "تحميل النفقات",
                        VendorUpload: "تحميل المورد",
                        ProductUpload: "تحميل المنتج",
                        ServiceUpload: "تحميل الخدمة",
                        AssetUpload: "تحميل الأصول",
                        PurchaseEnquiry: "استعلام عن المشتريات",
                        EmployeeAppraisals: "تقييمات الموظفين",
                        CRM: "إدارة علاقات العملاء",
                        Property: "ملكية",
                        FlatType: "نوع الشقة",
                        FlatStatus: "حالة الشقة",
                        TenancyContract: "عقد الايجار",
                        POS: "نقاط البيع",
                        CounterSalesTouch: " مبيعات العداد",
                        Production: "إنتاج",
                        Documents: "وثائق",
                        DocumentsByJob: "المستندات حسب الوظيفة",
                        JobWiseProfitDetails: "تفاصيل الربح لكل صفقة",
                        JobWiseProfit: "الربح لكل صفقة",
                        InventoryReports: "تقارير المخزون",
                        Receipts: "الإيصالات",
                        PurchaseReports: "تقارير المشتريات",
                        MagtecERP: "ماجتيك لتخطيط موارد المؤسسات",
                        AllRightsReserved: "© 2023 جميع الحقوق محفوظة",
                        ReceiptType: "نوع الاستلام",
                        IsSizeMandatory: "هل الحجم إلزامي؟",
                        IsColorMandatory: "هل اللون إجباري؟",
                        IsTypeMasterMandatory: "هل النوع (الرئيسى) إلزامي؟",
                        IsProductBatchMandatory: "هل دفعة المنتج إلزامية؟",
                        IsSupplierMandatory: "هل المورد إلزامي؟",
                        IsBrandMandatory: "هل العلامة التجارية إلزامية؟",
                        IsSubCategoryMandatory: "هل الفئة الفرعية إلزامية؟",

                        IsCategoryMandatory: "هل الفئة إلزامية؟",
                        IsPurchaseAccountMandatory: "هل حساب المشتريات إلزامي؟",
                        IsSalesAccountMandatory: "هل حساب المبيعات إلزامي؟",
                        IsVATMandatory: "هل ضريبة القيمة المضافة إلزامية؟",
                        IsCountryMandatory: "هل البلد إلزامية؟",
                        IsUnitMandatory: "هل الوحدة إلزامية؟",
                        IsHSCodeMandatory: "هل رمز النظام المنسق إلزامي؟",
                        IsWeightMandatory: "هل الوزن إجباري؟",
                        IsStockMandatory: "هل المخزون إلزامي؟",
                        IsManufacturingMandatory: "هل التصنيع إجباري؟",
                        IsYRRefNoMandatory: "هل المرجع السنوى إلزاميًا؟",
                        IsVatTypeMandatory: "هل نوع ضريبة القيمة المضافة إلزامي؟",
                        IsShowPosCheckMandatory: "هل إظهار التحقق من نقاط البيع إلزامي؟",
                        IsWarrantyDateMandatory: "هل تاريخ الضمان إلزامي؟",
                        IsDescriptionMandatory: "هل الوصف إلزامي؟",
                        IsAveragePriceMandatory: "هل متوسط السعر إلزامي؟",
                        IsPurchasePriceMandatory: "هل سعر الشراء إلزامي؟",
                        IsSellPriceMandatory: "هل سعر البيع إلزامي؟",
                        IsAMCCompanyMandatory: "هل شركة AMC إلزامية؟",
                        IsDepreciationYearMandatory: "هل سنة الإهلاك إلزامية؟",
                        IsSupplierMandatory: "هل المورد إلزامي؟",
                        IsModelMandatory: "هل النموذج إجباري؟",
                        IsProductTypeMandatory: "هل نوع المنتج إلزامي؟",
                        IsImageMandatory: "هل الصورة إلزامية؟",
                        IsSpecificationMandatory: "هل المواصفات إلزامية؟",
                        IsBarcodeMandatory: "هل الباركود إلزامي؟",
                        IsNameArabicMandatory: "هل الاسم العربي إلزامي؟",
                        IsNameMandatory: "هل الاسم إلزامي؟",
                        IsProductCodeMandatory: "هل رمز المنتج إلزامي؟",
                        IsSizeToMain: "هل الحجم هو الرئيسي؟",
                        IsColorToMain: "هل اللون هو الرئيسي؟",
                        IsTypeMasterToMain: "هل النوع الرئيسي؟ ",
                        IsProductBatchToMain: "هل دفعة المنتج إلى الرئيسية؟",
                        IsSupplierToMain: "هل المورد إلى الرئيسي؟",
                        IsBrandToMain: "هل العلامة التجارية إلى الرئيسية؟",
                        IsSubCategoryToMain: "هل الفئة الفرعية إلى الرئيسية؟",
                        IsCategoryToMain: "هل الفئة إلى الرئيسية؟",
                        IsPurchaseAccountToMain: "هل حساب المشتريات رئيسي؟",
                        IsSalesAccountToMain: "هل حساب المبيعات رئيسي؟",
                        IsVATToMain: "هل ضريبة القيمة المضافة هي الرئيسية؟",
                        IsCountryToMain: "هل الدولة رئيسية؟",
                        IsUnitToMain: "هل الوحدة رئيسية؟",
                        IsHSCodeToMain: "هل رمز النظام المنسق هو الرئيسي؟",
                        IsWeightToMain: "هل الوزن رئيسي؟",
                        IsStockToMain: "هل المخزون رئيسي؟",
                        IsManufacturingToMain: "هل التصنيع رئيسي؟",
                        IsYRRefNoToMain: "هل رقم المرجع السنوى رئيسي؟",
                        IsVatTypeToMain: "هل نوع ضريبة القيمة المضافة رئيسي؟",
                        IsShowPosCheckToMain: "هل يتم إظهار التحقق من نقاط البيع فى الصفحة الرئيسية؟",
                        IsWarrantyDateToMain: "هل تاريخ الضمان رئيسي؟",
                        IsDescriptionToMain: "هل الوصف رئيسي؟",
                        IsAveragePriceToMain: "هل متوسط السعر رئيسي؟",
                        IsPurchasePriceToMain: "هل سعر الشراء رئيسي؟",
                        IsSellPriceToMain: "هل سعر البيع رئيسي؟",
                        IsAMCCompanyToMain: "هل شركة AMC إلى الرئيسية؟",
                        IsDepreciationYearToMain: "هل سنة الاستهلاك رئيسية؟",
                        IsSupplierToMain: "هل المورد رئيسي؟",
                        IsModelToMain: "هل النموذج رئيسي؟",
                        IsProductTypeToMain: "هل نوع المنتج رئيسي؟",
                        IsImageToMain: "هل الصورة رئيسية؟",
                        IsSpecificationToMain: "هل المواصفات رئيسية؟",
                        IsBarcodeToMain: "هل الباركود رئيسي؟",
                        IsNameArabicToMain: "هل الاسم عربي رئيسي؟",
                        IsNameToMain: "هل الاسم رئيسي؟",
                        IsProductCodeToMain: "هل رمز المنتج رئيسي؟",
                        Defaults: "الافتراضيات",
                        SMS: "رسالة قصيرة",
                        UnlockVouchers: "فتح الفواتير",
                        TryPOSPrint: "حاول طباعة نقاط البيع",
                        ServerApiPath: "مسار واجهة برمجة تطبيقات الخادم",
                        ApiUrl: "عنوان URL لواجهة برمجة التطبيقات",
                        BlockBillWise: "إغلاق الفاتورة؟",
                        IsSalesInventoryPosting: "هل يتم ترحيل مخزون المبيعات؟",
                        RoundOffPoints: "نقاط التقريب",
                        LinewiseGL: "خط الحكيم GL؟",
                        ApprovalNeeded: "مطلوب التأكيد؟",
                        IsOtpLogin: "هل تسجيل الدخول لمرة واحدة؟",
                        Fashion: "موضة",
                        Maintenance: "صيانة",
                        Consultancy: "الاستشارات",
                        Garage: "كراج",
                        Salon: "صالون",
                        Perfume: "عطر",
                        Construction: "بناء",
                        Transportation: "مواصلات",
                        FoodStuff: "المواد الغذائية",
                        RentACar: "استئجار سيارة",
                        Supermarket: "سوبر ماركت",
                        Restaurant: "مطعم",
                        RealEstate: "العقارات",
                        Trading: "تجارة",
                        TypeOfBusiness: "نوع  الأعمال؟",
                        SalesAccountFromProduct: "حساب المبيعات المنتج؟",
                        PurchaseAccountFromProduct: " حساب المشتريات من المنتج؟",
                        IsLineWiseMaturityDate: "هل تاريخ استحقاق ؟",
                        IsDNStockAffect: "هل يؤثر مخزون DN؟",
                        IsGRNStockAffect: "هل يؤثر مخزون GRN؟",
                        HideBalanceCalculation: "إخفاء حساب الرصيد؟",
                        IsProductRemarksCopy: "هل ملاحظات المنتج نسخة؟",
                        IsAutoProductCode: "هل رمز المنتج تلقائي؟",
                        IsBlockMultiProductInVoucher: "هل يتم حظر المنتجات المتعددة في الفاتورة؟",
                        IsSpareParts: "هل قطع غيار؟",
                        IsRentACar: "هل استئجار سيارة؟",
                        IsRealEstate: "هل العقارات؟",
                        IsAutoBatchNo: "هل رقم الدفعة التلقائية ؟",
                        IsProductBatch: "هل دفعة المنتج؟",
                        IsPriceChart: "هل الرسم البياني للسعر؟",
                        IsProduction: "هل الإنتاج؟",
                        IsStock: "هل المخزون؟",
                        IsRecipe: "هل الوصفة؟",
                        IsAdvocate: "هل المحامي؟",
                        IsBranch: "هل فرع؟",
                        HideVAT: "إخفاء ضريبة القيمة المضافة؟",
                        IsHR: "هل الموارد البشرية؟",
                        NoOfPrintCopy: "عدد النسخ المطبوعة",
                        PrinterName: "اسم الطابعة",
                        NeedKOT: "هل تحتاج إلى KOT؟",
                        NeedTask: "هل تحتاج إلى مهمة؟",
                        NeedCRM: "هل تحتاج إلى إدارة علاقات العملاء؟",
                        NeedPOS: "هل تحتاج إلى نقاط البيع؟",
                        SalesReturnQ: "عائد المبيعات؟",
                        PorformaInvoiceQ: "فاتورة أولية؟",
                        IndividualSalesInvoiceQ: "فاتورة المبيعات الفردية؟",
                        DirectSalesInvoiceQ: "فاتورة المبيعات المباشرة؟",
                        ExportSalesInvoiceQ: "تصديرفاتورة المبيعات ؟",
                        SalesInvoiceQ: "فاتورة المبيعات؟",
                        DeliveryNoteQ: "مذكرة تسليم؟",
                        PackingListQ: "قائمة التعبئة؟",
                        SalesOrderQ: "طلب المبيعات؟",
                        SalesQuotationQ: "عرض المبيعات؟",
                        SalesEnquiryQ: "إستعلام عن المبيعات؟",
                        PurchaseReturnQ: "مردودات المشتريات؟",
                        PurchaseRequestQ: "طلب مشتريات؟",
                        PurchaseEnquiryQ: "استفسار عن المشتريات؟",
                        PurchaseQuotationQ: "عرض أسعار المشتريات؟",
                        PurchaseOrderQ: "أمر شراء؟",
                        GoodsReceivedQ: " البضائع المستلمة؟",
                        PurchaseInvoiceQ: "فاتورة الشراء؟",
                        DirPurchaseInvoiceQ: "فاتورة الشراء المباشر؟",
                        ImpPurchaseInvoiceQ: "استيراد فاتورة الشراء؟",
                        IndPurchaseInvoiceQ: "فاتورة الشراء الفردية؟",
                        ExpPurchaseInvoiceQ: "تصدير فاتورة الشراء؟",
                        SenderNameAs: "اسم المرسل باسم",
                        EmailUsername: "اسم مستخدم البريد الإلكتروني",
                        EmailPassword: "كلمة مرور البريد الإلكتروني",
                        IsCostCenterNameWithCode: "هل اسم مركز التكلفة مع الرمز؟",
                        LoadCustomer: "تحميل العميل",
                        SupplierTogether: "المورد معا؟",
                        JobwiseStartingVoucher: "قسيمة البدء في العمل",


                        VatAccountTypeCostCenterGroup: "نوع حساب ضريبة القيمة المضافة مجموعة مركز التكلفة",
                        TaxCategoryCostCenterGroup: "فئة الضريبة مجموعة مركز التكلفة",
                        VatStateEmirateCostCenterGroup: "دولة ضريبة القيمة المضافة / مجموعة مركز تكلفة الإمارة",
                        VatCountryCostCenterGroup: "مجموعة مركز تكلفة ضريبة القيمة المضافة",
                        ExpenseAccountType: "نوع حساب المصاريف",
                        VendorAccountType: "نوع حساب المورد",
                        CustomerAccountType: "نوع حساب العميل",
                        DefaultExpenseAccountHead: " حساب النفقات الرئيسى الافتراضي",
                        DefaultVendorAccountHead: " حساب البائع الرئيسى الافتراضي",
                        DefaultCustomerAccountHead: " حساب العميل الرئيسى الافتراضي",
                        DefaultCustomer: "العميل الافتراضي",
                        MaxUnit: "أقصى وحدة ",
                        DefaultUnitDefaultProduct: "الوحدة الافتراضية",
                        DefaultVATType: "نوع ضريبة القيمة المضافة الافتراضي",
                        BankDetails: "التفاصيل المصرفية",
                        ResaveAll: "إعادة حفظ الكل",
                        VoucherCount: "عدد الفواتير",
                        Hold: "أحتفظ",
                        Skip: "تخطى",
                        PckingCharges: "رسوم التعبئة",
                        DeliveryCharges: "رسوم التوصيل",
                        DutyCharges: "رسوم الواجب",
                        ClearingCharges: "رسوم المقاصة",
                        FreightCharges: "رسوم الشحن",
                        Master8: "رئيسى 8",
                        Master7: "رئيسى 7",
                        Master6: "رئيسى 6",
                        Master5: "رئيسى 5",
                        Master4: "رئيسى 4",
                        Master3: "رئيسى 3",
                        Master2: "رئيسى 2",
                        Master1: "رئيسى 1",
                        Field20: "الحقل 20",
                        Field19: "الحقل 19",
                        Field18: "المجال 18",
                        Field17: "المجال 17",
                        Field16: "الحقل 16",
                        Field15: "الحقل 15",
                        Field14: "الحقل 14",
                        Field13: "الحقل 13",
                        Field12: "الحقل 12",
                        Field11: "الحقل 11",
                        Field10: "الحقل 10",
                        Field9: "الحقل 9",
                        Field8: "الحقل 8",
                        Field7: "الحقل 7",
                        Field6: "الحقل 6",
                        Field5: "الحقل 5",
                        Field4: "الحقل 4",
                        Field3: "الحقل 3",
                        Field2: "الحقل 2",
                        Field1: "الحقل 1",
                        DiscountType: "Discount Type",
                        DiscountValue: "قيمة الخصم",
                        QCost: " تكلفة الكمية",
                        TCost: "تكلفة ",
                        Cost: "التكلفة",
                        Manuf: "مصنع",
                        YRRef: " المرجع السنوى",
                        TableFields: "حقول الجدول",
                        CustomerPO: "  طلب شراء العميل ",
                        SupplierPO: "طلب الشراء للمورد",
                        EndLetter: "نهاية الرسالة",
                        IntroLetter: "رسالة مقدمة",
                        CreditDebit: "دائن / مدين",
                        Excel: "اكسل",
                        AddressButton: "زر العنوان",
                        POSSales: "مبيعات نقاط البيع",
                        SupplierNo: "رقم المورد",
                        PackingCharges: "رسوم التعبئة",
                        put: "يضع",
                        symboltoincreasethecolumnwidth: "رمز لزيادة عرض العمود",
                        Copy: "نسخ",
                        Paste: "طبع",
                        CanDelete: "يمكن حذف",
                        CanPrint: "يمكن الطباعة",
                        CanView: "يمكن أن يشاهد",
                        CanEdit: "يمكن تعديل",
                        CanAdd: "يمكن إضافة",
                        CanAccess: "يمكن الوصول",
                        PageGroup: "مجموعة الصفحات",
                        RemoveCompleteAccess: "إزالة الوصول الكامل",
                        SetCompleteAccess: "تعيين الوصول الكامل",
                        MoveFirst: "التحرك أولا؟",
                        VatGroup: "مجموعة ضريبة القيمة المضافة؟",
                        MandatoryQ: "إلزامي؟",
                        VisibleQ: "مرئي؟",
                        VoucherType: "نوع الفاتورة",
                        MoveToFirstSession: "الانتقال إلى الجلسة الأولى؟",
                        VoucherCostCenterSettings: "إعدادات مركز تكلفة الفاتورة",
                        MandatoryMaster8: "رئيسى إلزامي 8",
                        MandatoryMaster7: "رئيسى إلزامي 7",
                        MandatoryMaster6: "رئيسى إلزامي 6",
                        MandatoryMaster5: "رئيسى إلزامي 5",
                        MandatoryMaster4: "رئيسى إلزامي 4",
                        MandatoryMaster3: "رئيسى إلزامي 3",
                        MandatoryMaster2: "رئيسى إلزامي 2",
                        MandatoryMaster1: "رئيسى إلزامي 1",
                        MandatoryField20: "الحقل الإلزامي 20",
                        MandatoryField19: "الحقل الإلزامي 19",
                        MandatoryField18: "الحقل الإلزامي 18",
                        MandatoryField17: "الحقل الإلزامي 17",
                        MandatoryField16: "الحقل الإلزامي 16",
                        MandatoryField15: "الحقل الإلزامي 15",
                        MandatoryField14: "الحقل الإلزامي 14",
                        MandatoryField13: "الحقل الإلزامي 13",
                        MandatoryField12: "الحقل الإلزامي 12",
                        MandatoryField11: "الحقل الإلزامي 11",
                        MandatoryField10: "الحقل الإلزامي 10",
                        MandatoryField9: "الحقل الإلزامي 9",
                        MandatoryField8: "الحقل الإلزامي 8",
                        MandatoryField7: "الحقل الإلزامي 7",
                        MandatoryField6: "الحقل الإلزامي 6",
                        MandatoryField5: "الحقل الإلزامي 5",
                        MandatoryField4: "الحقل الإلزامي 4",
                        MandatoryField3: "الحقل الإلزامي 3",
                        MandatoryField2: "الحقل الإلزامي 2",
                        MandatoryField1: "الحقل الإلزامي 1",
                        EnableField20: "تمكين الحقل 20",
                        EnableField19: "تمكين الحقل 19",
                        EnableField18: "تمكين الحقل 18",
                        EnableField17: "تمكين الحقل 17",
                        EnableField16: "تمكين الحقل 16",
                        EnableField15: "تمكين الحقل 15",
                        EnableField14: "تمكين الحقل 14",
                        EnableField13: "تمكين الحقل 13",
                        EnableField12: "تمكين الحقل 12",
                        EnableField11: "تمكين الحقل 11",
                        EnableField10: "تمكين الحقل 10",
                        EnableField9: "تمكين الحقل 9",
                        EnableField8: "تمكين الحقل 8",
                        EnableField7: "تمكين الحقل 7",
                        EnableField6: "تمكين الحقل 6",
                        EnableField5: "تمكين الحقل 5",
                        EnableField4: "تمكين الحقل 4",
                        EnableField3: "تمكين الحقل 3",
                        EnableField2: "تمكين الحقل 2",
                        EnableField1: "تمكين الحقل 1",
                        Field20NameDate: "(الحقل 20 الاسم (التاريخ",
                        Field19NameDate: "(الحقل 19 الاسم (التاريخ",
                        Field18NameDate: "(الحقل 18 الاسم (التاريخ",
                        Field17NameDate: "(الحقل 17 الاسم (التاريخ",
                        Field16NameDate: "(الحقل 16 الاسم (التاريخ",
                        Field15NameDate: "(الحقل 15 الاسم (التاريخ",
                        Field14NameDate: "(الحقل 14 الاسم (التاريخ",
                        Field13NameDate: "(الحقل 13 الاسم (التاريخ",
                        Field12NameDate: "(الحقل 12 الاسم (التاريخ",
                        Field11NameDate: "(الحقل 11 الاسم (التاريخ",
                        Field10NameDate: "(الحقل 10 الاسم (التاريخ",
                        Field9NameDate: "(الحقل 9 الاسم (التاريخ",
                        Field8NameDate: "(الحقل 8 الاسم (التاريخ",
                        Field7NameDate: "(الحقل 7 الاسم (التاريخ",
                        Field6NameDate: "(الحقل 6 الاسم (التاريخ",
                        Field5NameDate: "(الحقل 5 الاسم (التاريخ",
                        Field4NameDate: "(الحقل 4 الاسم (التاريخ",
                        Field3NameDate: "(الحقل 3 الاسم (التاريخ",
                        Field2NameDate: "(الحقل 2 الاسم (التاريخ",
                        Field1NameDate: "(الحقل 1 الاسم (التاريخ",
                        Field14NameSelect: "(اسم الحقل 14 (اختر",
                        Field15NameSelect: "(اسم الحقل 15 (اختر",
                        Field13NameSelect: "(اسم الحقل 13 (اختر",
                        Field12NameSelect: "(اسم الحقل 12 (اختر",
                        Field11NameSelect: "(اسم الحقل 11 (اختر",
                        Field10Name: "اسم الحقل 10",
                        Field9Name: "اسم الحقل 9",
                        Field8Name: "اسم الحقل 8",
                        Field7Name: "اسم الحقل 7",
                        Field6Name: "اسم الحقل 6",
                        Field5Name: "اسم الحقل 5",
                        Field4Name: "اسم الحقل 4",
                        Field3Name: "اسم الحقل 3",
                        Field2Name: "اسم الحقل 2",
                        Field1Name: "اسم الحقل 1",
                        EnableMoreBodyFields: "تمكين المزيد من حقول الجسم",
                        Master5ToMainScreen: "سيد 5 إلى الشاشة الرئيسية",
                        Master4ToMainScreen: "سيد 4 إلى الشاشة الرئيسية",
                        Master3ToMainScreen: "سيد 3 إلى الشاشة الرئيسية",
                        Master2ToMainScreen: "سيد 2 إلى الشاشة الرئيسية",
                        Master1ToMainScreen: "سيد 1 إلى الشاشة الرئيسية",
                        Field20ToMainScreen: "الحقل 20 إلى الشاشة الرئيسية",
                        Field19ToMainScreen: "الحقل 19 إلى الشاشة الرئيسية",
                        Field18ToMainScreen: "الحقل 18 إلى الشاشة الرئيسية",
                        Field17ToMainScreen: "الحقل 17 إلى الشاشة الرئيسية",
                        Field16ToMainScreen: "الحقل 16 إلى الشاشة الرئيسية",
                        Field15ToMainScreen: "الحقل 15 إلى الشاشة الرئيسية",
                        Field14ToMainScreen: "الحقل 14 إلى الشاشة الرئيسية",
                        Field13ToMainScreen: "الحقل 13 إلى الشاشة الرئيسية",
                        Field12ToMainScreen: "الحقل 12 إلى الشاشة الرئيسية",
                        Field11ToMainScreen: "الحقل 11 إلى الشاشة الرئيسية",
                        Field10ToMainScreen: "الحقل 10 إلى الشاشة الرئيسية",
                        Field9ToMainScreen: "الحقل 9 إلى الشاشة الرئيسية",
                        Field8ToMainScreen: "الحقل 8 إلى الشاشة الرئيسية",
                        Field7ToMainScreen: "الحقل 7 إلى الشاشة الرئيسية",
                        Field6ToMainScreen: "الحقل 6 إلى الشاشة الرئيسية",
                        Field5ToMainScreen: "الحقل 5 إلى الشاشة الرئيسية",
                        Field4ToMainScreen: "الحقل 4 إلى الشاشة الرئيسية",
                        Field3ToMainScreen: "الحقل 3 إلى الشاشة الرئيسية",
                        Field2ToMainScreen: "الحقل 2 إلى الشاشة الرئيسية",
                        Field1ToMainScreen: "الحقل 1 إلى الشاشة الرئيسية",
                        EnableMoreFields: "تمكين المزيد من الحقول",
                        EnableFocQuantity: "تمكين الكمية المعفاة من الرسوم",
                        EnableTotalGrossWeight: "تمكين إجمالي الوزن",
                        EnableTotalNetWeight: "تمكين الوزن الصافي الإجمالي",
                        EnableGrossWeight: "تمكين الوزن الإجمالي",
                        EnableNetWeight: "تمكين الوزن الصافي",
                        EnableProductWeightFields: "تمكين حقول وزن المنتج",
                        EnableCalculationWithVAT: "تمكين الحساب مع ضريبة القيمة المضافة",
                        CustomsDutyCharges: " الرسوم الجمركية",
                        EnableDirectAccountPosting: "تمكين الترحيل المباشر للحساب",
                        PackingChargesPI: "رسوم التعبئة (PI)",
                        DeliveryChargesIPI: "رسوم التوصيل (IPI)",
                        DutyChargesIPI: "رسوم الخدمة (IPI)",
                        ClearingChargesIPI: "رسوم المقاصة (IPI)",
                        FreightChargesPIIPI: "رسوم الشحن (PI وIPI)",
                        PurchaseInvoiceImprotPurchaseInvoiceOnly: "فاتورة الشراء / استيراد فاتورة الشراء فقط",
                        ApplyShippingFormula: "تطبيق صيغة الشحن",
                        UnlockDiscount: "فتح الخصم",
                        BonusLabel: "إسم المكافأة",
                        QCostLabel: "إسم تكلفة Q",
                        TCostLabel: "إسم تكلفة T",
                        StockLabel: "إسم الأسهم",
                        ManufLabel: "إسم المصنع",
                        YrRefLabel: "تسمية المرجع السنوى",
                        Stockselect: "(المخزون (اختر",
                        ManufNoselect: "(رقم التصنيع (اختر",
                        YrRefText: "(مرجع سنوى (نص",
                        EnableTableFields: "تمكين حقول الجدول",
                        SupplierPONoToMainScreen: " رقم أمرشراء المورد إلى الشاشة الرئيسية",
                        CustomerPONoToMainScreen: "رقم طلب العميل على الشاشة الرئيسية",
                        SalesEmployeeToMainScreen: "موظف المبيعات إلى الشاشة الرئيسية",
                        SupplierBillDateToMainScreen: "تاريخ فاتورة المورد إلى الشاشة الرئيسية",

                        ReturnTimeToMainScreen: "وقت العودة إلى الشاشة الرئيسية",
                        ReturnDateToMainScreen: "تاريخ العودة إلى الشاشة الرئيسية",
                        DeliveryTimeToMainScreen: "وقت التسليم إلى الشاشة الرئيسية",
                        DeliveryDateToMainScreen: "تاريخ التسليم إلى الشاشة الرئيسية",
                        PaymentTermsToMainScreen: "شروط الدفع للشاشة الرئيسية",
                        WarrentyPeriodToMainScreen: "فترة الضمان للشاشة الرئيسية",
                        DelieveryPeriodToMainScreen: "فترة التسليم إلى الشاشة الرئيسية",
                        DeliveryBasisToMainScreen: "قواعد التسليم إلى الشاشة الرئيسية",
                        WarrentyPeriod: "فترة الضمان",
                        OrderNoToMainScreen: "رقم الطلب للشاشة الرئيسية",
                        EnquiryNoToMainScreen: "رقم الإستفسار إلى الشاشة الرئيسية",
                        NetWeightToMainScreen: "الوزن الصافي للشاشة الرئيسية",
                        GrossWeightToMainScreen: "الوزن الإجمالي للشاشة الرئيسية",
                        WeightToMainScreen: "الوزن إلى الشاشة الرئيسية",
                        NoOfPackagesToMainScreen: "عدد الحزم إلى الشاشة الرئيسية",
                        SupplierQtnNoToMainScreen: "رقم كمية المورد للشاشة الرئيسية",
                        SupplierBillNoToMainScreen: "رقم فاتورة المورد  للشاشة الرئيسية",
                        ShippingAddressToMainScreen: "عنوان الشحن إلى الشاشة الرئيسية",
                        PlaceOfSupplyToMainScreen: "مكان التوريد للشاشة الرئيسية",
                        ConcernPersonToMainScreen: "الشخص المعني إلى الشاشة الرئيسية",
                        ValidityToMainScreen: "صلاحية الشاشة الرئيسية",
                        IntroLetterToMainScreen: "رسالة مقدمة إلى الشاشة الرئيسية",
                        EndLetterToMainScreen: "نهاية الرسالة إلى الشاشة الرئيسية",
                        EnableHeaderFields: "تمكين حقول الرأسية",
                        CustomerMapQ: "خريطة العملاء؟",
                        QcostLink: "رابط التكلفة ",
                        EnableQ: "يُمكَن؟",
                        IsMultipleQ: "هل متعددة؟",
                        LinkName: "اسم الرابط",
                        IsCustomerMap: "هي خريطة العملاء",
                        VoucherLink: "رابط الفاتورة",
                        VoucherLinkSettings: "إعدادات رابط الفاتورة",
                        SalesReturnName: "اسم  مردودات المبيعات",
                        IndividualSalesInvoiceName: "اسم فاتورة المبيعات الفردية",
                        ProformaInvoiceName: "اسم الفاتورة الأولية",
                        ExportSalesInvoiceName: "تصدير اسم فاتورة المبيعات",
                        DirectSalesInvoiceName: "اسم فاتورة المبيعات المباشرة",
                        SalesInvoiceName: "اسم مذكرة تسليم فاتورة المبيعات",
                        DeliveryNoteName: "DeliveryNoteName",
                        PackingListName: "اسم قائمة التعبئة",
                        SalesOrderName: "اسم أمر المبيعات",
                        SalesQuotationName: "اسم عرض أسعار المبيعات",
                        SalesEnquiryName: "اسم الاستعلام عن المبيعات",
                        PurchaseReturnName: "اسم مردودات المشتريات",
                        IndividualPurchaseInvoiceName: "اسم فاتورة المشتريات الفردية",
                        ImportPurchaseInvoiceName: "استيراد اسم فاتورة المشتريات",
                        ExportPurchaseInvoiceName: "تصدير اسم فاتورة المشتريات",
                        DirectPurchaseInvoiceName: "اسم فاتورة المشتريات المباشرة",
                        PurchaseInvoiceName: "اسم فاتورة المشتريات",
                        GoodsReceivedName: "اسم البضائع المستلمة",
                        PurchaseOrderName: "اسم أمر الشراء",
                        PurchaseQuotationName: "اسم عرض أسعار الشراء",
                        PurchaseRequestName: "اسم طلب الشراء",
                        DownloadFile: "تحميل الملف",
                        IsField5N: "هو المجال 5 -ve",
                        IsField4N: "هو المجال 4 -ve",
                        IsField3N: "هو المجال 3 -ve",
                        IsField2N: "هو المجال 2 -ve",
                        IsField1N: "هو الحقل 1 -ve",
                        Field5Account: "حساب الحقل 5",
                        Field4Account: "حساب الحقل 4",
                        Field3Account: "حساب الحقل 3",
                        Field2Account: "حساب الحقل 2",
                        Field1Account: "حساب الحقل 1",
                        StockProduction: " مخزون الأنتاج",
                        DiscountAccount: "حساب الخصم",
                        Net: "شبكة",
                        Stock: "مخزون",
                        DiscountPostingType: "نوع ترحيل الخصم",
                        EnableDiscountPosting: "تمكين ترحيل الخصم",
                        DiscountPosting: "ترحيل الخصم",
                        DefaultProduct: "المنتج الافتراضي",
                        DistributionType: "نوع التوزيع",
                        EnableCostPostingQ: "هل تريد تفعيل ترحيل التكلفة؟",
                        EnableInventoryPostingQ: "تمكين ترحيل المخزون؟",
                        EnableAccountPostingQ: "تمكين ترحيل الحساب؟",
                        BlockNegativeStockQ: "منع المخزون السالب؟",
                        AllowZeroProductPriceQ: "السماح بسعر المنتج الصفري؟",
                        ExtraChargesReversalAccount: "حساب عكس الرسوم الإضافية",
                        ExtraChargesAccount: "حساب الرسوم الإضافية",
                        PackingChargesAccount: "حساب رسوم التعبئة",
                        OtherChargesAccount: "حساب الرسوم الأخرى",
                        FreightChargesAccount: "حساب رسوم الشحن",
                        DeliveryChargesAccount: "حساب رسوم التوصيل",
                        CustomsDutyAccount: "حساب الرسوم الجمركية",
                        ClearingChargesAccount: "حساب رسوم المقاصة",
                        CostcenterAuto: "(مركز التكلفة (تلقائي",
                        COGSExpenseAccount: "تكلفة البضاعة المباعة / حساب النفقات",
                        InventoryAccount: "حساب المخزون",
                        OutputVATAccount: "حساب ضريبة المخرجات",
                        InputVATAccount: "حساب ضريبة المدخلات",
                        VoucherAccountSettings: "إعدادات حساب الفاتورة",


                        ApplyLeave: "تطبيق الإجازة",
                        AssignedLeaves: "الأوراق المخصصة",
                        AvailableLeaves: "Available Leaves",
                        TotalDays: "مجموع الأيام",
                        Component: "عنصر",
                        Month: "شهر",
                        Year: "سنة",
                        Deductions: "الخصومات",
                        Earnings: "الإيرادات",
                        OtherDeduction: "خصم آخر",
                        TelephoneDeduction: "خصم الهاتف",
                        Salik: "سالك",
                        Fines: "الغرامات",
                        SalaryAdvance: "سلفه على الراتب",
                        AirFare: "أجرة الطيران",
                        Arrears: "المتأخرات",
                        Transport: "ينقل",
                        Food: "طعام",
                        HRA: "HRA",
                        UploadFile: "رفع ملف",
                        EmployeeLeaveLedger: "حساب إجازات الموظف",
                        Leaves: "أوراق",
                        LeaveAllocation: "مكان الإجازة",
                        Loans: "القروض",
                        TotalFine: "إجمالي الغرامة",
                        Fine: "غرامة",
                        TotalWorking: "العمل الإجمالي",
                        TotalOverTime: "إجمالي الوقت الإضافى",
                        TotalHours: "إجمالي الساعات",
                        Approved: "موافقة",
                        Rejected: "مرفوض",
                        UpdateResignationStaus: "تحديث حالة الاستقالة",
                        ApprovedEndDate: "تاريخ الانتهاء المعتمد",
                        ApprovedStartDate: "تاريخ البدء المعتمد",
                        UpdateVacationStaus: "تحديث حالة الإجازة",
                        Response: "إجابة",
                        UpdateWarning: "تحذير التحديث",
                        Exchange: "تبادل",

                        NetworkError: "خطأ في الشبكة",
                        YouDontHaveAccessToDeleteData: "ليس لديك حق الوصول لحذف البيانات، يرجى الاتصال بالمسؤول",
                        YouDontHaveAccessToViewData: "ليس لديك حق الوصول لعرض البيانات، يرجى الاتصال بالمسؤول",
                        YouDontHaveAccessToEditData: "ليس لديك حق الوصول لتحرير البيانات، يرجى الاتصال بالمسؤول",
                        YouDontHaveAccessToAddData: "ليس لديك حق الوصول لإضافة البيانات، يرجى الاتصال بالمسؤول",
                        InvalidDetails: "تفاصيل غير صالحة",
                        SelectAccount: "حدد حساب",
                        CostCenterNotSelectedFor: "مركز التكلفة غير محدد لـ:",
                        NetworkErrorWhileLoadingAccountSettings: "حدث خطأ في الشبكة أثناء تحميل إعدادات الحساب",
                        AccountNotFound: "الحساب غير موجود",
                        EnterDetails: "أدخل التفاصيل",
                        AmountexeedingValueswillreset: "تنفيذ المبلغ، سيتم إعادة ضبط القيم",
                        ErrorLoadingBills: "حدث خطأ أثناء تحميل الفواتير",
                        SelectCustomerCity: "حدد مدينة العميل",
                        EnterCustomerMobileNo: "أدخل رقم جوال العميل",
                        EnterCustomerName: "أدخل اسم العميل",
                        SelectLeadSource: "حدد مصدرالعميل",
                        SelectLeadType: "حدد نوع العميل المتوقع",
                        SelectEmployee: "حدد الموظف",
                        EntertheName: "أدخل الاسم",
                        PlannedMeetingDate: "تاريخ الاجتماع المخطط له",
                        RefNo: "رقم المصدر ",
                        TopVendorsByPurchase: "أعلى الموردين حسب المشتريات",
                        MostPurchasingItems: "العناصر الأكثر شراءًا",
                        MonthlyPurchase: "الشراء الشهري",
                        MostPurchasingGroups: "معظم مجموعات المشتريات",
                        SalesPurchaseAnalysis: "تحليل المبيعات / المشتريات",
                        MostSellingGroups: "المجموعات الأكثر مبيعاً",
                        MonthlySales: "المبيعات الشهرية",
                        MostSellingItems: "العناصر الأكثر مبيعا",
                        TopCustomersBySale: "أهم العملاء حسب المبيعات",
                        ActiveUnitsSummary: "ملخص الوحدات النشطة",
                        VacantUnitsSummary: "ملخص الوحدات الشاغرة",
                        MostSellingUnitTypes: "أنواع الوحدات الأكثر مبيعاً",
                        BuildingUnitOverview: "المبنى - نظرة عامة على الوحدة",
                        EnterFileName: "أدخل اسم الملف",
                        SelectFile: "حدد ملف",
                        UploadError: "خطأ في التحميل",
                        FileUploaded: "ملف مرفوع",
                        FileUploadingPleaseWait: "تحميل الملف يرجى الانتظار",
                        EntertheGrade: "أدخل الدرجة",
                        Error: "خطأ",
                        Success: "نجاح",
                        DataExist: "البيانات موجودة!",
                        EntertheBankName: "أدخل اسم البنك",
                        SelectBankAccountNumber: "حدد رقم الحساب البنكي",
                        Deleted: "تم الحذف",
                        EnterSubject: "أدخل الموضوع",
                        EnterRemarks: "أدخل الملاحظات",
                        SelectLeaveType: "حدد نوع الإجازة",
                        EnterStartDate: "أدخل تاريخ البدء",
                        EnterEndDate: "أدخل تاريخ الانتهاء",
                        CannotEditWhileInProcess: "لا يمكن التحرير أثناء العملية",
                        CannotDeleteWhileInProcess: "لا يمكن الحذف أثناء العملية",
                        ApprovedDays: "الأيام المعتمدة",
                        EntertheStartDate: "أدخل تاريخ البدء",
                        EnterTotalDays: "أدخل إجمالي الأيام",
                        Failed: "فشل",
                        EnterReason: "أدخل السبب",
                        EnterResignationDate: "أدخل تاريخ الاستقالة",
                        EnterLeaves: "أدخل الإجازات",
                        SelectLeaveType: "حدد نوع الإجازة",
                        SelectGrade: "حدد الدرجة",
                        Assigned: "مُكَلَّف",
                        Applied: "مُطبَّق",
                        EntertheAmount: "أدخل المبلغ",
                        EnterFineType: "أدخل نوع الغرامة",
                        FileUploadingPleaseWait: "تحميل الملف يرجى الانتظار",
                        SelectAttachmentType: "حدد نوع المرفق",
                        EntertheDocNo: "أدخل رقم الوثيقة",
                        AddPercentage: "أضف النسبة المئوية",
                        AddBasicSalary: "إضافة الراتب الأساسي",
                        AddNetSalary: "أضف صافي الراتب",
                        EnterDescription: "أدخل الوصف",
                        SelectYear: "اختر السنة",
                        SelectMonth: "اختر الشهر",
                        AvailableLeavesLessThanRequested: "الإجازات المتاحة أقل من المطلوبة",
                        InvalidDates: "تواريخ غير صالحة",
                        CreditGrandTotal: "Credit Grand Total",
                        DebitGrandTotal: "Debit Grand Total",
                        POSReports: "POS Reports",
                        IsAutoCode: "Is AutoCode?",
                        HideCustomer: "Is Hide Customer Mob?",
                        CustomerCode: "Customer Code",
                        IsEmployeeAuto: "Is Employee Auto Code",
                        CreditNoteSR: "CreditNoteSR",
                        CreditNoteSRReport: "CreditNoteSRReport",
                        ProductWiseDirSalesReport: "Product Wise Direct Sales Report",
                        ProductWiseIndSalesReport: "Product Wise Individual Sales Report",
                        ProductWiseExpSalesReport: "Product Wise Export Sales Report",
                        ProductWiseProSalesReport: "Product Wise Proforma Sales Report",
                        ProductWiseIndPurchaseReport: "Product Wise Individual Purchase Report",
                        ProductWiseImpPurchaseReport: "Product Wise Import Purchase Report",
                        ProductWiseDirPurchaseReport: "Product Wise Direct Purchase Report",

                        CustomerWiseDirSalesReport: "Customer Wise Direct Sales Report",
                        CustomerWiseIndSalesReport: "Customer Wise Individual Sales Report",
                        CustomerWiseExpSalesReport: "Customer Wise Export Sales Report",
                        CustomerWiseProSalesReport: "Customer Wise Proforma Sales Report",

                        VendorWiseDirPurchaseReport: "Vendor Wise Direct Purchase Report",
                        VendorWiseImpPurchaseReport: "Vendor Wise Import Purchase Report",
                        VendorWiseIndPurchaseReport: "Vendor Wise Individual Purchase Report",
                        OtherSalesReports: "Other Sales Reports",

                        PurchaseEnquiryName: "Purchase Enquiry Name",




                    }

                    return languageData;

                } else {

                    var languageData = {
                        Dashboard: "Dashboard",
                        Currency: "Currency",
                        EntertheCurrencyConvertionty: "Enter the Currency Convertionty",

                        Rate: "Rate",
                        BaseCurrency: "Base Currency",
                        CurrencyName: "Currency Name",
                        ConvertedCurrencyName: "Converted Currency Name",
                        CurrencyConvertion: "Currency Convertion",
                        ConvertedCurrency: "Converted Currency",
                        Currency: "Currency",
                        Symbol: "Symbol",
                        DefaultVAT: "Default VAT ",
                        DefaultFinancialYear: " Default Financial Year ",
                        DefaultSalesAccount: "Default Sales Account ",
                        DefaultPurchaseAccount: "Default Purchase Account ",
                        DefaultInputVatAccount: "Default Input Vat Account ",
                        DefaultOutputVatAccount: "Default Output Vat Account ",
                        DefaultCashAccount: " Default Cash Account  ",
                        DefaultBankAccount: "  Default Bank Account ",
                        DefaultPDCPayableAccount: "  Default PDC Payable Account ",
                        DefaultPDCReceivableAccount: "  Default PDC Receivable Account ",
                        SMSId: "SMS Id",
                        SMSUsername: "SMS Username",
                        SMSPassword: "SMS Password",
                        Audited: "Audited",
                        Dateofsupply: "Date of supply",
                        EasybookSoftwareTrading: "Easybook Software Trading",
                        NeedOTP: "Need OTP",
                        EnterOTP: "Enter OTP",
                        Accounts: "Accounts",
                        SuperUser: "Super User",
                        DubaiunitedArabEmirates: "Dubai, united Arab Emirates",
                        SalesInvocie: "Sales Invocie",
                        PurchaseInvocie: "Purchase Invocie",
                        NoPurchaseDatasFound: "No Purchase Datas Found",
                        NoAuditDatasFound: "No Audit Datas Found",
                        CompanyExpenseVoucher: "Company Expense Voucher",
                        Voucher_CostCenterMapping: "Voucher - Cost Center Mapping",
                        InsertRow: "Insert Row",
                        Link: "Link",
                        Continue: "Continue",
                        PurchaseEnquiry: "Purchase Enquiry",
                        VoucherLinking: "Voucher Linking",
                        DeleteRow: "Delete Row",
                        AMCCompany: "AMC Company",
                        UpdateAsset: "Update Asset",
                        UpdateAssetGroup: "Update Asset Group",
                        WarrantyDate: "Warranty Date",
                        DepreciationYear: "Depreciation Year",
                        AddAsset: "Add Asset",
                        AddService: "Add Service",
                        UpdateService: "Update Service",
                        UpdateServiceGroup: "Update Service Group",
                        ContactPerson: "Contact Person",
                        ContactPersonNo: "Contact Person No",
                        CreditLimit: "Credit Limit",
                        CreditDays: "Credit Days",
                        Registered: "Registered",
                        NotRegistered: "Not Registered",
                        FaxNo: "Fax No",
                        DONo: "DO No",
                        UpdateProduct: "Update Product",
                        Model: "Model",
                        SelctedGroup: "Selcted Group",
                        SupplierName: "Supplier Name",
                        Specification: "Specification",
                        LicenseNo: "License No",
                        Username: "Username",
                        PurchasePrice: "Purchase Price",
                        SellingPrice: "Selling Price",
                        Barcode: "Barcode",
                        UpdateProductGroup: "Update Product Group",
                        PurchaseAccount: "Purchase Account",
                        SalesAccount: "Sales Account",
                        AddProduct: "Add Product",
                        EditCostCenter: "Edit Cost Center",
                        CostCenterName: "Cost Center Name",
                        AddCostCenter: "Add Cost Center",
                        LicenseExpiryDate: "License Expiry Date",
                        Usesearchforfindingtheaccountpleaseresetandaddupdateaccountsinactualway: "Use search for finding the account. Please reset and add / update accounts in actual way",

                        AddAccountTypes: "Add Account Types",
                        AddAccount: "Add Account",
                        EditAccountType: "Edit Account Type",
                        Shortcuts: "Shortcuts",
                        TotalVAT: "Total VAT",
                        CostMandatory: "Cost Mandatory",
                        Grand_Total: "Grand Total",
                        Masters: "Masters",
                        Nature: "Nature",
                        Purchase: "Purchase",
                        Sales: "Sales",
                        TRNo: "TRNo",
                        BasicVouchers: "Basic Vouchers",
                        PaymentVouchers: "Payment Vouchers",
                        ReceiptVouchers: "Receipt Vouchers",
                        PDCManagement: "PDC Management",
                        Stocks: "Stocks",
                        Reports: "Reports",
                        EASYBOOKACCOUNTING: "EASY BOOK ACCOUNTING",
                        Notifications: "Notifications",
                        Support: "Support",
                        Admin: "Admin",
                        Suppliers: "Suppliers",
                        Customers: "Customers",
                        Purchase: "Purchase",
                        Youhave0Mails: "You have 0 Mails",
                        YourEmailAddress: "Your Email Address",
                        Income: "Income",
                        Expense: "Expense",
                        NetProfit: "Net Profit",
                        January: "January",
                        MonthlySales: "Monthly Sales",
                        CostCenterExpense: "Cost Center Expense",
                        CostCenter: "Cost Center",
                        ExpenseCurrentMonth: "Expense Current Month",
                        CostCenterExpenseSummary: "Cost Center Expense Summary",
                        Country: "Country",
                        City: "City",
                        Unit: "Unit",
                        VAT: "VAT",
                        PDCPayable: "PDC Payable",
                        Employees: "Employees",
                        AccountTypes: "Account Types",
                        ChartofAccounts: "Chart of Accounts",
                        CostCenters: "Cost Centers",
                        Products: "Products",
                        Services: "Services",
                        Assets: "Assets",
                        Countries: "Countries",
                        Name: "Name",
                        Refresh: "Refresh",
                        Submit: "Submit",
                        CountryName: "Country Name",
                        Options: "Options",
                        Delete: "Delete",
                        Edit: "Edit",
                        Items: "Items",
                        Cities: "Cities",
                        Country: "Country",
                        Refresh: "Refresh",
                        CityName: "City Name",
                        CountryName: "Country Name",
                        Options: "Options",
                        Delete: "Delete",
                        Edit: "Edit",
                        ConfirmtoProceed: "Confirm to Proceed",
                        Units: "Units",
                        Name: "Name",
                        UnitName: "Unit Name",
                        ConfirmDelete: "Confirm Delete",
                        VATS: "VATS",
                        Value: "Value",
                        Designation: "Designation",
                        MobileNo: "Mobile No",
                        TelNo: "TelNo",
                        Email: "Email",
                        EmailId: "Email Id",
                        Address: "Address",
                        Country: "Country",
                        Remarks: "Remarks",
                        Photo: "Photo",
                        ChooseFile: "Choose File",
                        NoFileChosen: "No File Chosen",
                        Password: "Password",
                        Image: "Image",
                        Telephone: "Telephone",
                        AccountTypes: "Account Types",
                        SavedCostCentre: "Saved Cost Centre",
                        CHARTOFACCOUNTS: "CHART OF ACCOUNTS",
                        NameinArabic: "Name in Arabic",
                        AccountType: "Account Type",
                        AddAccountType: "Add Account Type",
                        GiveAccountName: "Give Account Name",
                        AddAccount: "Add Account",
                        ShowTable: "Show Table",
                        Group: "Group",
                        FinYear: "Financial Year",
                        TeamViewer: "Team Viewer",
                        DoDate: "Do Date",

                        UpdateAccount: "Update Account",
                        ConfirmDelete: "Confirm Delete",
                        Proceed: "Proceed",
                        Confirm: "Confirm",
                        Cancel: "Cancel",
                        Saved: "Saved",
                        EnglishName: "English Name",
                        ArabicName: "Arabic Name",
                        ExporttoExcel: "Export to Excel",
                        ShowTree: "Show Tree",
                        ShowTable: "Show Table",
                        CostCenters: "Cost Centers",
                        Products: "Products",
                        Code: "Code",
                        EnglishName: "English Name",
                        ArabicName: "Arabic Name",
                        AddProductGroup: "Add Product Group",
                        Services: "Services",
                        AddServiceGroup: "Add Service Group",
                        GiveName: "Give Name",
                        Assets: "Assets",
                        AddAssetGroup: "Add Asset Group",
                        PurchaseinvoiceReturnSummary: "Purchase invoice Return Summary",
                        Purchaseinvoice: "Purchase Invoice",
                        PurchaseReturn: "Purchase Return",
                        AuditPendingVouchers: "Audit Pending Vouchers",
                        PurchaseInvoice: "Purchase Invoice",
                        PurchaseOrder: "Purchase Order",
                        GoodsReceived: "Goods Received",
                        PurchaseQuotations: "Purchase Quotations",
                        PurchaseEnquiries: "Purchase Enquiries",
                        Pending: "Pending",
                        Purchaseflow: "Purchase Flow",
                        Purchaserequest: "Purchase Request",
                        PurchaseQuotation: "Purchase Quotation",
                        PurchaseOrder: "Purchase Order",
                        GoodsReceived: "Goods Received",
                        Purchasereturn: "Purchase Return",
                        purchase: "Purchase",
                        Date: "Date",
                        Supplier: "Supplier",
                        Remarks: "Remarks",
                        Enabletosendmailtosupplier: "Enable to send mail to supplier",
                        EnabletosendSMStoSupplier: "Enable to send SMS to Supplier",
                        Code: "Code",
                        SendMail: "Send Mail",
                        ProductName: "Product Name",
                        Description: "Description",
                        Unit: "Unit",
                        VAT: "VAT",
                        VATType: "VAT Type",
                        Quantity: "Quantity",
                        Bonus: "Bonus",
                        UnitPrice: "Unit Price",
                        Gross: "Gross",
                        Discount: "Discount",
                        Taxable: "Taxable",
                        Vat: "Vat",
                        RoundVat: "Round Vat",
                        Total: "Total",
                        EnterYourMessageHere: "Enter Your Message Here",
                        Refresh: "Refresh",
                        view: "View",
                        View: "View",
                        Print: "Print",
                        save: "Save",
                        NetTotal: "Net Total",
                        TotalTax: "Total Tax",
                        GrandTotal: "Grand Total",
                        PurchaseRequest: "Purchase Request",
                        Supplier: "Supplier",
                        PleaseselectSupplier: "Please Select Supplier",
                        selectSupplier: " Select Supplier",
                        PurchaseQuotation: " Purchase Quotation",
                        IntroLetterDescription: " Intro Letter Description",
                        Enabletosendmailtosupplier: " Enable to send mail to supplier",
                        EnabletosendSMStoSupplier: " Enable to send SMS to Supplier",
                        EndLetterDescription: " End Letter Description",
                        Productcode: " Product Code",
                        ProductName: " Product Name",
                        Description: " Description",
                        PurchaseOrder: " Purchase Order",
                        date: " Date",
                        YourMobileNo: " Your Mobile No",
                        Enabletosendmailtosupplier: " Enable to send mail to supplier",
                        IntroLetterDescription: " Intro Letter Description",
                        EnabletosendSMStoSupplier: " Enable to send SMS to Supplier",
                        EndLetterDescription: " End Letter Description",
                        Productcode: " Product Code",
                        ProductName: " Product Name",
                        PleaseselectSupplier: " Please Select Supplier",

                        SelectSupplier: " Select Supplier",
                        GoodsReceived: " Goods Received",
                        OrderNo: " Order No",
                        Enabletosendmailtosupplier: " Enable to send mail to supplier",
                        EnabletosendSMStoSupplier: " Enable to send SMS to Supplier",
                        Taxable: " Taxable",
                        ViewPrint: " View Print",
                        DebitAccount: " Debit Account",
                        DeliveryDate: " Delivery Date",
                        ReturnDate: " Return Date",
                        Dragacolumnheaderanddropitheretogroupbythatcolumn: " Drag a column header and drop it here to group by that column",
                        CreditAccount: " Credit Account",
                        SalesInvoiceReturnSummary: " Sales Invoice Return Summary",
                        SalesInvoice: "Sales Invoice",
                        SalesReturn: "Sales Return",
                        SalesOrder: "Sales Order",
                        AuditPendingVouchers: "Audit Pending Vouchers",
                        DeliveryNote: "Delivery Note",
                        SalesQuotations: "Sales Quotations",
                        SalesEnquiries: "Sales Enquiries",
                        SalesFlow: "Sales Flow",
                        SalesEnquiry: "Sales Enquiry",
                        salesorder: "Sales Order",
                        Sales: "Sales",
                        Customer: "Customer",
                        Enabletosendmailtocustomer: "Enable to send mail to customer",
                        Enabletosentsmstocustomer: "Enable to sent sms to customer",
                        code: "Code",
                        Description: "Description",
                        Salesquotation: "Sales Quotation",
                        Enabletosendmailtocustomer: "Enable to send mail to customer",
                        Enabletosendsmstocustomer: "Enable to send sms to customer",
                        PleaseselectCustomer: "Please select Customer",
                        Selectcustomer: "Select Customer",
                        SalesOrder: "Sales Order",
                        remarks: "Remarks",
                        SelctedGroup: "Selcted Group ",

                        OpeningBalance: "Opening Balance",
                        account_code: "Account Code",
                        account_name: "Account Name",
                        debit_amount: "Debit Amount",
                        Credit_amount: "Credit Amount",
                        project: "Project",
                        costcenter2: "Cost Center2",
                        CostCenter2: "Cost Center2",
                        costcenter3: "Cost Center 3",
                        refresh: "Refresh",
                        viewGL: "View GL",
                        savedelete: "Save Delete",
                        confirmsavevoucher: "Confirm Save Voucher",
                        confirmtoproceed: "Confirm To Proceed",
                        confirm: "Confirm",
                        cancel: "Cancel",
                        GeneralLedger: "General Ledger",
                        type: "Type",
                        account: "Account",
                        Account: "Account",
                        debit: "Debit",
                        Debit: "Debit",
                        credit: "Credit",
                        Credit: "Credit",
                        CostCenter1: "Cost Center 1",
                        costcenter1: "Cost Center 1",
                        costcenter2: "Cost Center 2",
                        costcenter3: "Cost Center 3",
                        totaldebit: "Total Debit",
                        TotalDebit: "Total Debit",
                        totalcredit: "Total Credit",
                        TotalCredit: "Total Credit",
                        balance: "Balance",
                        Balance: "Balance",
                        close: "Close",
                        Close: "Close",
                        JournalVoucher: "Journal Voucher",
                        narration: "Narration",
                        Narration: "Narration",
                        invaliddetails: "Invalid Details",
                        Companyexpense: "Company Expense",
                        CompanyExpense: "Company Expense",
                        amount: "Amount",
                        sub_total: "Sub Total",
                        total_vat: "Total Vat",

                        total_tax: "Total Tax",
                        Subject: "Subject",
                        selectaccount: "Select Account",
                        cashpaymentvoucher: "Cash Payment Voucher",
                        CashPayment: "Cash Payment",
                        total: "Total",
                        invaliddetails: "Invalid Details",
                        FundPaymentVoucher: "Fund Payment Voucher",
                        FundPayment: "Fund Payment",
                        PDCPayableAccount: "PDC Payable Account",
                        Bankaccount: "Bank account",
                        BankAccount: "Bank account",
                        ChequeNo: "Cheque No",
                        Maturitydate: "Maturity date",
                        ChequeReceiptvoucher: "Cheque Receipt voucher",
                        ChequeReceipt: "Cheque Receipt",
                        PDCReceivableAccount: "PDC Receivable Account",
                        PDCReceivable: "PDC Receivable",

                        Bankaccount: "Bank Account",
                        PendingPDCs: "Pending PDC's",
                        DateFrom: "Date From",
                        DateTo: "Date To",
                        Refresh: "Refresh",
                        Filter: "Filter",
                        Noitemstodisplay: "No items to display",
                        PDCNo: "PDC No",
                        Voucher: "Voucher",
                        Cheque: "Cheque",
                        PDCAccount: "PDC Account",
                        Bankaccount: "Bank account",
                        Status: "Status",
                        Options: "Options",
                        ProcessedPDCs: "Processed PDC's",
                        Noitemstodisplay: "No items to display",
                        PDCNo: "PDC No",
                        VoucherNo: "Voucher No",
                        PDCAccount: "PDC Account",
                        SupplierCustomeraccount: "Supplier Customer Account",
                        Options: "Options",
                        ReconcileDate: "Reconcile Date",
                        ReconcileBankAccount: "Reconcile Bank Account",
                        Reconcilechequepayment: "Reconcile Cheque Payment",
                        chequepayNo: "Cheque Pay No",
                        Noitemstodisplay: "No Items To Display",
                        Reconcilechequereceipt: "Reconcile Cheque Receipt",
                        Openingstocks: "Opening Stocks",
                        OpeningStock: "Opening Stock",
                        Openingstock: "Opening Stock",
                        confirmsavevoucher: "Confirm Save Voucher",
                        confirmdelete: "Confirm Delete",
                        confirmtoproceed: "Confirm to Proceed",
                        totalquantity: "Total Quantity",
                        TotalQuantity: "Total Quantity",
                        stockissue: "Stock Issue",
                        StockIssue: "Stock Issue",
                        stockrecive: "Stock Receive",
                        FilterLedger: "Filter Ledger",
                        SelectAll: "Select All",
                        selectall: "Select All",
                        from: "From",
                        to: "To",
                        DocNumber: "Doc Number",
                        Applyfilter: "Apply Filter",
                        resetfilter: "Reset Filter",
                        Reset: "Reset",
                        close: "Close",
                        exporttoexcel: "Export to Excel",
                        exporttoPDF: "Export to PDF",

                        itemsperpage: "Items Per Page",
                        Noitemstodisplay: "No Items To Display",
                        trailbalance: "Trail Balance",
                        level: "Level",
                        accountcode: "Account Code",
                        AccountCode: "Account Code",
                        accountname: "Account Name",
                        AccountName: "Account Name",
                        balancedebit: "Balance Debit",
                        balancecredit: "Balance Credit",
                        itemsperpage: "Items Per Page",
                        profitloss: "Profit & Loss",
                        all: "All",
                        itemsperpage: "Items Per Page",
                        balancesheet: "Balance Sheet",
                        BalanceSheet: "Balance Sheet",
                        itemsperpage: "Items Per Page",
                        shortcuts: "Shortcuts",
                        addaccounts: "Add Accounts",
                        addproducts: "Add Products",
                        addservices: "Add Services",
                        addassets: "Add Assets",
                        addaccount: "Add Account",
                        chartofaccounts: "Chart of Accounts",
                        assets: "Assets",
                        support: "Support",
                        livechat: "Live Chat",
                        emailsupport: "Email Support",
                        whatsappsupport: "Whats App Support",
                        enquiry: "Enquiry",
                        admin: "Admin",
                        documentnumber: "Document Number",
                        smstemplates: "SMS Templates",
                        changepassword: "Change Password",
                        Logout: "Logout",
                        logout: "Logout",
                        profile: "Profile",
                        Profile: "Profile",
                        general: "General",
                        phoneno: "Phone No",
                        mobileno: "Mobile No",
                        emailsupport: "Email Support",
                        address: "Address",
                        website: "Website",
                        TRN: "TRN",
                        TRNNo: "TRN No",
                        defaultvat: "Default Vat",
                        defaultfinancialyear: "Default Financial Year",
                        defaultsalesaccount: "Default Sales Account",
                        defaultpurchaseaccount: "Default Purchase Account",
                        defaultinpoutvaraccount: "Default Inpout Var Account",
                        defaultoutputvataccount: "Default Output Vat Account",
                        deafultcashaccount: "Deafult Cash Account",
                        defaultbankaccount: "Default Bank Account",
                        deafultPDCPayableaccount: "Deafult PDC Payable Account",
                        defaultPDCReceivableAccount: "Default PDC Receivable Account",
                        refresh: "Refresh",
                        Vouchercostcentermapping: "Voucher Cost Center Mapping",
                        updatemappings: "Update Mappings",
                        documentnumber: "Document Number",
                        save: "Save",
                        cancel: "Cancel",
                        prefix: "Prefix",
                        number: "Number",
                        smstemplates: "SMS Templates",
                        keywords: "Keywords",
                        vouchername: "Voucher Name",
                        VoucherName: "Voucher Name",
                        vouchernumber: "Voucher Number",
                        clientcustomername: "Client/Customer Name",
                        Passwordsdonotmatch: "Passwords do not match",
                        invoicedate: "Invoice Date",
                        subtotal: "Sub Total",
                        SubTotal: "Sub Total",
                        totaltax: "Total Tax",
                        TaxInvoice: "Tax Invoice",
                        template: "Template",
                        smsText: "SMS Text",
                        updatetemplates: "Update Templates",
                        newpassword: "New Password",
                        confirmpassword: "Confirm Password",
                        Passwordisrequired: "Password is required",
                        voucher: "Voucher #",
                        selectlevel: "Select Level",
                        DeselectAll: "Deselect All",
                        Details: "Details",
                        CreditAmount: "Credit Amount",
                        DebitAmount: "Debit Amount",
                        ChequeDate: "Cheque Date",
                        Profit: "Profit",
                        Loss: "Loss",
                        SalesInvoiceReport: "Sales Invoice Report",
                        Poduct_Code: "Poduct_Code",
                        Poduct_Name: "Poduct_Name",
                        InsertRow: "Insert Row",
                        DeleteRow: "Delete Row",
                        StockReceive: "Stock Receive",
                        Supplier: "Supplier",
                        ConfirmProcessPDC: "Confirm Process PDC",
                        SupplierCustomerAccount: "Supplier/Customer Account",
                        ChequeDate: "Cheque Date",
                        ConfirmReversePDC: "Confirm Reverse PDC",
                        ReconcileChequePaymentDetails: "Reconcile Cheque Payment Details",
                        Payment_No: "Payment No #",
                        PDCNumber: "PDC No #",
                        BankAccountName: "Bank Account Name",
                        CostCenter1Name: "Cost Center 1 Name",
                        CostCenter2Name: "Cost Center 2 Name",
                        CostCenter3Name: "Cost Center 3 Name",
                        ReconcileChequeReceiptDetails: "Reconcile Cheque Receipt Details",
                        CashReceiptVoucher: "Cash Receipt Voucher",
                        CashReceipt: "Cash Receipt",
                        Audited: " Audited",
                        FundReceiptVoucher: " Fund Receipt Voucher",
                        FundReceipt: " Fund Receipt",
                        ChequePaymentVoucher: " Cheque Payment Voucher",
                        ChequePayment: " Cheque Payment",
                        Exclusive: "Exclusive ",
                        Inclusive: "Inclusive ",
                        VoucherLinking: "Voucher Linking ",
                        SalesEnquiry: "Sales Enquiry ",
                        SalesQuotation: "Sales Quotation ",
                        SalesOrder: "Sales Order ",
                        Link: "Link",
                        AnyDesk: "Any Desk",
                        ChangeToEnglish: "Change To English",
                        ChangeToArabic: "Change To Arabic",
                        UsernamePasswordFinancialYearError: "Username / Password / Financial Year Error",
                        Login: "Login",
                        PlaceofSupply: "Place of Supply",
                        PlaceOfSupply: "Place of Supply",
                        SalesEmployee: "Sales Employee",
                        EasybookCloud: "Easybook Cloud",
                        LoginNow: "Login Now",
                        Cashledger: "Cash Ledger",
                        BankLedger: "Bank Ledger",
                        PettyCashLedger: "Petty Cash Ledger",
                        DebtorsLedger: "Debtors Ledger",
                        FixedAssetsLedger: "Fixed Assets Ledger",
                        InventoryLedger: "Inventory Ledger",
                        CashBalance: "Cash Balance",
                        PettyCashBalance: "Petty Cash Balance",
                        BankBalance: "Bank Balance",
                        DebtorsBalance: "Debtors Balance",
                        FixedAssetsBalance: "Fixed Assets Balance ",
                        InventoryBalance: "Inventory Balance ",
                        EquityCapitalBalance: "Equity Capital Balance ",
                        PartnerAccountBalance: "Partner Account Balance  ",
                        CreditorsBalance: "Creditors Balance ",
                        LoanBalance: "Loan Balance",
                        OtherLiabilitiesBalance: "Other Liabilities Balance",
                        PurchaseLedger: "Purchase Ledger",
                        DirectCostLedger: "Direct Cost Ledger",
                        PurchaseBalance: "Purchase Balance",
                        DirectCostBalance: "Direct Cost Balance",
                        SalaryandAllowancesBalance: "Salary and Allowances Balance",
                        ExpensesBalance: "Expenses Balance",
                        SalaryandAllowancesLedger: "Salary and Allowances Ledger",
                        ExpensesLedger: "Expenses Ledger",
                        SalesBalance: "Sales Balance",
                        SalesLedger: "Sales Ledger",
                        OtherRevenueAccount: "Other Revenue Account",
                        OtherRevenueLedger: "Other Revenue Ledger",
                        EquityCapitalLedger: "Equity Capital Ledger",
                        PartnerAccountLedger: "Partner Account Ledger",
                        CreditorsLedger: "Creditors Ledger",
                        LoanLedger: "Loan Ledger",
                        OtherLiabilitiesLedger: "Other Liabilities Ledger",
                        LoremIpsumissimplydummytextoftheprintingandtypesettingindustryLoremIpsumhasbeentheindustrysstandarddummytexteversincethe1500s: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
                        Cash: "Cash",
                        Bank: "Bank",

                        InterviewDay: "Interview Day",
                        DesignationDate: "Designation Date",
                        StartingDate: "Starting Date",
                        ResignationDate: "Resignation Date",
                        EndingDate: "Ending Date",
                        FirstName: "First Name",
                        SurName: "Sur Name",
                        FatherName: "Father Name",
                        MotherName: "Mother Name",
                        BirthDate: "Birth Date",
                        Gender: "Gender",
                        BirthPlace: "Birth Place",
                        PassportNo: "Passport No",
                        PassportIssueDate: "Passport Issue Date",
                        PassportIExpireDate: "Passport Expire Date",
                        Religion: "Religion",
                        VisaType: "Visa Type",
                        VisaNo: "Visa No",
                        VisaIssueDate: "Visa Issue Date",
                        VisaExpireDate: "Visa Expire Date",
                        JobLocation: "Job Location",
                        Qualification: "Qualification",
                        ContractNo: "Contract No",
                        ContractEndDate: "Contract End Date",
                        BloodGroup: "Blood Group",
                        MaritalStatus: "Marital Status",
                        WhatsappNo: "Whatsapp No",
                        HomeCountryAddress: "Home Country Address",
                        Insurance: "Insurance",
                        EmiratesIDNo: "Emirates ID No",
                        EmiratesIDExpireDate: "Emirates ID Expire Date",
                        ReferenceFriendName: "Reference Friend Name",
                        ReferenceFriendNo: "Reference Friend No",
                        Designation: "Designation",
                        Department: "Department",
                        ReportingManager: "Reporting Manager",
                        FullName: "Full Name",
                        Employee: "Employee",
                        AttachmentType: "Attachment Type",
                        EmployeeAttachment: "Employee Attachment",
                        DocNo: "Doc No",
                        FilePath: "File Path",
                        WpsDetail: "Wps Detail",
                        PaymentType: "PaymentType",
                        BankName: "Bank Name",
                        BankAccNo: "Bank Acc No",
                        BankBranch: "Bank Branch",
                        AgentCode: "Agent Code",
                        IbanNo: "Iban No",
                        SalaryDetail: "Salary Detail",
                        BasicSalary: "Basic Salary",
                        TransportAllowance: "Transport Allowance",
                        AccommodationAllowance: "Accommodation Allowance",
                        OtherAllowance: "Other Allowance",
                        Total: "Total",
                        LeaveType: "Leave Type",
                        VacationRequest: "Vacation Request",
                        StartDate: "Start Date",
                        EndDate: "End Date",
                        ResignationForm: "Resignation Form",
                        ResignationDate: "Resignation Date",
                        Reason: "Reason",
                        WarningLetter: "Warning Letter",
                        RespondDate: "Respond Date",
                        ApplyVacation: "Apply Vacation",
                        HR: "HR",
                        SalarySheet: "Salary Sheet",
                        BasicSalary: "Basic Salary",
                        TransportationAllowance: "Transportation Allowance",
                        AccommodationAllowance: "Accommodation Allowance",
                        OverTime: "Over Time",
                        OtherAllowance: "Other Allowance",
                        Bonus: "Bonus",
                        Advance: "Advance",
                        Deduction: "Deduction",
                        NetSalary: "Net Salary",
                        OtherAllowance: "Other Allowance",
                        TotalAccommodationAllowance: "Total Accommodation Allowance",
                        TotalTransportationAllowance: "Total Transportation Allowance",
                        TotalOverTime: "Total Over Time",
                        TotalNetSalary: "Total Net Salary",
                        TotalSalary: "Total Salary",
                        TotalOverTime: "Total Over Time",
                        TotalOtherAllowance: "Total Other Allowance",
                        TotalBonus: "Total Bonus",
                        TotalAdvance: "Total Advance",
                        TotalDeduction: "Total Deduction",
                        EmployeeAdvance: "Employee Advance",
                        Amount: "Amount",
                        EmployeeFine: "Employee Fine",
                        FineType: "Fine Type",
                        TimeSheet: "Time Sheet",
                        Shift1Start: "Shift1 Start",
                        Shift2Start: "Shift2 Start",
                        Shift1End: "Shift1 End",
                        Shift2End: "Shift2 End",
                        DailyHours: "Daily Hours",
                        OverTime: "Over Time",
                        TotalHours: "Total Hours",
                        VacationHistory: "Vacation History",
                        StartDate: "Start Date",
                        JoingDate: "Joing Date",
                        TotalDays: "Total Days",
                        AppraisalHistory: "Appraisal History",
                        Salary: "Salary",
                        PreviousSalary: "PreviousSalary",
                        CourtCategory: "Court Category",
                        Court: "Court",
                        CaseCategory: "Case Category",
                        CaseStage: "Case Stage",
                        AppointmentType: "Appointment Type",
                        CaseTransaction: "Case Transaction",
                        AuthorizedPerson: "Authorized Person",
                        Case: "Case",
                        OppositeLawyerName: "Opposite Lawyer Name",
                        OppositeLawyerPhone: "Opposite Lawyer Phone",
                        TotalFees: "Total Fees",
                        Advocate: "Advocate",
                        CaseNo: "Case No",
                        IsClosed: "Is Closed",
                        Act: "Act",
                        Appointment: "Appointment",
                        AppointmentDate: "Appointment Date",
                        IsVisited: "Is Visited",
                        CaseVisit: "Case Visit",
                        CaseVisitType: "Case Visit Type",
                        CreatedBy: "Created By",
                        CreatedDate: "Created Date",
                        CaseHearing: "Case Hearing",
                        HearingDate: "Hearing Date",
                        IsDone: "Is Done",
                        Recipe: "Recipe",
                        Product: "Product",
                        RProduct: "Recipe Product",
                        Cusian: "Cushion",
                        CounterSalesTable: "counter Sales Table",
                        counterSalesTable: "counter Sales Table",
                        SalesInvoiceA: "Sales Invoice A",
                        SalesInvoiceB: "Sales Invoice B",
                        SalesInvoiceC: "Sales Invoice C",
                        SalesInvoiceD: "Sales Invoice D",
                        SalesInvoiceE: "Sales Invoice E",
                        EmployeeSalesReport: "Employee Sales Report",
                        FromDate: "From Date",
                        ToDate: "To Date",


                        Building: "Building",
                        BuildingNo: "Building No",
                        PlotNo: "Plot No",
                        Floors: "Floors",
                        Area: "Area",
                        RentPropertyType: "Rent Property Type",
                        Location: "Location",
                        AddressArabic: "Address Arabic",
                        BuildDate: "Build Date",
                        BondDate: "Bond Date",
                        BondNo: "Bond No",
                        BondType: "Bond Type",
                        Lessor: "Lessor",
                        ContractorName: "Contractor Name",
                        ContractorNameArabic: "Contractor Name Arabic",
                        WatchMen: "Watch Men",
                        GovtNo: "Govt No",
                        RemarksArabic: "Remarks Arabic",
                        NoOfParking: "No Of Parking",
                        Contracts: "Contracts",
                        NameArabic: "Name Arabic",
                        Flat: "Flat",
                        FlatNo: "Flat No",
                        FloorNo: "Floor No",
                        BedRooms: "Bed Rooms",
                        BathRooms: "Bathrooms",
                        AvgRate: "Average Rate",
                        ContractType: "Contract Type",
                        RemarksAr: "Remarks Ar",
                        ContractPlace: "Contract Place",
                        Tenant: "Tenant",
                        RentalType: "Rental Type",
                        PurposeOfRent: "Purpose Of Rent",
                        RentDuration: "Rent Duration",
                        ExpiryDate: "Expiry Date",
                        TotalAmountInWords: "Total Amount In Words",
                        NoOfPayments: "No Of Payments",
                        SecurityDeposit: "Security Deposit",
                        Commission: "Commission",
                        PaymentMethod: "Payment Method",
                        TotalAmount: "Total Amount",
                        ContractInvoice: "Contract Invoice",

                        VehicleInsuranceExpiryDate: "Vehicle Insurance Expiry Date",
                        Branch: "Branch",
                        VehicleMake: "Vehicle Make",
                        VehicleInsuranceProviderName: "Vehicle Insurance Provider Name",
                        VehicleModel: "Vehicle Model",
                        VehicleChassisNo: "Vehicle Chassis No",
                        VehicleEngine: "Vehicle Engine",
                        VehicleCurrentOdometer: "Vehicle Current Odometer",
                        VehicleYear: "Vehicle Year",
                        VehicleDailyOdometerLimit: "Vehicle Daily Odometer Limit",
                        VehicleColor: "Vehicle Color",
                        VehicleOdometerExtraFeesPerUnit: "Vehicle Odometer Extra Fees Per Unit",
                        VehicleTrafficNo: "Vehicle Traffic No",
                        VehicleCurrentFuel: "Vehicle Current Fuel",
                        VehiclePlateSource: "Vehicle Plate Source",
                        VehicleDailyRate: "Vehicle Daily Rate",
                        VehicleWeeklyRate: "Vehicle Weekly Rate",
                        VehiclePlateCategory: "Vehicle Plate Category",
                        VehicleMonthlyRate: "Vehicle Monthly Rate",
                        VehicleLicenceIssuedDate: "Vehicle Licence Issued Date",
                        VehicleLicenceExpiryDate: "Vehicle Licence Expiry Date",
                        VehicleYearlyRate: "Vehicle Yearly Rate",
                        VehicleCurrentLocation: "Vehicle Current Location",
                        VehicleSalikAccount: "Vehicle Salik Account",
                        VehicleCurrentStatus: "Vehicle Current Status",
                        VehicleCategory: "Vehicle Category",
                        VehiclePlateNo: "Vehicle Plate No",
                        IntroLetterDescription: "Intro Letter Description",
                        EndLetterDescription: "End Letter Description",
                        SupplierPONO: "Supplier PO NO",

                        SupplierBillNo: "Supplier Bill No",
                        SupplierBillDate: "Supplier Bill Date",
                        PaymentTerms: "Payment Terms",
                        DeliveryBasis: "Delivery Basis",
                        DeliveryPeriod: "Delivery Period",
                        EnquiryNo: "Enquiry No",
                        WarrantyPeriod: "Warranty Period",
                        YRRefNo: "YR Ref No",
                        Manufacturing: "Manufacturing",
                        Stock: "Stock",
                        UnitConvertion: "Unit Convertion",
                        ConvertedUnit: "Converted Unit",
                        ConvertedUnitName: "Converted Unit Name",
                        ShippingAddress: "Shipping Address",
                        CreditNote: "Credit Note",
                        DebitNote: "Debit Note",
                        Grades: "Grades",
                        Shifts: "Shifts",
                        Banks: "Banks",
                        PayrollComponents: "Payroll Components",
                        Type: "Type",

                        Order: "Order",
                        Lead: "Lead",
                        Task: "Task",
                        Followup: "Followup",
                        Change: "Change",
                        Cushion: "Cushion",
                        TelphoneNo: "Telphone No",
                        Branches: "Branches",
                        Warehouses: "Warehouses",
                        Brands: "Brands",
                        DeleteAll: "Delete All",
                        DeleteOne: "Delete One",
                        AddCostCenter: "Add Cost Center",
                        SelectedGroup: "Selected Group",
                        AddParentCostCenter: "Add Parent Cost Center",
                        Add: "Add",
                        AccountWiseCostCenters: "Account Wise Cost Centers",
                        Save: "Save",
                        ChooseParentAccountToMove: "Choose Parent Account To Move",
                        MoveAccount: "Move Account",
                        WorkPhoneNo: "Work Phone No",
                        WorkAddress: "Work Address",
                        Profession: "Profession",
                        HomePhoneNo: "Home Phone No",
                        DrivingLicenseIssuedBy: "Driving License Issued By",
                        HomeAddress: "Home Address",
                        PlaceOfBirth: "Place Of Birth",
                        VisitVisaNo: "Visit Visa No",
                        DrivingLicenseExpiryDate: "Driving License Expiry Date",
                        DrivingLicenseIssueDate: "Driving License Issue Date",
                        DateOfBirth: "Date Of Birth",
                        IdentityExpiryDate: "Identity Expiry Date",
                        IdentityIssueDate: "Identity Issue Date",
                        Nationlity: "Nationlity",
                        UnifiedNo: "Unified No",
                        IdentityCardNo: "Identity Card No",
                        PreferedLanguage: "Prefered Language",
                        PhoneNo: "Phone No",
                        IsGroup: "Is Group",
                        More: "More",
                        Basic: "Basic",
                        SaveAccount: "Save Account",
                        Economy: "Economy",
                        Business: "Business",
                        First: "First",
                        TicketAirClass: "Ticket Air Class",
                        TicketDestination: "Ticket Destination",
                        TicketInfants: "Ticket Infants",
                        TicketChildren: "Ticket Children",
                        TicketAdults: "Ticket Adults",
                        VacationDays: "Vacation Days",
                        TwoYears: "Two Years",
                        HalfYearly: "Half Yearly",
                        Yearly: "Yearly",
                        VacationPeriod: "Vacation Period",
                        RemainingTickets: "Remaining Tickets",
                        RemainingVacationSalary: "Remaining Vacation Salary",
                        RemainingVacationDays: "Remaining Vacation Days",
                        LOPDays: "LOP Days",
                        DateAsOn: "Date As On",
                        Notes: "Notes",
                        AnnualCTC: "Annual CTC",
                        SwiftNo: "Swift No",
                        IBANNo: "IBAN No",
                        BankBranchName: "Bank Branch Name",
                        BankAccountNo: "Bank Account No",
                        Bank: "Bank",
                        ModeOfPayment: "Mode Of Payment",
                        MolNo: "Mol No",
                        OHCExpiryDate: "OHC Expiry Date",
                        OHCIssueDate: "OHC Issue Date",
                        OHCNo: "OHC No",
                        MedicalExpiryDate: "Medical Expiry Date",
                        MedicalIssueDate: "Medical Issue Date",
                        MedicalNo: "Medical No",
                        DrivingLicenseNo: "Driving License No",
                        IdExpiryDate: "ID Expiry Date",
                        IdIssueDate: "ID Issue Date",
                        IdNo: "ID No",
                        ContractExpendableDate: "Contract Expendable Date",
                        ContractExpiryDate: "Contract Expiry Date",
                        ContractIssueDate: "Contract Issue Date",
                        LabourCardIssueDate: "Labour Card Issue Date",
                        LabourCardIssueDate: "Labour Card Issue Date",
                        LabourCardNo: "Labour Card No",
                        VisaExpiryDate: "Visa Expiry Date",
                        PassportExpiryDate: "Passport Expiry Date",
                        Contact: "Contact",
                        Permanant: "Permanant",
                        Present: "Present",
                        Address2: "Address 2",
                        Address1: "Address 1",
                        MobileNo2: "MobileNo 2",
                        MobileNo1: "MobileNo 1",
                        AddNew: "Add New",
                        Relative: "Relative",
                        Friend: "Friend",
                        Wife: "Wife",
                        Husband: "Husband",
                        Sister: "Sister",
                        Brother: "Brother",
                        Mother: "Mother",
                        Father: "Father",
                        Relation: "Relation",
                        Saturday: "Saturday",
                        Friday: "Friday",
                        Thursday: "Thursday",
                        Wednesday: "Wednesday",
                        Tuesday: "Tuesday",
                        Monday: "Monday",
                        Sunday: "Sunday",
                        WeeklyOff2: "Weekly Off 2",
                        WeeklyOff1: "Weekly Off 1",
                        AllowOverTime: "Allow Over Time",
                        Section: "Section",
                        Sponsership: "Sponsership",
                        ConfirmationDate: "Confirmation Date",
                        DateOfJoining: "Date Of Joining",
                        InterviewDate: "Interview Date",
                        GuardianRelation: "Guardian Relation",
                        GuardianName: "Guardian Name",
                        EmergencyContactNo: "Emergency Contact No",
                        EmergencyContactName: "Emergency Contact Name",
                        RoomNo: "Room No",
                        Accomodation: "Accomodation",
                        RegisteredPartnership: "Registered Partnership",
                        Separated: "Separated",
                        Divorced: "Divorced",
                        Widowed: "Widowed",
                        Married: "Married",
                        Single: "Single",
                        MaritalStatus: "Marital Status",
                        Others: "Others",
                        Nonreligious: "Nonreligious",
                        Sikh: "Sikh",
                        Buddha: "Buddha",
                        Hindu: "Hindu",
                        Christian: "Christian",
                        Muslim: "Muslim",
                        NotSpecified: "Not Specified",
                        Female: "Female",
                        Male: "Male",
                        Shift: "Shift",
                        Grade: "Grade",
                        Contract: "Contract",
                        PartTime: "Part Time",
                        Permanent: "Permanent",
                        EmployeeType: "Employee Type",
                        EmployeeCode: "Employee Code",
                        Attachments: "Attachments",
                        Appraisals: "Appraisals",
                        Vacation: "Vacation",
                        Openings: "Openings",
                        Payroll: "Payroll",
                        Payment: "Payment",
                        Identities: "Identities",
                        ViewList: "View List",
                        AssetCategory: "Asset Category",
                        AddAsset: "Add Asset",
                        AssetList: "Asset List",
                        SubCategory: "Subcategory",
                        Category: "Category",
                        ShowOnPOS: "Show On POS",
                        AssetSubCategory: "Asset Subcategory",
                        Parent: "Parent",
                        ApplyParent: "Apply Parent",
                        ChooseExcel: "Choose Excel",
                        DownloadExcel: "Download Excel",
                        Upload: "Upload",
                        CostCenterUpload: "Cost Center Upload",
                        VatAccountType: "Vat Account Type",
                        TaxCategory: "Tax Category",
                        VatStateEmirate: "VAT State / Emirate",
                        VatCountry: "VAT Country",
                        Expenses: "Expenses",
                        CostCenter: "Cost Center",
                        Combinations: "Combinations",
                        CostCenterGroup: "Cost Center Group",
                        SellPrice: "Sell Price",
                        PurchasePrice: "Purchase Price",
                        PriceChart: "Price Chart",
                        ProductCategory: "Product Category",
                        ProductColors: "Product Colors",
                        ProductList: "Product List",
                        Color: "Color",
                        Size: "Size",
                        IsBatch: "Is Batch",
                        Brand: "Brand",
                        HSCode: "HS Code",
                        GrossWeight: "Gross Weight",
                        NetWeight: "Net Weight",
                        Volume: "Volume",
                        Height: "Height",
                        Width: "Width",
                        Length: "Length",
                        Packing: "Packing",
                        ProductSizes: "Product Sizes",
                        ProductSubCategory: "Product Sub Category",
                        ProductTypes: "Product Types",
                        Apply: "Apply",
                        ProductUpdate: "Product Update",
                        AfterEachUploadPleaseReloadThePage: "After Each Upload Please Reload The Page",
                        ConvertingValue: "Converting Value",
                        ConvertingUnit: "Converting Unit",
                        Manufacture: "Manufacture",
                        RecipeProduct: "Recipe Product",
                        MainProduct: "Main Product",
                        ServiceCategory: "Service Category",
                        ServiceList: "Service List",
                        ServiceSubCategory: "Service Subcategory",
                        UserRoles: "User Roles",
                        ConfirmBlockUnblockUser: "Confirm Block / Unblock User",
                        ConfirmPassword: "Confirm Password",
                        Role: "Role",
                        UserName: "User Name",
                        Users: "Users",
                        VATAccountType: "VAT Account Type",
                        VatStateEmirate: "VAT State / Emirate",
                        VatCountry: "VAT Country",
                        Vendors: "Vendors",

                        RemarksAr: "RemarksArabic",
                        Next: "Next",
                        Back: "Back",
                        Save: "Save",
                        ViewLedger: "View Ledger",
                        TotalBalance: "Total Balance",
                        Adjustment: "Adjustment",
                        TotalPaid: "Total Paid",
                        INVNo: "Invoice No",
                        INVType: "Invoice Type",
                        AutoAdjust: "Auto Adjust",
                        BillAnalysis: "Bill Analysis",
                        BillwiseDetails: "Billwise Details",
                        LPONo: "LPO No",
                        DueDate: "Due Date",
                        InvNo: "Invoice No",
                        InvDate: "Invoice Date",
                        CostCenterDetails: "Cost Center Details",
                        Date: "Date",
                        CompanyExpensePreview: "Company Expense Preview",
                        CreditNotePreview: "Credit Note Preview",
                        DebitNotePreview: "Debit Note Preview",
                        JournalVoucherPreview: "Journal Voucher Preview",
                        OpeningBalancePreview: "Opening Balance Preview",
                        ConfirmtoSave: "Confirm to Save",
                        Probability: "Probability",
                        CustomerAddress: "Customer Address",
                        CustomerEmirate: "Customer Emirate",
                        CustomerEmail: "Customer Email",
                        CustomerMobileNo1: "Customer Mobile No 1",
                        CustomerMobileNo2: "Customer Mobile No 2",
                        CustomerName: "Customer Name",
                        LeadSource: "Lead Source",
                        LeadType: "Lead Type",
                        Tasks: "Tasks",
                        Folloup: "Follow Up",
                        FollowUp: "Follow Up",
                        OtherInfo: "Other Info",
                        LeadInfo: "Lead Info",
                        AddLead: "Add Lead",
                        UpdateStatus: "Update Status",
                        ConfirmConvert: "Confirm Convert",
                        Leads: "Leads",
                        LeadSources: "Lead Sources",
                        LeadTypes: "Lead Types",
                        Opportunities: "Opportunities",
                        TotalExpense: "Total Expense",
                        InventoryValue: "Inventory Value",
                        TotalPayable: "Total Payable",
                        TotalReceivable: "Total Receivable",
                        BankBalance: "Bank Balance",
                        CashBalance: "Cash Balance",
                        LastYearPurchase: "Last Year Purchase",
                        LastMonthPurchase: "Last Month Purchase",
                        LastDayPurchase: "Last Day Purchase",
                        ThisYearPurchase: "This Year Purchase",
                        ThisMonthPurchase: "This Month Purchase",
                        TodayPurchase: "Today Purchase",
                        ToDoList: "To Do List",
                        VacantFlats: "Vacant Flats",
                        CreatedOn: "Created On",
                        RecentlyAddedContracts: "Recently Added Contracts",
                        ExpiringOn: "Expiring On",
                        ContractsEndingSoon: "Contracts Ending Soon",
                        VacantUnits: "Vacant Units",
                        ActiveUnits: "Active Units",
                        TotalUnits: "Total Units",
                        TotalBuildings: "Total Buildings",
                        TodaySales: "Today Sales",
                        ThisMonthSales: "This Month Sales",
                        ThisYearSales: "This Year Sales",
                        LastDaySales: "Last Day Sales",
                        LastMonthSales: "Last Month Sales",
                        LastYearSales: "Last Year Sales",
                        Expiry: "Expiry",
                        FileName: "File Name",
                        DocumentsByJobNo: "Documents By Job No",
                        UploadDoc: "Upload Document",
                        VoucherDocuments: "Voucher Documents",
                        BillDate: "Bill Date",
                        BillNo: "Bill No",
                        DueDate: "Due Date",
                        ChequePaymentVoucherPreview: "Cheque Payment Voucher Preview",
                        CashPaymentVoucherPreview: "Cash Payment Voucher Preview",
                        FundPaymentVoucherPreview: "Fund Payment Voucher Preview",
                        ReceiptNo: "Receipt No",
                        BounceChequePayment: "Bounce Cheque Payment",
                        BounceChequeReceipt: "Bounce Cheque Receipt",
                        BouncePDC: "Bounce PDC",
                        BounceDate: "Bounce Date",
                        ItemTotal: "Item Total",
                        VATPerc: "VAT %",
                        ItemPrice: "Item Price",
                        ItemDescription: "Item Description",
                        BalanceAmount: "Balance Amount",
                        ReceivedAmount: "Received Amountabic",
                        CardAmount: "Card Amount",
                        CashAmount: "Cash Amount",
                        CustomerMob: "Customer Mobile No",
                        Search: "Search",
                        BillReview: "Bill Review",
                        TotalDiscount: "Total Discount",
                        TotalCardAmount: "Total Card Amount",
                        TotalSales: "Total Sales",
                        TotalCashAmount: "Total Cash Amount",
                        ConfirmCloseCounter: "Confirm Close Counter",
                        MyCounters: "My Counters",
                        CloseCounterNow: "Close Counter Now",
                        PrintBill: "Print Bill",
                        CurrentCounterStartedAt: "Current Counter Started At",
                        YourCounterDidnotOpenedYet: "Your Counter Didn't Opened Yet",
                        CurrentCounter: "Current Counter",
                        CounterList: "Counter List",
                        Current: "Current",
                        Counters: "Counters",
                        ConfirmSaveSale: "Confirm Save Sale",
                        OpenCounterNow: "Open Counter Now !",
                        BalanceCash: "Balance Cash",
                        RecievedCash: "Recieved Cash",
                        Staff: "Staff",
                        CardAmt: "Card Amount",
                        CashAmt: "Cash Amount",
                        PayType: "Pay Type",
                        Checkout: "Checkout",
                        SelectProductCode: "Select Product Code",
                        SelectProduct: "Select Product",
                        Scanbarcode: "Scan Barcode",
                        PurchasedProducts: "Purchased Products",
                        Finished: "Finished ?",
                        Sub: "Sub",
                        Item: "Item",
                        SelectedTable: "Selected Table",
                        ChooseProducts: "Choose Products",
                        Using: "Using",
                        Open: "Open",
                        SlotName: "Slot Name",
                        Zone: "Zone",
                        ZoneName: "Zone Name",
                        Conditions: "Conditions",
                        TitleInArabic: "Title In Arabic",
                        Publish: "Publish ?",
                        Particulars: "Particulars",
                        LandloardCommissionAccount: "Land loard Commission Account",
                        ParkingAdvanceAccount: "Parking Advance Account",
                        ParkingIncomeAccount: "Parking Income Account",
                        RentalAdvanceReceivableCloseAccount: "Rental Advance Receivable Close Account",
                        RentalAdvanceReceivableAccount: "Rental Advance Receivable Account",
                        ProvisionAccount: "Provision Account",
                        BankLoanAccount: "Bank Loan Account",
                        AdvanceRentAccount: "Advance Rent Account",
                        PenaltyAccount: "Penalty Account",
                        RentReceivableAccount: "Rent Receivable Account",
                        RentIncomeAccount: "Rent Income Account",
                        RemarksInArabic: "Remarks In Arabic",
                        AddressinArabic: "Address in Arabic",
                        GovernmentNo: "Government No",
                        BondNumber: "Bond Number",
                        UnderConstruction: "Under Construction",
                        InActive: "In Active",
                        Active: "Active",
                        Parking: "Parking",
                        ContractorInArabic: "Contractor In Arabic",
                        Contractor: "Contractor",
                        Watchmen: "Watchmen",
                        Lessor: "Lessor",
                        BuildingType: "Building Type",
                        History: "History",
                        ParkingSlots: "Parking Slots",
                        ParkingZones: "Parking Zones",
                        PublishDetails: "Publish Details",
                        AccountDetails: "Account Details",
                        BasicDetails: "Basic Details",
                        AddBuilding: "Add Building",
                        Title: "Title",
                        IsOnCase: "Is On Case ?",
                        FlatType: "Flat Type",
                        Residential: "Residential",
                        Commercial: "Commercial",
                        FloorNumber: "Floor Number",
                        FlatNumber: "Flat Number",
                        AddFlatUnit: "Add Flat / Unit",
                        ReceivableBank: "Receivable Bank",
                        PayeeBank: "Payee Bank",
                        PaymentStartDate: "Payment Start Date",
                        ChequeStartingNo: "Cheque Starting No",
                        NoofChequesPayments: "No of Cheques / Payments",
                        GeneratePayments: "Generate Payments",
                        ConfirmSave: "Confirm Save ?",
                        POBox: "PO Box",
                        Fax: "Fax",
                        TelephoneNo: "Telephone No",
                        Nationality: "Nationality",
                        LessorCardNo: "Lessor Card No",
                        DetailsOfLessor: "Details Of Lessor",
                        Beneficiary: "Beneficiary",
                        CardNo: "Card No",
                        PropertyTypesNo: "Property Types No",
                        TenantNameArabic: "Tenant Name Arabic",
                        TenantName: "Tenant Name",
                        DetailsOfTenant: "Details Of Tenant",
                        AmountInWords: "Amount In Words",
                        LedgerDateBy: "Ledger Date By",
                        ContractDate: "Contract Date",
                        LastOfMonth: "Last Of Month",
                        FirstOfMonth: "First Of Month",
                        MonthlyPaymentOn: "Monthly Payment On",
                        Monthly: "Monthly",
                        Annual: "Annual",
                        Fulltime: "Full Time",
                        SelectFlat: "Select Flat",
                        SelectBuilding: "Select Building",
                        LesseeNameArabic: "Lessee Name Arabic",
                        LesseeName: "Lessee Name",
                        Terms: "Terms",
                        LesseeLessor: "Lessee / Lessor",
                        PremisesPayment: "Premises Payment",
                        PremisesConditions: "Premises Conditions",
                        AddTenancyContract: "Add Tenancy Contract",
                        Buildings: "Buildings",
                        AverageRate: "Average Rate",
                        Floor: "Floor",
                        Vacant: "Vacant",
                        BuildingSummary: "Building Summary",
                        BuildingTypes: "Building Types",
                        Flats: "Flats",
                        Occupied: "Occupied",
                        FlatTypes: "Flat Types",
                        Terminate: "Terminate",
                        Refund: "Refund",
                        Termination: "Termination",
                        Both: "Both",
                        Renew: "Renew",
                        New: "New",
                        LoadType: "Load Type",
                        TenancyContracts: "Tenancy Contracts",
                        FOCQty: "FOC Qty",
                        TNetWeight: "Total Net Weight",
                        TGrossWeight: "Total Gross Weight",
                        DiscValue: "Discount Value",
                        DiscType: "Discount Type",
                        OtherCharges: "Other Charges",
                        ExtraCharges: "Extra Charges",
                        WareHouse: "Warehouse",
                        BalanceQty: "Balance Qty",
                        QtyToLink: "Qty To Link",
                        AvailableQty: "Available Qty",
                        LinkedQty: "Linked Qty",
                        ActualQuantity: "Actual Quantity",
                        VoucherLinkingPreview: "Voucher Linking Preview",
                        LinkVouchers: "Link Vouchers",
                        NoPendingVouchersFound: "No Pending Vouchers Found !",

                        ApplyUnitPrice: "Apply Unit Price",
                        RoundOfVat: "Round Of Vat",
                        TaxValue: "Tax Value",
                        TaxableAmount: "Taxable Amount",
                        ProductAnalysis: "Product Analysis",
                        ShowBatchInfo: "Show Batch Info",
                        LoadFromPriceChart: "Load From Price Chart",
                        AnalyseAllPrice: "Analyse All Price",
                        AnalyseCustomerPrice: "Analyse Customer Price",
                        AddedQuantity: "Added Quantity",
                        ManufacturingDate: "Manufacturing Date",
                        BatchNo: "Batch No",
                        SaveToList: "Save To List",
                        ProductBatch: "Product Batch",
                        TotalBalanceAmount: "Total Balance Amount",
                        UnassignedBillsFound: "Unassigned Bills Found !",
                        Extra: "Extra",
                        Percentage: "Percentage",
                        DeliveryTime: "Delivery Time",
                        SupplyPlace: "Supply Place",
                        TotalNetWeight: "Total Net Weight",
                        TotalGrossWeight: "Total Gross Weight",
                        NoOfPackages: "No Of Packages",
                        Weight: "Weight",
                        Dimension: "Dimension",
                        CustomerPONo: "Customer PO No",
                        SupplierQTNNo: "Supplier QTN No",
                        ConcernPerson: "Concern Person",
                        Validity: "Validity",
                        ReturnTime: "Return Time",
                        DueDays: "Due Days",
                        LinkedRefs: "Linked Refs",
                        Recalculate: "Recalculate",
                        BulkPE: "Bulk PE",
                        VatAmount: "VAT Amount",
                        VATAmount: "VAT Amount",
                        VendorName: "Vendor Name",
                        VendorCode: "Vendor Code",
                        BulkPurchaseEnquiry: "Bulk Purchase Enquiry",
                        ShowPendingLinking: "Show Pending (Linking) ?",
                        CustomerDetails: "Customer Details",
                        VoucherDetails: "Voucher Details",
                        Preview: "Preview",
                        IndividualPurchaseInvociePreview: "Individual Purchase Invocie Preview",
                        PDCAccountDebit: "PDC Account (Debit)",
                        CreditDebitAccount: "Credit Debit / Account",
                        CostLedger: "Cost Ledger",
                        FilterData: "Filter Data",
                        CounterSales: "Counter Sales",
                        date: "Date",
                        SelectJobs: "Select Jobs",
                        JobWiseProfit: "Job Wise Profit",
                        LossDetails: "Loss Details",
                        CashPaymentReport: "Cash Payment Report",
                        CashReceiptReport: "Cash Receipt Report",
                        ChequePaymentReport: "Cheque Payment Report",
                        ChequeReceiptReport: "Cheque Receipt Report",
                        CompanyExpenseReport: "Company Expense Report",
                        CreditNoteReport: "Credit Note Report",
                        DebitNoteReport: "Debit Note Report",
                        FundPaymentReport: "Fund Payment Report",
                        FundReceiptReport: "Fund Receipt Report",
                        JournalVoucherReport: "Journal Voucher Report",
                        OpeningBalanceReport: "Opening Balance Report",
                        PaymentsReceiptReport: "Payments & Receipt Report",
                        Report: "Report",
                        VendorWisePurchaseReport: "Vendor Wise Purchase Report",
                        ProductWisePurchaseReport: "Product Wise Purchase Report",
                        PurchaseReport: "Purchase Report",
                        Pending: "Pending",
                        PendingPurchaseReport: "Pending Purchase Report",
                        AgingAnalysisReport: "Aging Analysis Report",
                        BillWiseAging: "Bill Wise Aging",
                        BillWiseAnalysis: "Bill Wise Analysis",
                        ListOfOutstanding: "List Of Outstanding",
                        Keyword: "Keyword",
                        BillWiseReport: "Bill Wise Report",
                        ListOfOutstandingCredit: "List Of Outstanding (Credit)",
                        ListOfOutstandingDebit: "List Of Outstanding (Debit)",
                        AgingAnalysis: "Aging Analysis",
                        ListOfOutstandingBills: "List Of Outstanding Bills",
                        Payables: "Payables",
                        Receivables: "Receivables",
                        CustomerWiseSalesReport: "Customer Wise Sales Report",
                        OverdueDirectSalesInvoices: "Overdue Direct Sales Invoices",
                        OverdueExportSalesInvoices: "Overdue Export Sales Invoices",
                        OverdueIndividualSalesInvoices: "Overdue Individual Sales Invoices",
                        OverdueSalesInvoices: "Overdue Sales Invoices",
                        PendingSalesReport: "Pending Sales Report",
                        ProductWiseSalesReport: "Product Wise Sales Report",
                        CustomerWiseSales: "Customer Wise Sales",
                        ProductWiseSales: "Product Wise Sales",
                        SalesReport: "Sales Report",
                        SalesReports: "Sales Reports",
                        BatchLedger: "Batch Ledger",
                        InventoryReport: "Inventory Report",
                        StockLedger: "Stock Ledger",
                        StockLedgerMultiUnit: "Stock Ledger Multi Unit",
                        StockList: "Stock List",
                        StockValuation: "Stock Valuation",
                        StockMovement: "Stock Movement",
                        StockLedgerMultiUnit: "Stock Ledger - Multi Unit",
                        Print2: "Print 1",
                        Print2: "Print 2",
                        Print3: "Print 3",
                        CarNo: "Car No",
                        CarName: "Car Name",
                        CustomerHistory: "Customer History",
                        CPVs: "CPV's",
                        CRVs: "CRV's",
                        ChequePVs: "Cheque PV's",
                        ChequeRVs: "Cheque RV's",
                        FPVs: "FPV's",
                        FRVs: "FRV's",
                        JVs: "JV's",
                        BalanceQuantity: "Balance Quantity",
                        IndividualSalesInvociePreview: "Individual Sales Invocie Preview",
                        TCost: "Total Cost",
                        StockFOC: "Stock FOC",
                        StockJV: "Stock JV",
                        Warehouse: "Warehouse",
                        Price: "Price",
                        Issue: "Issue",
                        Receive: "Receive",
                        StockReceivePreview: "Stock Receive Preview",
                        StockJVPreview: "Stock JV Preview",
                        StockIssuePreview: "Stock Issue Preview",
                        StockFOCPreview: "Stock FOC Preview",
                        OpeningStockPreview: "Opening Stock Preview",
                        Projects: "Projects",
                        Document: "Document",
                        Project: "Project",
                        DurationType: "Duration Type",
                        Minutes: "Minute(s)",
                        Hours: "Hour(s)",
                        Days: "Day(s)",
                        Duration: "Duration",
                        AssignedTo: "Assigned To",
                        TaskType: "Task Type",
                        TaskTypes: "Task Types",
                        Cancelled: "Cancelled",
                        Completed: "Completed",
                        Terminated: "Terminated",
                        ReasonOfClosing: "Reason Of Closing",
                        CloseContract: "Close Contract",
                        Closed: "Closed",
                        Vehicle: "Vehicle",
                        NRef: "N Ref",
                        DailyKMLimit: "Daily KM Limit",
                        ReturnLocation: "Return Location",
                        IsTaxInclusive: "Is Tax Inclusive",
                        Rate: "Rate",
                        Period: "Period",
                        Weekly: "Weekly",
                        Daily: "Daily",
                        OrderType: "Order Type",
                        CustomerMobileNo: "Customer Mobile No",
                        CarContract: "Car Contract",
                        CarContractLedger: "Car Contract Ledger",
                        Acts: "Acts",
                        Payments: "Payments",
                        FilingDate: "Filing Date",
                        FileNo: "File No",
                        No: "No",
                        Yes: "Yes",
                        CustomerSupplier: "Customer / Supplier",
                        SaveAll: "Save All",
                        CustomerSupplier: "Customer / Supplier?",
                        Head: "Head",
                        Body: "Body",
                        IndividualSalesInvoice: "Individual Sales Invoice",
                        ExportSalesInvoice: "Export Sales Invoice",
                        ProformaInvoice: "Proforma Invoice",
                        PackingList: "Packing List",
                        DirectSalesInvoice: "Direct Sales Invoice",
                        ExportPurchaseInvoice: "Export Purchase Invoice",
                        ImportPurchaseInvoice: "Import Purchase Invoice",
                        IndividualPurchaseInvoice: "Individual Purchase Invoice",
                        DirectPurchaseInvoice: "Direct Purchase Invoice",
                        VoucherAccountsLoading: "Voucher Accounts Loading",
                        IsDescriptionMandatory: "Is Description Mandatory?",
                        IsAddressMandatory: "Is Address Mandatory?",
                        IsField20Mandatory: "Is Field 20 Mandatory?",
                        IsField19Mandatory: "Is Field 19 Mandatory?",
                        IsField18Mandatory: "Is Field 18 Mandatory?",
                        IsField17Mandatory: "Is Field 17 Mandatory?",
                        IsField16Mandatory: "Is Field 16 Mandatory?",
                        IsField15Mandatory: "Is Field 15 Mandatory?",
                        IsField14Mandatory: "Is Field 14 Mandatory?",
                        IsField13Mandatory: "Is Field 13 Mandatory?",
                        IsField12Mandatory: "Is Field 12 Mandatory?",
                        IsField11Mandatory: "Is Field 11 Mandatory?",
                        IsField10Mandatory: "Is Field 10 Mandatory?",
                        IsField9Mandatory: "Is Field 9 Mandatory?",
                        IsField8Mandatory: "Is Field 8 Mandatory?",
                        IsField7Mandatory: "Is Field 7 Mandatory?",
                        IsField6Mandatory: "Is Field 6 Mandatory?",
                        IsField5Mandatory: "Is Field 5 Mandatory?",
                        IsField4Mandatory: "Is Field 4 Mandatory?",
                        IsField3Mandatory: "Is Field 3 Mandatory?",
                        IsField2Mandatory: "Is Field 2 Mandatory?",
                        IsField1Mandatory: "Is Field 1 Mandatory?",
                        IsDescription: "Is Description?",
                        IsAutoCode: "Is AutoCode?",
                        HideCustomer: "Is Hide Customer Mob?",
                        CustomerCode: "Customer Code",
                        IsEmployeeAuto: "Is Employee Auto Code",
                        IsAddress: "Is Address?",
                        IsField20: "Is Field 20?",
                        IsField19: "Is Field 19?",
                        IsField18: "Is Field 18?",
                        IsField17: "Is Field 17?",
                        IsField16: "Is Field 16?",
                        IsField15: "Is Field 15?",
                        IsField14: "Is Field 14?",
                        IsField13: "Is Field 13?",
                        IsField12: "Is Field 12?",
                        IsField11: "Is Field 11?",
                        IsField10: "Is Field 10?",
                        IsField9: "Is Field 9?",
                        IsField8: "Is Field 8?",
                        IsField7: "Is Field 7?",
                        IsField6: "Is Field 6?",
                        IsField5: "Is Field 5?",
                        IsField4: "Is Field 4?",
                        IsField3: "Is Field 3?",
                        IsField2: "Is Field 2?",
                        IsField1: "Is Field 1?",
                        Field16Date: "Field 16 (Date)",
                        Field17Date: "Field 17 (Date)",
                        Field18Date: "Field 18 (Date)",
                        Field19Date: "Field 19 (Date)",
                        Field20Date: "Field 20 (Date)",
                        Field11select: "Field 11 (select)",
                        Field12select: "Field 12 (select)",
                        Field13select: "Field 13 (select)",
                        Field14select: "Field 14 (select)",
                        Field15select: "Field 15 (select)",
                        Field1: "Field 1",
                        Field2: "Field 2",
                        Field3: "Field 3",
                        Field4: "Field 4",
                        Field5: "Field 5",
                        Field6: "Field 6",
                        Field7: "Field 7",
                        Field8: "Field 8",
                        Field9: "Field 9",
                        Field10: "Field 10",
                        CostCenterDesign: "Cost Center Design",
                        IsMaster8: "Is Master 8?",
                        IsMaster7: "Is Master 7?",
                        IsMaster6: "Is Master 6?",
                        IsMaster5: "Is Master 5?",
                        IsMaster4: "Is Master 4?",
                        IsMaster3: "Is Master 3?",
                        IsMaster2: "Is Master 2?",
                        IsMaster1: "Is Master 1?",
                        Master8Name: "Master 8 Name",
                        Master7Name: "Master 7 Name",
                        Master6Name: "Master 6 Name",
                        Master5Name: "Master 5 Name",
                        Master4Name: "Master 4 Name",
                        Master3Name: "Master 3 Name",
                        Master2Name: "Master 2 Name",
                        Master1Name: "Master 1 Name",
                        Master8Field1Name: "Master 8 Field 1 Name",
                        Master7Field1Name: "Master 7 Field 1 Name",
                        Master6Field1Name: "Master 6 Field 1 Name",
                        Master5Field1Name: "Master 5 Field 1 Name",
                        Master4Field1Name: "Master 4 Field 1 Name",
                        Master3Field1Name: "Master 3 Field 1 Name",
                        Master2Field1Name: "Master 2 Field 1 Name",
                        Master1Field1Name: "Master 1 Field 1 Name",
                        Master7Field2Name: "Master 7 Field 2 Name",
                        Master6Field2Name: "Master 6 Field 2 Name",
                        Master5Field2Name: "Master 5 Field 2 Name",
                        Master4Field2Name: "Master 4 Field 2 Name",
                        Master3Field2Name: "Master 3 Field 2 Name",
                        Master2Field2Name: "Master 2 Field 2 Name",
                        Master1Field2Name: "Master 1 Field 2 Name",
                        Master8Field2Name: "Master 8 Field 2 Name",
                        Master8Field3Name: "Master 8 Field 3 Name",
                        Master7Field3Name: "Master 7 Field 3 Name",
                        Master6Field3Name: "Master 6 Field 3 Name",
                        Master5Field3Name: "Master 5 Field 3 Name",
                        Master4Field3Name: "Master 4 Field 3 Name",
                        Master3Field3Name: "Master 3 Field 3 Name",
                        Master2Field3Name: "Master 2 Field 3 Name",
                        Master1Field3Name: "Master 1 Field 3 Name",
                        ExtraMasters: "Extra Masters",
                        Page: "Page",
                        SelectPage: "Select Page",
                        SelectPageGroup: "Select Page Group",
                        FavouriteLinks: "Favourite Links",
                        YouDonotHaveAccessOnThisPage: "You Don't Have Access On This Page",
                        ContactAdminRegardingYourAccess: "Contact Admin Regarding Your Access",
                        GoToDashboard: "Go To Dashboard",
                        InvoiceCompeleted: "Invoice Compeleted",
                        InvoiceSent: "Invoice Sent",
                        fromlastmonth: "from last month",
                        Complete: "Complete",
                        InvoiceRemaining: "Invoice Remaining",
                        TotalTransactions: "Total Transactions",
                        ClickHereToConnect: "Click Here To Connect",
                        Ifyoufaceanytrouble: "If you face any trouble please connect us now to get support and fixes. Regular support time 9:00 AM to 10:00 PM.",
                        LookingForSupportConnectUsNow: "Looking For Support Connect Us Now",
                        UploadDate: "Upload Date",
                        ExpiringExpiredDocuments: "Expiring / Expired Documents",
                        LatestSaleOrders: "Latest Sale Orders",
                        UpdateProfile: "Update Profile",
                        TotalQuotations: "Total Quotations",
                        UnpaidBills: "Unpaid Bills",
                        PaidBills: "Paid Bills",
                        TotalInvoices: "Total Invoices",
                        ERPCLOUD: "ERP CLOUD",
                        Seeallnotifications: "See all notifications",
                        VoucherSettings: "Voucher Settings",
                        VoucherCostCenters: "Voucher Cost Centers",
                        VoucherLinks: "Voucher Links",
                        VoucherDesign: "Voucher Design",
                        VoucherLoading: "Voucher Loading",
                        TabDesign: "Tab Design",
                        ProductDesign: "Product Design",
                        CostCenterDesign: "Cost Center Design",
                        VoucherNames: "Voucher Names",
                        VoucherPrints: "Voucher Prints",
                        TableDesign: "Table Design",
                        ResaveVouchers: "Resave Vouchers",
                        UserRoleMapping: "User Role Mapping",
                        UserPageRole: "User Page Role",
                        Reminders: "Reminders",
                        Hi: "Hi,",
                        Inbox: "Inbox",
                        SalesDashboard: "Sales Dashboard",
                        PurcahseDashboard: "Purchase Dashboard",
                        FinancialDashboard: "Financial Dashboard",
                        RealestateDashboard: "Realestate Dashboard",
                        Inventory: "Inventory",
                        ProductType: "Product Type",
                        ProductColor: "Product Color",
                        ProductSize: "Product Size",
                        Uploads: "Uploads",
                        CostCenterUpload: "Cost Center Upload",
                        CustomerUpload: "Customer Upload",
                        ExpenseUpload: "Expense Upload",
                        VendorUpload: "Vendor Upload",
                        ProductUpload: "Product Upload",
                        ServiceUpload: "Service Upload",
                        AssetUpload: "Asset Upload",
                        PurchaseEnquiry: "Purchase Enquiry",
                        EmployeeAppraisals: "Employee Appraisals",
                        CRM: "CRM",
                        Property: "Property",
                        FlatType: "Flat Type",
                        FlatStatus: "Flat Status",
                        TenancyContract: "Tenancy Contract",
                        POS: "POS",
                        CounterSalesTouch: "Counter Sales Touch",
                        Production: "Production",
                        Documents: "Documents",
                        DocumentsByJob: "Documents By Job",
                        JobWiseProfitDetails: "Job Wise Profit Details",
                        JobWiseProfit: "Job Wise Profit",
                        InventoryReports: "Inventory Reports",
                        Receipts: "Receipts",
                        PurchaseReports: "Purchase Reports",
                        MagtecERP: "Magtec ERP",
                        AllRightsReserved: "© 2023 All Rights Reserved",
                        ReceiptType: "Receipt Type",
                        IsSizeMandatory: "Is Size Mandatory?",
                        IsColorMandatory: "Is Color Mandatory?",
                        IsTypeMasterMandatory: "Is Type (Master) Mandatory?",
                        IsProductBatchMandatory: "Is Product Batch Mandatory?",
                        IsSupplierMandatory: "Is Supplier Mandatory?",
                        IsBrandMandatory: "Is Brand Mandatory?",
                        IsSubCategoryMandatory: "Is Sub Category Mandatory?",

                        IsCategoryMandatory: "Is Category Mandatory?",
                        IsPurchaseAccountMandatory: "Is Purchase Account Mandatory?",
                        IsSalesAccountMandatory: "Is Sales Account Mandatory?",
                        IsVATMandatory: "Is VAT Mandatory?",
                        IsCountryMandatory: "Is Country Mandatory?",
                        IsUnitMandatory: "Is Unit Mandatory?",
                        IsHSCodeMandatory: "Is HS Code Mandatory?",
                        IsWeightMandatory: "Is Weight Mandatory?",
                        IsStockMandatory: "Is Stock Mandatory?",
                        IsManufacturingMandatory: "Is Manufacturing Mandatory?",
                        IsYRRefNoMandatory: "Is YR Ref No Mandatory ?",
                        IsVatTypeMandatory: "Is Vat Type Mandatory ?",
                        IsShowPosCheckMandatory: "Is Show Pos Check Mandatory?",
                        IsWarrantyDateMandatory: "Is Warranty Date Mandatory?",
                        IsDescriptionMandatory: "Is Description Mandatory?",
                        IsAveragePriceMandatory: "Is Average Price Mandatory?",
                        IsPurchasePriceMandatory: "Is Purchase Price Mandatory?",
                        IsSellPriceMandatory: "Is Sell Price Mandatory?",
                        IsAMCCompanyMandatory: "Is AMC Company Mandatory?",
                        IsDepreciationYearMandatory: "Is Depreciation Year Mandatory?",
                        IsSupplierMandatory: "Is Supplier Mandatory?",
                        IsModelMandatory: "Is Model Mandatory?",
                        IsProductTypeMandatory: "Is Product Type Mandatory?",
                        IsImageMandatory: "Is Image Mandatory?",
                        IsSpecificationMandatory: "Is Specification Mandatory?",
                        IsBarcodeMandatory: "Is Barcode Mandatory?",
                        IsNameArabicMandatory: "Is Name Arabic Mandatory?",
                        IsNameMandatory: "Is Name Mandatory?",
                        IsProductCodeMandatory: "Is Product Code Mandatory?",
                        IsSizeToMain: "Is Size To Main?",
                        IsColorToMain: "Is Color To Main?",
                        IsTypeMasterToMain: "Is Type (Master) To Main?",
                        IsProductBatchToMain: "Is Product Batch To Main?",
                        IsSupplierToMain: "Is Supplier To Main?",
                        IsBrandToMain: "Is Brand To Main?",
                        IsSubCategoryToMain: "Is Sub Category To Main?",
                        IsCategoryToMain: "Is Category To Main?",
                        IsPurchaseAccountToMain: "Is Purchase Account To Main?",
                        IsSalesAccountToMain: "Is Sales Account To Main?",
                        IsVATToMain: "Is VAT To Main?",
                        IsCountryToMain: "Is Country To Main?",
                        IsUnitToMain: "Is Unit To Main?",
                        IsHSCodeToMain: "Is HS Code To Main?",
                        IsWeightToMain: "Is Weight To Main?",
                        IsStockToMain: "Is Stock To Main?",
                        IsManufacturingToMain: "Is Manufacturing To Main?",
                        IsYRRefNoToMain: "Is YR Ref No To Main?",
                        IsVatTypeToMain: "Is Vat Type To Main?",
                        IsShowPosCheckToMain: "Is Show Pos Check To Main?",
                        IsWarrantyDateToMain: "Is Warranty Date To Main?",
                        IsDescriptionToMain: "Is Description To Main?",
                        IsAveragePriceToMain: "Is Average Price To Main?",
                        IsPurchasePriceToMain: "Is Purchase Price To Main?",
                        IsSellPriceToMain: "Is Sell Price To Main?",
                        IsAMCCompanyToMain: "Is AMC Company To Main?",
                        IsDepreciationYearToMain: "Is Depreciation Year To Main?",
                        IsSupplierToMain: "Is Supplier To Main?",
                        IsModelToMain: "Is Model To Main?",
                        IsProductTypeToMain: "Is Product Type To Main?",
                        IsImageToMain: "Is Image To Main?",
                        IsSpecificationToMain: "Is Specification To Main?",
                        IsBarcodeToMain: "Is Barcode To Main?",
                        IsNameArabicToMain: "Is Name Arabic To Main?",
                        IsNameToMain: "Is Name To Main?",
                        IsProductCodeToMain: "Is Product Code To Main?",
                        Defaults: "Defaults",
                        SMS: "SMS",
                        UnlockVouchers: "Unlock Vouchers",
                        TryPOSPrint: "Try POS Print",
                        ServerApiPath: "Server Api Path",
                        ApiUrl: "Api Url",
                        BlockBillWise: "Block Bill Wise?",
                        IsSalesInventoryPosting: "Is Sales Inventory Posting?",
                        RoundOffPoints: "Round Off Points",
                        LinewiseGL: "Line Wise GL?",
                        ApprovalNeeded: "Approval Needed?",
                        IsOtpLogin: "Is Otp Login?",
                        Fashion: "Fashion",
                        Maintenance: "Maintenance",
                        Consultancy: "Consultancy",
                        Garage: "Garage",
                        Salon: "Salon",
                        Perfume: "Perfume",
                        Construction: "Construction",
                        Transportation: "Transportation",
                        FoodStuff: "Food Stuff",
                        RentACar: "Rent A Car",
                        Supermarket: "Supermarket",
                        Restaurant: "Restaurant",
                        RealEstate: "Real Estate",
                        Trading: "Trading",
                        TypeOfBusiness: "Type Of Business?",
                        SalesAccountFromProduct: "Sales Account From Product?",
                        PurchaseAccountFromProduct: "Purchase Account From Product?",
                        IsLineWiseMaturityDate: "Is Line Wise Maturity Date?",
                        IsDNStockAffect: "Is DN Stock Affect?",
                        IsGRNStockAffect: "Is GRN Stock Affect?",
                        HideBalanceCalculation: "Hide Balance Calculation?",
                        IsProductRemarksCopy: "Is Product Remarks Copy?",
                        IsAutoProductCode: "Is Auto Product Code?",
                        IsBlockMultiProductInVoucher: "Is Block Multi Product In Voucher?",
                        IsSpareParts: "Is Spare Parts?",
                        IsRentACar: "Is Rent A Car?",
                        IsRealEstate: "Is Real Estate?",
                        IsAutoBatchNo: "Is Auto Batch No?",
                        IsProductBatch: "Is Product Batch?",
                        IsPriceChart: "Is Price Chart?",
                        IsProduction: "Is Production?",
                        IsStock: "Is Stock?",
                        IsRecipe: "Is Recipe?",
                        IsAdvocate: "Is Advocate?",
                        IsBranch: "Is Branch?",
                        HideVAT: "Hide VAT?",
                        IsHR: "Is HR?",
                        NoOfPrintCopy: "No Of Print Copy",
                        PrinterName: "Printer Name",
                        NeedKOT: "Need KOT?",
                        NeedTask: "Need Task?",
                        NeedCRM: "Need CRM?",
                        NeedPOS: "Need POS?",
                        SalesReturnQ: "Sales Return?",
                        PorformaInvoiceQ: "Porforma Invoice?",
                        IndividualSalesInvoiceQ: "Individual Sales Invoice?",
                        DirectSalesInvoiceQ: "Direct Sales Invoice?",
                        ExportSalesInvoiceQ: "Export Sales Invoice?",
                        SalesInvoiceQ: "Sales Invoice?",
                        DeliveryNoteQ: "Delivery Note?",
                        PackingListQ: "Packing List?",
                        SalesOrderQ: "Sales Order?",
                        SalesQuotationQ: "Sales Quotation?",
                        SalesEnquiryQ: "Sales Enquiry?",
                        PurchaseReturnQ: "Purchase Return?",
                        PurchaseRequestQ: "Purchase Request?",
                        PurchaseEnquiryQ: "Purchase Enquiry?",
                        PurchaseQuotationQ: "Purchase Quotation?",
                        PurchaseOrderQ: "Purchase Order?",
                        GoodsReceivedQ: "Goods Received?",
                        PurchaseInvoiceQ: "Purchase Invoice?",
                        DirPurchaseInvoiceQ: "Direct Purchase Invoice?",
                        ImpPurchaseInvoiceQ: "Import Purchase Invoice?",
                        IndPurchaseInvoiceQ: "Individual Purchase Invoice?",
                        ExpPurchaseInvoiceQ: "Export Purchase Invoice?",
                        SenderNameAs: "Sender Name As",
                        EmailUsername: "Email Username",
                        EmailPassword: "Email Password",
                        IsCostCenterNameWithCode: "Is Cost Center Name With Code?",
                        LoadCustomer: "Load Customer",
                        SupplierTogether: "Supplier Together?",
                        JobwiseStartingVoucher: "Job Wise Starting Voucher",
                        VatAccountTypeCostCenterGroup: "VAT Account Type Cost Center Group",
                        TaxCategoryCostCenterGroup: "Tax Category Cost Center Group",
                        VatStateEmirateCostCenterGroup: "VAT State/Emirate Cost Center Group",
                        VatCountryCostCenterGroup: "VAT Country Cost Center Group",
                        ExpenseAccountType: "Expense Account Type",
                        VendorAccountType: "Vendor Account Type",
                        CustomerAccountType: "Customer Account Type",
                        DefaultExpenseAccountHead: "Default Expense Account Head",
                        DefaultVendorAccountHead: "Default Vendor Account Head",
                        DefaultCustomerAccountHead: "Default Customer Account Head",
                        DefaultCustomer: "Default Customer",
                        MaxUnit: "Max Unit",
                        DefaultUnitDefaultProduct: "Default Unit",
                        DefaultVATType: "Default VAT Type",
                        BankDetails: "Bank Details",
                        ResaveAll: "Resave All",
                        VoucherCount: "Voucher Count",
                        Hold: "Hold",
                        Skip: "Skip",
                        PckingCharges: "Packing Charges",
                        DeliveryCharges: "Delivery Charges",
                        DutyCharges: "Duty Charges",
                        ClearingCharges: "Clearing Charges",
                        FreightCharges: "Freight Charges",
                        Master8: "Master 8",
                        Master7: "Master 7",
                        Master6: "Master 6",
                        Master5: "Master 5",
                        Master4: "Master 4",
                        Master3: "Master 3",
                        Master2: "Master 2",
                        Master1: "Master 1",
                        Field20: "Field 20",
                        Field19: "Field 19",
                        Field18: "Field 18",
                        Field17: "Field 17",
                        Field16: "Field 16",
                        Field15: "Field 15",
                        Field14: "Field 14",
                        Field13: "Field 13",
                        Field12: "Field 12",
                        Field11: "Field 11",
                        Field9: "Field 9",
                        Field8: "Field 8",
                        Field7: "Field 7",
                        Field6: "Field 6",
                        Field5: "Field 5",
                        Field4: "Field 4",
                        Field3: "Field 3",
                        Field2: "Field 2",
                        Field1: "Field 1",
                        DiscountType: "Discount Type",
                        DiscountValue: "Discount Value",
                        QCost: "Q Cost",
                        TCost: "T Cost",
                        Cost: "Cost",
                        Manuf: "Manuf",
                        YRRef: "YR Ref",
                        TableFields: "Table Fields",
                        CustomerPO: "Customer PO",
                        SupplierPO: "Supplier PO",
                        EndLetter: "End Letter",
                        IntroLetter: "Intro Letter",
                        CreditDebit: "Credit / Debit",
                        Excel: "Excel",
                        AddressButton: "Address Button",
                        POSSales: "POS Sales",
                        SupplierNo: "Supplier No",
                        PackingCharges: "Packing Charges",
                        put: "put",
                        symboltoincreasethecolumnwidth: "symbol to increase the column width",
                        Copy: "Copy",
                        Paste: "Paste",
                        CanDelete: "Can Delete",
                        CanPrint: "Can Print",
                        CanView: "Can View",
                        CanEdit: "Can Edit",
                        CanAdd: "Can Add",
                        CanAccess: "Can Access",
                        PageGroup: "Page Group",
                        RemoveCompleteAccess: "Remove Complete Access",
                        SetCompleteAccess: "Set Complete Access",
                        MoveFirst: "Move First?",
                        VatGroup: "Vat Group?",
                        MandatoryQ: "Mandatory?",
                        VisibleQ: "Visible?",
                        VoucherType: "Voucher Type",
                        MoveToFirstSession: "Move To First Session?",
                        VoucherCostCenterSettings: "Voucher Cost Center Settings",
                        MandatoryMaster8: "Mandatory Master 8",
                        MandatoryMaster7: "Mandatory Master 7",
                        MandatoryMaster6: "Mandatory Master 6",
                        MandatoryMaster5: "Mandatory Master 5",
                        MandatoryMaster4: "Mandatory Master 4",
                        MandatoryMaster3: "Mandatory Master 3",
                        MandatoryMaster2: "Mandatory Master 2",
                        MandatoryMaster1: "Mandatory Master 1",
                        MandatoryField20: "Mandatory Field 20",
                        MandatoryField19: "Mandatory Field 19",
                        MandatoryField18: "Mandatory Field 18",
                        MandatoryField17: "Mandatory Field 17",
                        MandatoryField16: "Mandatory Field 16",
                        MandatoryField15: "Mandatory Field 15",
                        MandatoryField14: "Mandatory Field 14",
                        MandatoryField13: "Mandatory Field 13",
                        MandatoryField12: "Mandatory Field 12",
                        MandatoryField11: "Mandatory Field 11",
                        MandatoryField10: "Mandatory Field 10",
                        MandatoryField9: "Mandatory Field 9",
                        MandatoryField8: "Mandatory Field 8",
                        MandatoryField7: "Mandatory Field 7",
                        MandatoryField6: "Mandatory Field 6",
                        MandatoryField5: "Mandatory Field 5",
                        MandatoryField4: "Mandatory Field 4",
                        MandatoryField3: "Mandatory Field 3",
                        MandatoryField2: "Mandatory Field 2",
                        MandatoryField1: "Mandatory Field 1",
                        EnableField20: "Enable Field 20",
                        EnableField19: "Enable Field 19",
                        EnableField18: "Enable Field 18",
                        EnableField17: "Enable Field 17",
                        EnableField16: "Enable Field 16",
                        EnableField15: "Enable Field 15",
                        EnableField14: "Enable Field 14",
                        EnableField13: "Enable Field 13",
                        EnableField12: "Enable Field 12",
                        EnableField11: "Enable Field 11",
                        EnableField10: "Enable Field 10",
                        EnableField9: "Enable Field 9",
                        EnableField8: "Enable Field 8",
                        EnableField7: "Enable Field 7",
                        EnableField6: "Enable Field 6",
                        EnableField5: "Enable Field 5",
                        EnableField4: "Enable Field 4",
                        EnableField3: "Enable Field 3",
                        EnableField2: "Enable Field 2",
                        EnableField1: "Enable Field 1",
                        Field20NameDate: "Field 20 Name (Date)",
                        Field19NameDate: "Field 19 Name (Date)",
                        Field18NameDate: "Field 18 Name (Date)",
                        Field17NameDate: "Field 17 Name (Date)",
                        Field16NameDate: "Field 16 Name (Date)",
                        Field15NameDate: "Field 15 Name (Date)",
                        Field14NameDate: "Field 14 Name (Date)",
                        Field13NameDate: "Field 13 Name (Date)",
                        Field12NameDate: "Field 12 Name (Date)",
                        Field11NameDate: "Field 11 Name (Date)",
                        Field10NameDate: "Field 10 Name (Date)",
                        Field9NameDate: "Field 9 Name (Date)",
                        Field8NameDate: "Field 8 Name (Date)",
                        Field7NameDate: "Field 7 Name (Date)",
                        Field6NameDate: "Field 6 Name (Date)",
                        Field5NameDate: "Field 5 Name (Date)",
                        Field4NameDate: "Field 4 Name (Date)",
                        Field3NameDate: "Field 3 Name (Date)",
                        Field2NameDate: "Field 2 Name (Date)",
                        Field1NameDate: "Field 1 Name (Date)",
                        Field14NameSelect: "Field 14 Name (Select)",
                        Field15NameSelect: "Field 15 Name (Select)",
                        Field13NameSelect: "Field 13 Name (Select)",
                        Field12NameSelect: "Field 12 Name (Select)",
                        Field11NameSelect: "Field 11 Name (Select)",
                        Field10Name: "Field 10 Name",
                        Field9Name: "Field 9 Name",
                        Field8Name: "Field 8 Name",
                        Field7Name: "Field 7 Name",
                        Field6Name: "Field 6 Name",
                        Field5Name: "Field 5 Name",
                        Field4Name: "Field 4 Name",
                        Field3Name: "Field 3 Name",
                        Field2Name: "Field 2 Name",
                        Field1Name: "Field 1 Name",
                        EnableMoreBodyFields: "Enable More Body Fields",
                        Master5ToMainScreen: "Master 5 To Main Screen",
                        Master4ToMainScreen: "Master 4 To Main Screen",
                        Master3ToMainScreen: "Master 3 To Main Screen",
                        Master2ToMainScreen: "Master 2 To Main Screen",
                        Master1ToMainScreen: "Master 1 To Main Screen",
                        Field20ToMainScreen: "Field 20 To Main Screen",
                        Field19ToMainScreen: "Field 19 To Main Screen",
                        Field18ToMainScreen: "Field 18 To Main Screen",

                        Field17ToMainScreen: "Field 17 To Main Screen",
                        Field16ToMainScreen: "Field 16 To Main Screen",
                        Field15ToMainScreen: "Field 15 To Main Screen",
                        Field14ToMainScreen: "Field 14 To Main Screen",
                        Field13ToMainScreen: "Field 13 To Main Screen",
                        Field12ToMainScreen: "Field 12 To Main Screen",
                        Field11ToMainScreen: "Field 11 To Main Screen",
                        Field10ToMainScreen: "Field 10 To Main Screen",
                        Field9ToMainScreen: "Field 9 To Main Screen",
                        Field8ToMainScreen: "Field 8 To Main Screen",
                        Field7ToMainScreen: "Field 7 To Main Screen",
                        Field6ToMainScreen: "Field 6 To Main Screen",
                        Field5ToMainScreen: "Field 5 To Main Screen",
                        Field4ToMainScreen: "Field 4 To Main Screen",
                        Field3ToMainScreen: "Field 3 To Main Screen",
                        Field2ToMainScreen: "Field 2 To Main Screen",
                        Field1ToMainScreen: "Field 1 To Main Screen",
                        EnableMoreFields: "Enable More Fields",
                        EnableFocQuantity: "Enable FOC Quantity",
                        EnableTotalGrossWeight: "Enable Total Gross Weight",
                        EnableTotalNetWeight: "Enable Total Net Weight",
                        EnableGrossWeight: "Enable Gross Weight",
                        EnableNetWeight: "Enable Net Weight",
                        EnableProductWeightFields: "Enable Product Weight Fields",
                        EnableCalculationWithVAT: "Enable Calculation With VAT",
                        CustomsDutyCharges: "Customs Duty Charges",
                        EnableDirectAccountPosting: "Enable Direct Account Posting",
                        PackingChargesPI: "Packing Charges (PI)",
                        DeliveryChargesIPI: "Delivery Charges (IPI)",
                        DutyChargesIPI: "Duty Charges (IPI)",
                        ClearingChargesIPI: "Clearing Charges (IPI)",
                        FreightChargesPIIPI: "Freight Charges (PI &amp; IPI)",
                        PurchaseInvoiceImprotPurchaseInvoiceOnly: "Purchase Invoice / Improt Purchase Invoice Only",
                        ApplyShippingFormula: "Apply Shipping Formula",
                        UnlockDiscount: "Unlock Discount",
                        BonusLabel: "Bonus Label",
                        QCostLabel: "Q Cost Label",
                        TCostLabel: "T Cost Label",
                        StockLabel: "Stock Label",
                        ManufLabel: "Manuf Label",
                        YrRefLabel: "YR Ref Label",
                        Stockselect: "Stock (select)",
                        ManufNoselect: "Manuf No (select)",
                        YrRefText: "YR Ref (Text)",
                        EnableTableFields: "Enable Table Fields",
                        SupplierPONoToMainScreen: "Supplier PO No To Main Screen",
                        CustomerPONoToMainScreen: "Customer PO No To Main Screen",
                        SalesEmployeeToMainScreen: "Sales Employee To Main Screen",
                        SupplierBillDateToMainScreen: "Supplier Bill Date To Main Screen",

                        ReturnTimeToMainScreen: "Return Time To Main Screen",
                        ReturnDateToMainScreen: "Return Date To Main Screen",
                        DeliveryTimeToMainScreen: "Delivery Time To Main Screen",
                        DeliveryDateToMainScreen: "Delivery Date To Main Screen",
                        PaymentTermsToMainScreen: "Payment Terms To Main Screen",
                        WarrentyPeriodToMainScreen: "Warrenty Period To Main Screen",
                        DelieveryPeriodToMainScreen: "Delievery Period To Main Screen",
                        DeliveryBasisToMainScreen: "Delivery Basis To Main Screen",
                        WarrentyPeriod: "Warrenty Period",
                        OrderNoToMainScreen: "Order No To Main Screen",
                        EnquiryNoToMainScreen: "Enquiry No To Main Screen",
                        NetWeightToMainScreen: "Net Weight To Main Screen",
                        GrossWeightToMainScreen: "Gross Weight To Main Screen",
                        WeightToMainScreen: "Weight To Main Screen",
                        NoOfPackagesToMainScreen: "No Of Packages To Main Screen",
                        SupplierQtnNoToMainScreen: "Supplier Qtn No To Main Screen",
                        SupplierBillNoToMainScreen: "Supplier Bill No To Main Screen",
                        ShippingAddressToMainScreen: "Shipping Address To Main Screen",
                        PlaceOfSupplyToMainScreen: "Place Of Supply To Main Screen",
                        ConcernPersonToMainScreen: "Concern Person To Main Screen",
                        ValidityToMainScreen: "Validity To Main Screen",
                        IntroLetterToMainScreen: "Intro Letter To Main Screen",
                        EndLetterToMainScreen: "End Letter To Main Screen",
                        EnableHeaderFields: "Enable Header Fields",
                        CustomerMapQ: "Customer Map?",
                        QcostLink: "Q cost Link",
                        EnableQ: "Enable?",
                        IsMultipleQ: "Is Multiple?",
                        LinkName: "Link Name",
                        IsCustomerMap: "Is Customer Map",
                        VoucherLink: "Voucher Link",
                        VoucherLinkSettings: "Voucher Link Settings",
                        SalesReturnName: "Sales Return Name",
                        IndividualSalesInvoiceName: "Individual Sales Invoice Name",
                        ProformaInvoiceName: "Proforma Invoice Name",
                        ExportSalesInvoiceName: "Export Sales Invoice Name",
                        DirectSalesInvoiceName: "Direct Sales Invoice Name",
                        SalesInvoiceName: "Sales Invoice  Name",
                        DeliveryNoteName: "Delivery Note  Name",
                        PackingListName: "Packing List Name",
                        SalesOrderName: "Sales Order Name",
                        SalesQuotationName: "Sales Quotation Name",
                        SalesEnquiryName: "Sales Enquiry Name",
                        PurchaseReturnName: "Purchase Return Name",
                        IndividualPurchaseInvoiceName: "Individual Purchase Invoice Name",
                        ImportPurchaseInvoiceName: "Import Purchase Invoice Name",
                        ExportPurchaseInvoiceName: "Export Purchase Invoice Name",
                        DirectPurchaseInvoiceName: "Direct Purchase Invoice Name",
                        PurchaseInvoiceName: "Purchase Invoice Name",
                        GoodsReceivedName: "Goods Received Name",
                        PurchaseOrderName: "Purchase Order Name",
                        PurchaseQuotationName: "Purchase Quotation Name",
                        PurchaseRequestName: "Purchase Request Name",
                        DownloadFile: "Download File",
                        IsField5N: "Is Field 5 -ve",
                        IsField4N: "Is Field 4 -ve",
                        IsField3N: "Is Field 3 -ve",
                        IsField2N: "Is Field 2 -ve",
                        IsField1N: "Is Field 1 -ve",
                        Field5Account: "Field 5 Account",
                        Field4Account: "Field 4 Account",
                        Field3Account: "Field 3 Account",
                        Field2Account: "Field 2 Account",
                        Field1Account: "Field 1 Account",
                        StockProduction: "Stock Production",
                        DiscountAccount: "Discount Account",
                        Net: "Net",
                        Stock: "Stock",
                        DiscountPostingType: "Discount Posting Type",
                        EnableDiscountPosting: "Enable Discount Posting",
                        DiscountPosting: "Discount Posting",
                        DefaultProduct: "Default Product",
                        DistributionType: "Distribution Type",
                        EnableCostPostingQ: "Enable Cost Posting?",
                        EnableInventoryPostingQ: "Enable Inventory Posting?",
                        EnableAccountPostingQ: "Enable Account Posting?",
                        BlockNegativeStockQ: "Block Negative Stock?",
                        AllowZeroProductPriceQ: "Allow Zero Product Price?",
                        ExtraChargesReversalAccount: "Extra Charges Reversal Account",
                        ExtraChargesAccount: "Extra Charges Account",
                        PackingChargesAccount: "Packing Charges Account",
                        OtherChargesAccount: "Other Charges Account",
                        FreightChargesAccount: "Freight Charges Account",
                        DeliveryChargesAccount: "Delivery Charges Account",
                        CustomsDutyAccount: "Customs Duty Account",
                        ClearingChargesAccount: "Clearing Charges Account",
                        CostcenterAuto: "Cost Center (Auto)",
                        COGSExpenseAccount: "COGS / Expense Account",

                        InventoryAccount: "Inventory Account",
                        OutputVATAccount: "Output VAT Account",
                        InputVATAccount: "Input VAT Account",
                        VoucherAccountSettings: "Voucher Account Settings",
                        ApplyLeave: "Apply Leave",
                        AssignedLeaves: "Assigned Leaves",
                        AvailableLeaves: "Available Leaves",
                        TotalDays: "Total Days",
                        Component: "Component",
                        Month: "Month",
                        Year: "Year",
                        Deductions: "Deductions",
                        Earnings: "Earnings",
                        OtherDeduction: "Other Deduction",
                        TelephoneDeduction: "Telephone Deduction",
                        Salik: "Salik",
                        Fines: "Fines",
                        SalaryAdvance: "Salary Advance",
                        AirFare: "Air Fare",
                        Arrears: "Arrears",
                        Transport: "Transport",
                        Food: "Food",
                        HRA: "HRA",
                        UploadFile: "Upload File",
                        EmployeeLeaveLedger: "Employee Leave Ledger",
                        Leaves: "Leaves",
                        LeaveAllocation: "Leave Allocation",
                        Loans: "Loans",
                        TotalFine: "Total Fine",
                        Fine: "Fine",
                        Cost: "Cost",
                        TotalWorking: "Total Working",
                        TotalOverTime: "Total Over Time",
                        TotalHours: "Total Hours",
                        Approved: "Approved",
                        Rejected: "Rejected",
                        UpdateResignationStaus: "Update Resignation Staus",
                        ApprovedEndDate: "Approved End Date",
                        ApprovedStartDate: "Approved Start Date",
                        UpdateVacationStaus: "Update Vacation Staus",
                        Response: "Response",
                        UpdateWarning: "Update Warning",
                        Exchange: "Exchange",

                        NetworkError: "Network Error",
                        YouDontHaveAccessToDeleteData: "You Dont Have Access To Delete Data, Please Contact Admin",
                        YouDontHaveAccessToViewData: "You Dont Have Access To View Data, Please Contact Admin",
                        YouDontHaveAccessToEditData: "You Dont Have Access To Edit Data, Please Contact Admin",
                        YouDontHaveAccessToAddData: "You Dont Have Access To Add Data, Please Contact Admin",
                        InvalidDetails: "Invalid Details",
                        SelectAccount: "Select Account",
                        CostCenterNotSelectedFor: "Cost Center Not Selected For :",
                        NetworkErrorWhileLoadingAccountSettings: "Network Error While Loading Account Settings",
                        AccountNotFound: "Account Not Found",
                        EnterDetails: "Enter Details",
                        AmountexeedingValueswillreset: "Amount exeeding, Values will reset",
                        ErrorLoadingBills: "Error Loading Bills",
                        SelectCustomerCity: "Select Customer City",
                        EnterCustomerMobileNo: "Enter Customer Mobile No",
                        EnterCustomerName: "Enter Customer Name",
                        SelectLeadSource: "Select Lead Source",
                        SelectLeadType: "Select Lead Type",
                        SelectEmployee: "Select Employee",
                        EntertheName: "Enter the Name",
                        PlannedMeetingDate: "Planned Meeting Date",
                        RefNo: "Ref No",
                        TopVendorsByPurchase: "Top Vendors By Purchase",
                        MostPurchasingItems: "Most Purchasing Items",
                        MonthlyPurchase: "Monthly Purchase",
                        MostPurchasingGroups: "Most Purchasing Groups",
                        SalesPurchaseAnalysis: "Sales / Purchase Analysis",
                        MostSellingGroups: "Most Selling Groups",
                        MonthlySales: "Monthly Sales",
                        MostSellingItems: "Most Selling Items",
                        TopCustomersBySale: "Top Customers By Sale",
                        ActiveUnitsSummary: "Active Units Summary",
                        VacantUnitsSummary: "Vacant Units Summary",
                        MostSellingUnitTypes: "Most Selling Unit Types",
                        BuildingUnitOverview: "Building - Unit Overview",
                        EnterFileName: "Enter File Name",
                        SelectFile: "Select File",
                        UploadError: "Upload Error",
                        FileUploaded: "File Uploaded",
                        FileUploadingPleaseWait: "File Uploading Please Wait",
                        EntertheGrade: "Enter the Grade",
                        Error: "Error",
                        Success: "Success",
                        DataExist: "Data Exist!",
                        EntertheBankName: "Enter the Bank Name",
                        SelectBankAccountNumber: "Select Bank Account Number",
                        Deleted: "Deleted",
                        EnterSubject: "Enter Subject",
                        EnterRemarks: "Enter Remarks",
                        SelectLeaveType: "Select Leave Type",
                        EnterStartDate: "Enter Start Date",
                        EnterEndDate: "Enter End Date",
                        CannotEditWhileInProcess: "Cannot Edit While In Process",
                        CannotDeleteWhileInProcess: "Cannot Delete While In Process",
                        ApprovedDays: "Approved Days",
                        EntertheStartDate: "Enter the Start Date",
                        EnterTotalDays: "Enter Total Days",
                        Failed: "Failed",
                        EnterReason: "Enter Reason",
                        EnterResignationDate: "Enter Resignation Date",
                        EnterLeaves: "Enter Leaves",
                        SelectLeaveType: "Select Leave Type",
                        SelectGrade: "Select Grade",
                        Assigned: "Assigned",
                        Applied: "Applied",
                        EntertheAmount: "Enter the Amount",
                        EnterFineType: "Enter Fine Type",
                        FileUploadingPleaseWait: "File Uploading Please Wait",
                        SelectAttachmentType: "Select Attachment Type",
                        EntertheDocNo: "Enter the Doc No",
                        AddPercentage: "Add Percentage",
                        AddBasicSalary: "Add Basic Salary",
                        AddNetSalary: "Add Net Salary",
                        EnterDescription: "Enter Description",
                        SelectYear: "Select Year",
                        SelectMonth: "Select Month",
                        AvailableLeavesLessThanRequested: "Available Leaves Less Than Requested",
                        InvalidDates: "Invalid Dates",

                        CreditGrandTotal: "Credit Grand Total",
                        DebitGrandTotal: "Debit Grand Total",
                        POSReports: "POS Reports",
                        POSSalesSummary: "POS Sales Summary",
                        CreditNoteSR: "Credit Note SR",
                        CreditNoteSRReport: "Credit Note SR Report",
                        ProductWiseDirSalesReport: "Product Wise Direct Sales Report",
                        ProductWiseIndSalesReport: "Product Wise Individual Sales Report",
                        ProductWiseExpSalesReport: "Product Wise Export Sales Report",
                        ProductWiseProSalesReport: "Product Wise Proforma Sales Report",
                        ProductWiseIndPurchaseReport: "Product Wise Individual Purchase Report",
                        ProductWiseImpPurchaseReport: "Product Wise Import Purchase Report",
                        ProductWiseDirPurchaseReport: "Product Wise Direct Purchase Report",

                        CustomerWiseDirSalesReport: "Customer Wise Direct Sales Report",
                        CustomerWiseIndSalesReport: "Customer Wise Individual Sales Report",
                        CustomerWiseExpSalesReport: "Customer Wise Export Sales Report",
                        CustomerWiseProSalesReport: "Customer Wise Proforma Sales Report",
                        VendorWiseDirPurchaseReport: "Vendor Wise Direct Purchase Report",
                        VendorWiseImpPurchaseReport: "Vendor Wise Import Purchase Report",
                        VendorWiseIndPurchaseReport: "Vendor Wise Individual Purchase Report",
                        OtherSalesReports: "Other Sales Reports",

                        PurchaseEnquiryName: "Purchase Enquiry Name",






                    }

                    return languageData;

                }

            };



            //            this.init();
        }
    ])
